<template>
  <div ref="parentContainer" class="table-wrapper">
    <!-- searchModel:{{ searchModel }} pipeline :{{ this.data_object.pipeline }} -->
    <!-- filterItems:{{ filterItems }} -->
    <!-- <v-form-component/> -->
    <v-navigation-drawer style="width:50%" v-model="searchDrawer" absolute temporary>
      <h2>Advanced Search</h2>

      <v-tabs class="main-tabs mb-6" v-if="searchTabs && searchTabs.length" v-model="searchTab">
        <template v-for="(value, i) in searchTabs">
          <v-tab :key="i">
            {{ value["tabName"] }}
          </v-tab>
        </template>
      </v-tabs>
      <v-list style="height:85%; overflow:auto" v-if="hasAdvancedSearch" :key="searchModelKey">
        <v-list-item
          v-for="(h, i) in computedHeaders.filter(c => {
            return c.show && hasFilter({ name: c.value });
          })"
          :key="i"
        >
          <v-row>
            <v-col class="ma-2">
              <label>{{ capitalize(h.text) }}:</label>
            </v-col>

            <v-col>
              <v-form :key="searchFormKey" ref="searchForm">
                <!-- {{ getSchema({ name: h.value })[h.value] }} -->
                <!-- searchModel:{{ searchModel }} -->
                <v-form-component
                  :ref="h.value"
                  :name="h.value"
                  :label="h.text"
                  :schema="getSchema({ name: h.value })"
                  :k="h.value"
                  :model="searchModel"
                  :hasParent="hasParent"
                  :noEditForm="true"
                ></v-form-component>
              </v-form>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
      <hr />

      <v-btn
        class="ma-2"
        text
        color="info"
        @click="
          searchDrawer = false;
          doSearch();
        "
        ><v-icon class="ma-2">mdi-database-search</v-icon>Search</v-btn
      >
      <v-btn class="ma-2" text color="info" @click="resetSearchForm()"
        ><v-icon class="ma-2">mdi-filter-off</v-icon>Reset</v-btn
      >
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="sidePanelOpen"
      class="side-panel-drawer elevation-5"
      absolute
      right
      style="width:50%; "
    >
      <div class="pa-3">
        <div class="side-panel">
          <v-menu-button
            :title="$vuetify.breakpoint.mdAndUp ? addButtonCaption : ''"
            v-bind="getAddButton()"
            :apply="applyRow"
            :reset="resetNewRow"
            :menuOpen="menuOpen"
            icon="mdi-plus-circle"
            :modal="true"
            :text="true"
            color="info"
            :menuItemClick="addRowFromButton"
            :hasSearch="true"
            :getItems="getItems"
            :menuItems="menuItems"
            v-if="addMenuButton && !edited && !readonly && (!noAddOnAllTab || (noAddOnAllTab && currentFilter))"
            :formModel="formModel"
            :editableFields="getEditableFields()"
            :table="this"
            :key="menuButtonKey"
            :capitalizeText="true"
          ></v-menu-button>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- {{ propertyList }} -->
    <!-- assistantQry: {{ assistantQry }}
    <br />
    convertAssistantQry:  -->
    <!-- {{ convertAssistantQry() }} -->
    <!-- {{ table }} -->
    <div hidden>
      <v-take-photo></v-take-photo>
    </div>

    <h3 v-if="!hideTitle">{{ table_title || tableHeader }}</h3>
    <!-- expanded:{{ expanded }} -->
    <!-- defaultModel:{{ defaultModel }} -->

    <v-tabs
      v-if="filterItems.length && filterItems.length > 1 && !noTabs && useTabs"
      v-show="!hideFilterTabs"
      v-model="currentFilter"
      class="mt-2 filter-tabs"
      active-class="active-tab"
      continuous
      grow
      show-arrows
      :key="tabKey"
    >
      <v-tab v-for="item in filteredTabItems" :key="item.caption">
        <span :style="{ borderRadius: '4px' }">
          {{ item.caption }}
        </span>
      </v-tab>
    </v-tabs>

    <!-- <v-toolbar v-if="groupByItemTabs.length" flat
      ><h4>Group By {{ capitalize(groupByItemTabs[0].item) }}</h4>
      <v-btn @click="clearGroupBy" icon><v-icon>mdi-close</v-icon></v-btn></v-toolbar
    > -->

    <div style="position:relative" :class="{ 'full-screen': isFullScreen }">
      <!-- </v-toolbar> -->
      <!-- <v-label v-if="hideTopBar && table_title">
        {{ table_title }}
      </v-label> -->
      <div class="top-bar">
        <v-component
          :is="$vuetify.breakpoint.smAndDown ? 'div' : 'v-toolbar'"
          v-if="!edited && getTotal && !data_object.hideTotal"
          :class="{
            'ml-n0 mr-n0 mb-4': $vuetify.breakpoint.smAndDown,
            'ml-0 mb-0 mr-0': $vuetify.breakpoint.mdAndUp
          }"
          flat
        >
          <v-spacer v-if="(!edited && !dList && !hideTitle && table_title) || table_title"></v-spacer>

          <v-spacer v-if="!edited && filterItems && filterItems.length && showFilterCombo"></v-spacer>

          <v-spacer v-if="!edited && getTotal && !data_object.hideTotal && !dExcel"></v-spacer>
          <v-chip class="mt-n2" ref="total" v-if="!edited && getTotal && !data_object.hideTotal" elevation-4>
            {{ !totals ? "" : totals.total.text }}
          </v-chip>
        </v-component>

        <!-- class="header-toolbar ml-0 mt-2 mb-2 pa-2" -->

        <v-toolbar
          v-if="(!hideTopBar || !noDelete || addButtonCaption) && !hideControls"
          :key="toolbarKey"
          flat
          class="table-toolbar"
        >
          <v-tooltip v-if="!edited && !noDelete && selectDelete" top>
            <template v-slot:activator="{ on }">
              <v-btn
                :class="dExcel ? `ml-2` : `ml-2`"
                icon
                v-on="on"
                :disabled="!selected.length"
                @click="deleteSelected"
              >
                <v-icon color="error">mdi-delete-sweep</v-icon>
              </v-btn>
            </template>
            <span>Delete Selected</span>
          </v-tooltip>

          <v-btn
            v-if="!edited && !noDelete && !readonly && tableReady && table.length"
            :key="delBtnKey"
            class="ml-2"
            icon
            v-on="on"
            @click="
              selectDelete = !selectDelete;
              selected = [];
            "
          >
            <v-icon v-if="!selectDelete" color="error">mdi-minus-circle</v-icon>

            <v-icon v-if="selectDelete">mdi-cancel</v-icon>
          </v-btn>

          <v-btn
            class="ma-0"
            v-if="addButtonCaption && !tableInsertable && !edited && !readonly && !addMenuButton"
            color="info"
            @click="editCurrentRecord()"
            text
          >
            <v-icon class="ma-2">mdi-plus-circle</v-icon>

            <span v-if="$vuetify.breakpoint.lgAndUp">
              {{ addButtonCaption }}
            </span>
          </v-btn>
          <v-btn v-if="tableInsertable && !addMenuButton" class="ma-1" v-on="on" text color="info" @click="addRow()">
            <v-icon class="ma-2">mdi-plus-circle</v-icon>
            <div v-if="$vuetify.breakpoint.lgAndUp">{{ addButtonCaption || "Add Record" }}</div>
          </v-btn>
          <v-btn
            v-if="addMenuButton && !edited && !readonly && (!noAddOnAllTab || (noAddOnAllTab && currentFilter))"
            color="success"
            text
            small
            @click="sidePanelOpen = !sidePanelOpen"
          >
            <v-icon>mdi-plus-circle</v-icon>
            <div v-if="$vuetify.breakpoint.lgAndUp">{{ addButtonCaption }}</div>
          </v-btn>
          <div v-if="noAddOnAllTab && !currentFilter">Please {{ filterComboLabel }} to Add Record</div>
          <v-spacer></v-spacer>

          <v-menu
            v-if="
              !this.edited &&
                ((hasSearch && table.length) ||
                  search ||
                  remoteSearch ||
                  (searchModel && Object.keys(searchModel) && Object.keys(searchModel).length))
            "
            v-model="searchMenuModel"
            :close-on-content-click="false"
            offset-y
            :key="searchMenuKey"
          >
            <template v-slot:activator="{}">
              <v-text-field
                hide-details
                prepend-inner-icon="mdi-magnify"
                :append-icon="
                  hasAdvancedSearch && !searchReset
                    ? 'mdi-clipboard-text-search'
                    : searchAfterCompleted && search && !searchModel
                    ? 'mdi-account-search'
                    : hasAdvancedSearch && searchReset
                    ? 'mdi-close'
                    : ''
                "
                label="Search"
                clearable
                v-model="search"
                @keydown.enter="searchAfterCompleted ? doSearch() : (searchMenuModel = !searchMenuModel)"
                @click:append="showSearchDrawer()"
              ></v-text-field>
            </template>
            <v-toolbar flat>
              <h2 class="d-flex justify-center">Advanced Filter/Search</h2>
            </v-toolbar>

            <v-toolbar>
              <v-btn text @click="clearSearch()">Clear Filter</v-btn>
              <v-spacer></v-spacer>
              <v-menu v-model="saveFilterMenu" :close-on-content-click="false" offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="ma-2" color="info">
                    Save Filter
                  </v-btn>
                </template>
                <v-toolbar>
                  <v-text-field label="Filter Name" v-model="filterName"></v-text-field>
                  <v-btn class="ma-2" text color="info" @click="saveFilter()">
                    Save Filter
                  </v-btn>
                </v-toolbar>
              </v-menu>
            </v-toolbar>
          </v-menu>
          <v-btn
            v-if="assistant && assistant.hasAssistant && !noCustomQry && !$root.customerId"
            text
            @click="buildCustomQueryPrompt"
            ><v-icon> mdi-database-search </v-icon>
            <v-span v-if="$vuetify.breakpoint.mdAndUp">{{ assistant.assistantTitle }}</v-span>
          </v-btn>
          <v-btn v-if="hasAssistant && assistantQry" text @click="resetAssistantQry"
            ><v-icon> mdi-close </v-icon>
            <v-span v-if="$vuetify.breakpoint.mdAndUp">Reset Custom Search</v-span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar v-if="edited" class="bottomToolBar mt-4" flat>
            <v-spacer></v-spacer>
            <div class="edit-bar" flat v-if="!childEdited && edited">
              <v-spacer></v-spacer>

              <v-btn text @click="cancelEdit">
                <v-icon class="ma-2">mdi-cancel</v-icon><span v-if="$vuetify.breakpoint.mdAndUp">Cancel Edit</span>
              </v-btn>
              <v-fab-transition>
                <v-btn
                  :text="$vuetify.breakpoint.smAndDown"
                  v-if="!disableSave"
                  color="success"
                  @click="validateAndSave()"
                  right
                >
                  <v-icon class="ma-2">mdi-check-circle</v-icon>
                  <span v-if="$vuetify.breakpoint.mdAndUp"> {{ saveButtonCaption || "Save" }}</span>
                </v-btn></v-fab-transition
              >
              <v-menu v-model="copyMenu" :close-on-content-click="false" :nudge-width="200" v-if="copyRecords" offset-x>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn text small v-on="on">
                    <v-icon>mdi-content-copy</v-icon>
                    Duplicate
                  </v-btn>
                </template>
                <v-card class="pa-2">
                  <h3>Copy {{ dObject.model[copyRecords.field_name] }}</h3>
                  <br />
                  <v-label> New {{ copyRecords.field_name }} separated by comma: </v-label>
                  <v-textarea v-model="duplicateValues"></v-textarea>
                  <v-btn @click="duplicate()" color="info">Submit</v-btn>
                </v-card>
              </v-menu>
              <!-- <v-btn
            small
            right
            text
            class="text-right ma-2"
            color="success"
            v-if="isEditedNew"
            @click="validateAndSave(true)"
          >
            Save and New
          </v-btn> -->
              <v-alert dismissible dense v-if="errorMessage != '' && errorMessage" type="error">
                {{ errorMessage }}
              </v-alert>
            </div>
          </v-toolbar>

          <v-btn v-if="expandable" text small @click="expandAll()">
            <v-icon v-if="!allTableExpanded" class="ma-2">mdi-expand-all</v-icon>
            <v-icon v-else class="ma-2">mdi-collapse-all</v-icon>
          </v-btn>

          <v-autocomplete
            clearable
            v-if="
              !edited &&
                (hasSearch || (filteredTabItems.length && filteredTabItems.length > 1 && !noTabs)) &&
                !useTabs & !$root.isMobile &&
                filteredTabItems.length &&
                filteredTabItems.length > 1 &&
                !noTabs
            "
            class="mt-5 pa-2"
            :items="filteredTabItems"
            item-text="caption"
            item-value="value"
            @change="applyFilter"
            @keydown="applyFilterOnEnter"
            :label="filterComboLabel || 'Filter'"
          ></v-autocomplete>

          <v-autocomplete
            v-if="
              assistant &&
                assistant.hasAssistant &&
                additionalModel &&
                additionalModel.custom_qry &&
                additionalModel.custom_qry.length &&
                !noCustomQry
            "
            clearable
            class="mt-5 pa-2"
            :items="additionalModel.custom_qry"
            item-text="caption"
            item-value="_id"
            @change="applyCustomQry"
            label="Custom Query"
          >
            <template v-slot:item="{ item }">
              <!-- <v-list>
                <v-list-item
                  v-for="(item, index) in additionalModel.custom_qry"
                  :key="item._id"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ item.caption }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action> -->
              {{ item.caption }}
              <v-btn icon @click="deleteCustomQry(item, index)">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
              <!-- </v-list-item-action>
                </v-list-item>
              </v-list> -->
            </template>
          </v-autocomplete>

          <!-- (!noAddOnAllTab || (noAddOnAllTab && currentFilter)) && -->
          <v-toolbar
            class="table-toolbar mt-2"
            flat
            v-if="tableInsertable && !edited && !readonly && table.length && table[0]._id == newRowId"
          >
            <v-btn v-if="table.length && table[0]._id == newRowId" class="ma-1" icon>
              <v-icon color="success" @click="applyRow()">
                mdi-checkbox-marked-circle
              </v-icon>
            </v-btn>

            <v-btn v-if="table.length && table[0]._id == newRowId" icon color="warning" class="ma-1">
              <v-icon @click="resetNewRow()">mdi-cancel</v-icon>
            </v-btn>
          </v-toolbar>

          <v-spacer> </v-spacer>

          <v-btn v-if="showAdvancedSearch" class="ma-1" small text @click="showAdvancedSearch = !showAdvancedSearch">
            <v-icon color="info">mdi-filter-remove</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <a target="_blank" :href="xllink" v-if="xllink">Download Excel</a>

          <div
            class="d-flex flex-wrap align-center"
            :key="toolBarKey"
            v-if="!edited && !dExcel && toolBarControls && !hideControls && !noToolBar && tableReady && !readonly"
            flat
          >
            <v-spacer v-if="toolbarRight && $vuetify.breakpoint.mdAndUp"></v-spacer>
            <div class="d-flex  flex-wrap align-top">
              <div
                v-for="(c, i) in (safeToolBarControls || []).filter(t => {
                  return $root.customerId ? t['v-bind'] && !t['v-bind'].noCustomer : !t.hidden;
                })"
                :key="i"
              >
                <div :class="$vuetify.breakpoint.smAndDown ? 'mt-n4' : 'mt-4'">
                  <v-btn
                    :ref="c[`id`]"
                    :small="true"
                    :color="c['v-bind'].color"
                    :text="c['v-bind'].text"
                    :class="[c['v-bind'].class]"
                    v-if="
                      c.default &&
                        c['v-bind'] &&
                        c[`comp`] == 'v-btn' &&
                        !c['v-bind'].hidden &&
                        !c.hidden &&
                        !hideCtl(c)
                    "
                    @click="customBtnClick(c)"
                    :loading="customBtnLoading"
                  >
                    <v-icon
                      :class="$vuetify.breakpoint.smAndDown ? 'ma-0' : 'ma-2'"
                      v-if="c['v-bind'] && c['v-bind'].icon"
                    >
                      {{ c["v-bind"].icon }}
                    </v-icon>
                    {{ c["v-bind"]["input-value"] }}
                  </v-btn>

                  <component
                    v-else-if="c.default && !edited && c['v-bind'] && !c['v-bind'].hidden && !hideCtl(c)"
                    @click="customBtnClick(c)"
                    @input="customCtlOnInput(c, $event)"
                    @select="customCtlOnInput(c, $event)"
                    @keydown.enter.prevent="customCtlOnInput(c, $event)"
                    :hidden="c.hidden"
                    small
                    :is="c[`comp`]"
                    :ref="c[`id`]"
                    :id="c[`id`]"
                    :table="getObject()"
                    :style="'width:' + c[`v-bind`].width"
                    v-bind="c[`v-bind`]"
                  >
                    {{ c.value }}
                  </component>
                </div>
              </div>
            </div>
          </div>

          <v-tooltip v-if="!noRefreshButton && getFreshData && !edited && tableReady" top>
            <template v-slot:activator="{ on }">
              <v-btn class="ma-1" small v-on="on" @click="refreshParent ? refreshParent() : refreshTable()" text>
                <v-icon :class="$vuetify.breakpoint.smAndDown ? 'ma-0' : 'ma-2'">
                  mdi-reload
                </v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>
          <v-autocomplete
            class="mt-5 pa-2"
            v-if="groupByItemsReady && serverPagination"
            label="Group By"
            :clearable="true"
            :items="captializedGroupByItems()"
            @change="applyGroupBy"
          ></v-autocomplete>
          <v-spacer v-if="!$root.isMobile"></v-spacer>

          <v-pager
            :key="pagerKey"
            v-if="
              !$root.isMobile && !edited && tableReady && !hideFooter && !editDisablePagination && !disablePagination
            "
            :pageStart="pageStart"
            :pageStop="itemsCount > pageStop ? pageStop : itemsCount"
            :itemsLength="itemsCount"
            :navigate="navigate"
            :page="page"
          ></v-pager>

          <v-menu
            v-model="menuModel"
            v-if="!edited && !noAdditionalMenu"
            :close-on-content-click="false"
            :close-on-click="closeMenuOnClick"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ma-1" icon small v-bind="attrs" v-on="on">
                <v-icon class="ma-2">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-toolbar class="mb-n2" flat>
              <v-spacer></v-spacer>
              <v-btnright icon @click="menuModel = false">
                <v-icon small>mdi-close</v-icon>
              </v-btnright>
            </v-toolbar>

            <v-list class="mt-n4">
              <!-- <v-list-item v-if="groupByItemsReady">


                <v-autocomplete
                  label="Group By"
                  :clearable="true"
                  :items="captializedGroupByItems()"
                  @change="applyGroupBy"
                ></v-autocomplete>
              </v-list-item> -->
              <v-list-item v-if="dExcel">
                <v-btn icon v-on="on" right @click="submit">
                  <v-icon>mdi-content-save</v-icon>
                  Save Table
                </v-btn>
              </v-list-item>

              <v-list-item>
                <v-btn :loading="loading" text small @click="downloadExcel(table)">
                  <v-icon class="ma-2">mdi-file-excel</v-icon>
                  Download Excel
                </v-btn>
              </v-list-item>

              <v-list-item v-if="hasUpload && tableReady">
                <v-btn :loading="loading" text small v-on="on" @click="uploadExcel()">
                  <v-icon class="ma-2">mdi-auto-upload</v-icon>
                  Upload Excel
                </v-btn>
              </v-list-item>
              <v-list-item v-if="$vuetify.breakpoint.smAndDown">
                <v-btn small @click="toggleBreakpoint()" text>
                  <v-icon v-if="breakpoint && breakpoint != '0'" class="ma-2">
                    mdi-table-large
                  </v-icon>
                  <v-icon class="ma-2" v-else>mdi-view-list</v-icon>
                  {{ breakpoint ? "View Table" : "View List" }}
                </v-btn>
              </v-list-item>
              <!-- && !serverPagination" -->
              <v-list-item v-if="tableReady && !hideFooter && table.length > 10">
                <v-btn v-on="on" text small @click="doDisablePagination">
                  <v-icon class="ma-2">mdi-select-all</v-icon>
                  {{ editDisablePagination ? "Enable Pagination" : "Disable Pagination" }}
                </v-btn>
              </v-list-item>

              <v-list-item v-if="columnTool && tableReady && !$root.customerId">
                <v-menu v-if="columnTool && tableReady && !$root.customerId" :close-on-content-click="false" offset-y>
                  <template v-slot:activator="{ on: onMenu, attrs }">
                    <v-btn small v-bind="attrs" v-on="{ ...onMenu }" text>
                      <v-icon class="ma-2">mdi-view-column</v-icon>
                      Choose Columns
                    </v-btn>
                  </template>
                  <v-list class="column-list">
                    <draggable style="width: 100%" :list="computedHeaders">
                      <v-list-item
                        class="pointer"
                        v-for="(item, index) in (computedHeaders || []).filter(c => {
                          return c.value != 'actions';
                        })"
                        :key="index"
                      >
                        <!-- {{ item }} -->
                        <v-list-item-title>{{ item.text }}</v-list-item-title>

                        <v-switch v-model="item.show"></v-switch>
                      </v-list-item>
                    </draggable>
                  </v-list>
                  <v-toolbar>
                    <v-btn @click="saveColumns()" text style="top" color="info">
                      Save Columns
                    </v-btn>
                    <v-btn @click="resetColumns()" text style="top" color="warning">
                      Reset Columns
                    </v-btn>
                  </v-toolbar>
                </v-menu>
              </v-list-item>
              <hr />
              <v-list-item
                v-for="(c, i) in (safeToolBarControls || []).filter(t => {
                  return (
                    (!t.default || $root.isMobile || $root.isTablet) &&
                    ($root.customerId ? t['v-bind'] && !t['v-bind'].noCustomer : !t.hidden)
                  );
                })"
                :key="i"
              >
                <v-btn
                  :small="true"
                  :color="c['v-bind'].color"
                  :text="c['v-bind'].text"
                  :class="c['v-bind'].class"
                  v-if="
                    (!c.default || $root.isMobile || $root.isTablet) &&
                      c[`comp`] == 'v-btn' &&
                      c['v-bind'] &&
                      !c['v-bind'].hidden &&
                      !c.hidden &&
                      !hideCtl(c)
                  "
                  @click="customBtnClick(c)"
                  :loading="customBtnLoading"
                >
                  <v-icon
                    :class="$vuetify.breakpoint.smAndDown ? 'ma-2' : 'ma-2'"
                    v-if="c['v-bind'] && c['v-bind'].icon"
                  >
                    {{ c["v-bind"].icon }}
                  </v-icon>
                  {{ c["v-bind"]["input-value"] }}
                </v-btn>
                <component
                  v-else-if="!c.default && !edited && c['v-bind'] && !c['v-bind'].hidden && !hideCtl(c)"
                  :hidden="c.hidden"
                  small
                  :is="c[`comp`]"
                  :ref="c[`id`]"
                  :id="c[`id`]"
                  :table="getObject()"
                  v-bind="c[`v-bind`]"
                >
                  {{ c.value }}
                </component>
              </v-list-item>
            </v-list>
          </v-menu>

          <div class="text-center">
            <v-dialog v-model="helpModel" v-if="helpText" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ma-1" icon small v-bind="attrs" v-on="on">
                  <v-icon class="ma-2">mdi-help-box</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                  {{ helpTitle }}
                </v-card-title>

                <v-card-text>
                  {{ helpText }}
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <template> </template>

          <v-tooltip v-if="!isMobile && !noFullScreen" top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" class="ma-2" icon @click="toggleFullScreen">
                <v-icon v-if="!isFullScreen">mdi-fullscreen</v-icon>
                <v-icon round color="error" v-else>mdi-fullscreen-exit</v-icon>
              </v-btn>
            </template>
            <span>Toggle Full Screen</span>
          </v-tooltip>
        </v-toolbar>
        <v-tabs v-model="groupByFilter" v-if="groupByItemTabs.length">
          <v-tab v-for="item in groupByItemTabs" :key="item.name">
            <span :style="{ borderRadius: '4px' }">
              {{ item.caption }}
            </span>
          </v-tab>
        </v-tabs>
      </div>
      <div v-if="upload">
        <v-upload
          defaultMessage="Drop here excel file to upload"
          :label="uploadFieldsTitle"
          :objectName="data_object.object_name"
          :uploadFields="uploadFields"
        ></v-upload>
      </div>

      <h3 class="ma-2" v-if="isEditedNew && edited">
        {{ addButtonCaption ? addButtonCaption.replace("Add", "New") : "New Record" }}
      </h3>

      <v-tabs
        :hidden="hideEditedTabs || isEditedNew"
        v-if="editedTabs.length"
        class="mt-2"
        v-model="edited"
        :key="editedTabsKey"
        show-arrows
        grow
      >
        <v-tab key="all_records">All {{ tableName }}</v-tab>
        <v-tab @click="getCurrentEditedItem(t)" v-for="(t, i) in editedTabs" :key="i">
          <v-icon class="pr-2" v-if="t.icon">{{ t.icon }}</v-icon>
          {{ t.text }}

          <v-btn icon @click="removeTab(i)" class="ml-2">
            <v-icon x-small>mdi-close</v-icon>
          </v-btn>
        </v-tab>
      </v-tabs>

      <div :class="!hasParent && !scrollableEditor ? 'edited-form-' : 'edited-form'" v-if="edited">
        <v-component :is="'div'" fullscreen v-model="dialog">
          <v-form-card
            :dObject="dObject"
            v-bind="schema['v-bind']"
            :inTable="true"
            ref="form"
            :panels="true"
            :key="formKey"
            :noCache="noCache"
            :hasParent="hasParent"
          ></v-form-card>
        </v-component>
      </div>

      <div
        ref="tableWrap"
        :style="{ height: wrapHeight, 'max-height': wrapHeight }"
        :class="
          hideScroll ? '' : $root.isMobile ? '' : noHorizontalScroll ? 'data-table-wrap-no-hor' : 'data-table-wrap'
        "
        v-else
      >
        <div ref="outerScroll" v-if="!hideScroll" class="outer-scroll">
          <div refs="innerScroll" class="inner-scroll"></div>
        </div>
        <!-- computedHeaders:{{ computedHeaders }} -->

        <v-data-table
          :items="filteredItems"
          v-if="!dList && !dExcel && Array.isArray(table) && !mapDialog && tableReady && computedHeaders"
          v-model="selected"
          :headers="
            (computedHeaders || []).filter(h => {
              return table.length && !h.hide && (h.show || h.value == 'actions');
            })
          "
          :group-by="groupBy"
          :group-key="groupBy"
          :group-desc="false"
          item-key="_id"
          :show-select="(!noDelete && selectDelete) || singleSelect || select || isDraggable || selectSwitch"
          :show-expand="expandable"
          :show-group-by="showGroupBy"
          :fixed-header="fixedHeader"
          :height="tableHeight"
          :disable-pagination="editDisablePagination"
          :hide-default-footer="true"
          :hide-default-header="hideHeader"
          :items-per-page="itemsPerPageEdited"
          :mobile-breakpoint="breakpoint"
          @click:row="handleClick"
          @pagination="onPagination"
          @mouseover="onRowHover"
          @mouseleave="onRowLeave"
          @item-selected="itemSelected || null"
          :options.sync="pagination"
          dense
          :expand.sync="expand"
          ref="dTable"
          :expanded.sync="expanded"
          class="elevation-1"
          transition="slide-y-transition"
          v-draggable
          @sorted="saveOrder"
          :page.sync="page"
          :loading="loading"
          :search="searchLen ? searchTrigger : search"
          :item-class="itemClass"
          :disable-sort="disableSort"
          :single-select="(singleSelect && !selectDelete) || (noDelete && !select)"
          :server-items-length="serverItemsLength"
          :custom-sort="customSorting"
          :custom-filter="customFilter ? customFiltering : defaultFilter"
          :tableName="tableName"
          :key="tableKey"
          :style="tblStyle"
          @update:sort-by="getSortBy"
          @update:sort-desc="getSortDesc"
          @update:group-by="getGroupBy"
          @update:group-desc="handleGroupDescChange"
        >
          <template v-if="isGoToButton" v-slot:item.goto="{ item }">
            <v-btn small elevation="0" @click="goToButtonAction(item)">
              {{ goToButtonText }}
            </v-btn>
          </template>
          <!-- 
          <template v-slot:body.prepend>
            <tr v-if="showAdvancedSearch">
              <td style="min-width: 150px; padding: 0px" v-for="(h, i) in computedHeaders" :key="i">
                <v-form-component
                  :ref="h.value"
                  :name="h.value"
                  :schema="getSchema({ name: h.value })"
                  :k="h.value"
                  :model="searchModel"
                  :hasParent="hasParent"
                ></v-form-component>
              </td>
            </tr>
          </template> -->
          <!-- v-if="
            props.props.headers.some((h) => {
              return h.span;
            })
          "    -->
          <template v-slot:top>
            <!-- Custom sort control for mobile -->
            <div v-if="$root.isMobile" class="custom-sort-control mb-n10 mt-n6 pl-4 pt-4">
              <!-- Your custom sort control for mobile -->
              <!-- <v-menu
                :close-on-content-click="false"
                v-if="$root.isMobile"
                v-model="menuFilterModel"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ma-2" icon small v-bind="attrs" v-on="on">
                    <v-icon>mdi-table-filter</v-icon>
                  </v-btn>
                </template> -->
              <!-- <v-list>
                  <v-list-item> -->
              <v-select
                v-if="filteredTabItems.length && filteredTabItems.length > 1 && !noTabs && $root.isMobile"
                clearable
                :items="filteredTabItems"
                item-text="caption"
                item-value="value"
                @change="applyFilter"
                class="mb-1 mr-1 mt-2"
                :outlined="false"
                filled
                :label="filterComboLabel || 'Filter'"
              ></v-select>
              <!-- </v-list-item>
                </v-list> -->
              <!-- </v-menu> -->
            </div>
          </template>

          <template
            slot="header"
            slot-scope="props"
            v-if="
              props.props.headers.some(h => {
                return h['v-bind'] && h['v-bind'].span && !h['v-bind'].noSpan;
              })
            "
          >
            <!-- {{ props.props.headers }} -->
            <td
              v-for="(h, i) in (props.props.headers || []).filter(r => {
                return !r['v-bind'] && !r.value == 'actions';
              })"
              :key="i"
            >
              {{ h.text }}
            </td>

            <td
              :colspan="h['v-bind'] ? h['v-bind'].span.headers.length : 1"
              v-for="(h, i) in (props.props.headers || []).filter(r => {
                return r['v-bind'] && r['v-bind'].span;
              })"
              :key="i"
            >
              <v-row v-if="h['v-bind']" class="ma-2 pr-12">
                <v-col v-for="(s, j) in h['v-bind'].span.headers" :key="j">
                  <span :class="'ml-n' + j * 6">{{ s }}</span>
                </v-col>
              </v-row>
            </td>
          </template>

          <template slot="group.header" slot-scope="props">
            <td :colspan="props.headers.length">
              <v-btn class="ma-2" @click="props.toggle" small text :data-open="props.isOpen" ref="group">
                <v-icon :ref="'openGroup_' + props.group" v-if="props.isOpen">
                  mdi-chevron-up
                </v-icon>
                <v-icon :ref="'closeGroup_' + props.group" v-else>
                  mdi-chevron-down
                </v-icon>
                <h4>
                  {{ capitalize(getGroupName(props)) }}
                </h4>
              </v-btn>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn ref="removeGroup" v-bind="attrs" v-on="on" small text @click="props.remove">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                Ungroup
              </v-tooltip>
            </td>
          </template>

          <template slot="item.data-table-select" slot-scope="item">
            <td
              v-if="(selectDelete && !noDelete) || select || singleSelect || selectSwitch"
              style="max-width: 50px; overflow: hidden"
            >
              <v-checkbox
                class="mt-0 mb-n4"
                v-if="
                  (!droppedObjects || !sortedDraggedObjects(item).length) &&
                    ((item.item._id && !disabledProperty) ||
                      (disabledValue && item.item[disabledProperty] !== disabledValue) ||
                      (!disabledValue && !item.item[disabledProperty]))
                "
                v-model="item.isSelected"
                @change="
                  log(item);
                  item.select($event);
                "
              ></v-checkbox>
            </td>
            <td v-if="isDraggable">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" class="drag-handle">mdi-drag</v-icon>
                </template>
                <span>Drag to reorder</span>
              </v-tooltip>
            </td>
            <td v-if="rowIcons">
              <span v-for="(i, j) in rowIcons(item)" :key="j">
                <v-icon :color="i.color">{{ i.icon }}</v-icon>
                {{ i.title }}
              </span>
            </td>
          </template>

          <template v-for="(field, i) in capitalizable" :slot="[`item.` + field]" slot-scope="props">
            <div
              :key="i"
              v-if="schema.properties[field] && schema.properties[field].template"
              v-html="getTemplate(props.item, { name: field })"
            ></div>

            <div :key="field" v-else-if="props.item[field] && schema.properties[field]">
              {{
                props.item[field] && schema.properties[field]["v-bind"] && schema.properties[field]["v-bind"].itemText
                  ? capitalize(props.item[schema.properties[field]["v-bind"].itemText])
                  : capitalize(props.item[field].toString())
              }}
            </div>
          </template>

          <!-- <template
          v-for="(slot, i) in coloredFields"
          v-slot:[`item.${slot}`]="{ item }"
        >
          <v-chip
            v-if="item[slot]"
            :key="i"
            :color="
              getItemColor
                ? getItemColor(item[slot], slot, item, tableName)
                : item['color']
                ? item['color']
                : ''
            "
            dark
            outlined
          >
            <b> {{ getChipValue(item, slot) }}</b>
          </v-chip>
        </template> -->

          <template v-for="(slot, i) in specialFields" v-slot:[`item.${slot.model}`]="{ item }">
            <v-text-dialog
              v-if="item[slot.model] && dialogFields"
              :vModel="item[slot.model]"
              :width="slot.width"
              :icon="getTextDialogIcon(slot, item)"
              :key="i"
            ></v-text-dialog>

            <!-- <v-alert
            v-if="item[slot.model] && !dialogFields"
            :key="i"
            :color="
              getItemColor
                ? getItemColor(item[slot.model], slot.model, item, tableName)
                : item['color']
                ? item['color']
                : ''
            "
          > -->

            <v-alert
              dense
              class="ma-2"
              text
              :color="
                $vuetify.theme.dark
                  ? invertColor(getItemColor(item[slot.model], slot.model, item, tableName))
                  : getItemColor(item[slot.model], slot.model, item, tableName)
              "
              v-if="item[slot.model] && !dialogFields"
              :key="i"
            >
              <span style="white-space: nowrap">
                {{ getChipValue(item, slot.model) }}
              </span>
            </v-alert>

            <!-- </v-alert> -->
          </template>

          <template v-for="(field, i) in editable" :slot="[`item.` + field.name]" slot-scope="props">
            <!-- props.item._id != newRowId && -->
            <!-- props.item._id != newRowId && -->

            <v-edit-dialog
              v-model="dialogModel"
              style="max-width:200px"
              persistent
              v-if="
                !editRow &&
                  !noEditRow &&
                  ((!readonly && !field.directEdit && editedItem) ||
                    (!editedItem && !readonly && !field.nonUpdatable && !field.directEdit))
              "
              :key="field.name + i"
              :ref="field.name + props.item._id"
              @cancel="cancel"
              save-text="apply"
              @open="open(field, props)"
              @close="close"
              @save="emitDialogSave(props.item, field.name)"
            >
              <div
                v-if="schema.properties && getColor(props, field) == 'underscore'"
                :class="$vuetify.breakpoint.smAndDown ? '' : getColor(props, field)"
                v-html="getField(props, field)"
              ></div>

              <v-chip v-else :color="getColor(props, field).replace(' editable', '')">
                <div class="chip-text">
                  {{ getField(props, field) || "" }}
                </div>
              </v-chip>
              <!-- {{ getSchema(field, props.item) }} -->

              <template v-slot:input>
                <div>
                  <v-form-component
                    :ref="field.name"
                    :name="field.name"
                    :model="editValue"
                    :parentModel="props.item"
                    :parModel="formModel"
                    :schema="getSchema(field, props.item)"
                    :parentSchema="parObject || {}"
                    :parentSchemaObject="getParentSchema()"
                    :inLine="true"
                    :k="field.name"
                    :defaultDataFn="defaultDataFn"
                    :placeholder="schema.properties[field.name].title"
                    :click="selectCtl"
                    :onValueChange="onValueChange"
                    :autofocus="true"
                    :dialogOpen="true"
                    :hasParent="hasParent"
                    :noCache="noCache"
                    :fullCol="true"
                  >
                  </v-form-component>
                </div>
                <v-toolbar v-if="showComponent(field.name, props.item)" flat>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="!schema.properties[field.name].noEditDialogButtons"
                    @click="emitDialogSave(props.item, field.name)"
                    small
                    text
                    color="info"
                  >
                    {{ getSaveTitle(field.name) }}
                  </v-btn>
                  <v-btn ref="cancelBtn" @click="closeDialog(field.name + props.item._id)" small text>
                    Close
                  </v-btn>
                </v-toolbar>
              </template>
            </v-edit-dialog>

            <div
              :key="field.name + i"
              v-if="
                (editRow && !field.hideTitle) ||
                  (readonly && schema.properties && getColor(props, field) == 'underscore')
              "
              :class="$vuetify.breakpoint.smAndDown ? '' : editRow ? '' : getColor(props, field)"
              v-html="getField(props, field)"
            ></div>
            <div
              :style="
                $vuetify.breakpoint.mdAndUp && getSchema(field)[field.name]
                  ? 'width:' + getSchema(field)[field.name].width + 'px'
                  : ''
              "
              :key="i"
            >
              <div
                style="width: 100px"
                v-if="
                  disabledProperty && props.item[disabledProperty] == disabledValue && field.name == disabledProperty
                "
              >
                {{ capitalize(props.item[disabledProperty]) }}
              </div>

              <div
                class="mb-n7 mt-n2 pa-0"
                v-if="
                  schema.properties[field.name] && schema.properties[field.name].template && !editable.includes(field)
                "
              >
                {{ getTemplate(props.item, field) }}
              </div>
              <!-- pa-2 mb-6 full-width -->

              <div :class="$vuetify.breakpoint.mdAndUp ? '' : ''">
                <v-form-component
                  v-if="
                    schema.properties[field.name] &&
                      ((schema.properties[field.name] &&
                        !schema.properties[field.name].template &&
                        props.item._id != newRowId &&
                        !schema.properties[field.name].NoFirstRowEditable &&
                        directEdit &&
                        field.directEdit != false &&
                        (props.item._id || tableInsertable) &&
                        ((!disabledProperty && schema.properties[field.name]) ||
                          props.item[disabledProperty] != disabledValue)) ||
                        (props.item._id == newRowId &&
                          !schema.properties[field.name].NoFirstRowEditable &&
                          tableInsertable &&
                          !field.directEdit) ||
                        (!directEdit && field.directEdit == true))
                  "
                  :ref="field.name"
                  :mainTab="formMainTab"
                  :name="field.name"
                  :model="props.item"
                  :parentModel="props.item"
                  :parModel="formModel"
                  :schema="getSchema(field, props.item)"
                  :parentSchema="parObject || {}"
                  :parentSchemaObject="getParentSchema()"
                  :inLine="true"
                  :k="field.name"
                  :inserted="tableInsertable"
                  :placeholder="schema.properties[field.name].title"
                  :click="selectCtl"
                  :defaultDataFn="defaultDataFn"
                  :onValueChange="getValueChange"
                  :hasParent="hasParent"
                ></v-form-component>
              </div>
            </div>
          </template>

          <template v-if="link && link.field" :slot="[`item.` + link.field]" slot-scope="props">
            <router-link
              :to="{
                name: link.name + '_' + props.item[link.field],
                params: { id: props.item[link.field] }
              }"
            >
              <div @click="linkClick ? linkClick(props.item) : myLinkClick(props.item)">
                {{ props.item[link.field] }}
              </div>
            </router-link>
          </template>

          <template v-if="tableEditRow || editRowWithEditable || actionCommand" slot="item.actions" slot-scope="props">
            <!-- <v-row> -->

            <v-toolbar style="background-color: transparent" flat>
              <v-spacer></v-spacer>
              <v-btn v-if="tableEditRow || editRowWithEditable" @click="editCurrentRecord(props.item)" icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <component
                v-for="(c, i) in editControls"
                :key="i"
                small
                class="ml-0"
                :is="c[`comp`]"
                :ref="c[`id`]"
                :id="c[`id`]"
                :formModel="props.item"
                v-bind="c[`v-bind`]"
              />
              <v-tooltip v-for="(c, i) in actionCommand" :key="i" bottom>
                <template v-slot:activator="{ on }">
                  <v-badge
                    bordered
                    :content="props.item[c.badge]"
                    :value="props.item[c.badge] ? true : false"
                    class="custom-badge-position"
                    color="error"
                    overlap
                  >
                    <v-btn
                      @click="c.action ? c.action(props.item) : customAction(props.item, c.actionName)"
                      :color="c.color"
                      v-on="on"
                      icon
                    >
                      <v-icon v-if="c.icon">{{ c.icon }}</v-icon>
                      <div v-if="c.commandText">
                        {{ c.commandText(props.item) }}
                      </div>
                    </v-btn>
                  </v-badge>
                </template>
                {{ c.text }}
                <!-- -->
              </v-tooltip>
            </v-toolbar>
            <!-- </v-row> -->
            <!-- <v-row v-else> </v-row> -->
          </template>

          <template slot="item.data-table-expand" slot-scope="{ item, expand, isExpanded }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  ref="expandIcon"
                  v-on="on"
                  v-if="item._id"
                  @click="
                    expand(!isExpanded);
                    doExpand(item, isExpanded);
                  "
                >
                  {{ isExpanded ? "mdi-arrow-up-drop-circle-outline" : "mdi-arrow-down-drop-circle-outline" }}
                </v-icon>
              </template>
              <span>More Detail</span>
            </v-tooltip>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td class="ma-0 pa-0" style="height: auto; overflow: hidden" :colspan="headers.length">
              <v-container v-if="!droppedObjectsAsTable">
                <v-row :key="dropKey" class="drop-zone" align="start" justify="start">
                  <v-col
                    v-for="(d, i) in sortedDraggedObjects(item)"
                    :key="d._id"
                    class="pa-2 dropped-panel"
                    :draggable="true"
                    @dragover.prevent="onDragOver($event, i)"
                    @dragstart="onDragStart(d, i)"
                    @drop="onDropItem(item, i)"
                  >
                    <v-card class="pa-2" v-html="droppedObjectTemplate ? droppedObjectTemplate(d, i) : ''"></v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-container class="dropped-objects-table pa-2" v-else>
                <v-data-table
                  :headers="droppedObjectsHeaders"
                  :items="sortedDraggedObjects(item)"
                  :item-key="droppedTableId || '_id'"
                  :items-per-page="50"
                  show-select
                  class="elevation-1"
                  @input="droppedObjectSelect"
                  @click:row="item => droppedObjectsLink(item)"
                  dense
                  ><template v-slot:item="{ item, index, isSelected, select }">
                    <tr
                      class="draggable-row"
                      @mousedown="droppedObjectDragStart(index)"
                      @dragover.prevent="droppedObjectDragOver(index)"
                      @drop.prevent="droppedObjectDropRow(index, item)"
                      @click="droppedObjectsLink(item)"
                      draggable="true"
                    >
                      <td class="text-center" style="width: 40px;">
                        <v-simple-checkbox :value="isSelected" @input="select($event)" />
                      </td>

                      <td>
                        <div class="d-flex align-center">
                          <!-- <div class="mr-2">{{ index + 1 }}</div> -->

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon class="drag-handle" v-on="on" v-bind="attrs">
                                mdi-drag
                              </v-icon>
                            </template>
                            <span
                              >Drag Row to Change
                              {{
                                capitalize(
                                  droppedObjectsSortProperty.split(".")[
                                    droppedObjectsSortProperty.split(".").length - 1
                                  ]
                                )
                              }}</span
                            >
                          </v-tooltip>
                        </div>
                      </td>

                      <td v-for="h in droppedObjectsHeaders.filter(h => h.value !== 'drag')" :key="h.value">
                        {{ item[h.value] }}
                      </td>
                    </tr>
                  </template>
                  <!-- <template v-slot:body>
                    <tbody>
                      <draggable
                        :list="sortedDraggedObjects(item)"
                        item-key="_id"
                        handle=".drag-handle"
                        tag="template"
                        @end="evt => onRowReorder(evt, item)"
                      >
                        <tr
                          v-for="row in sortedDraggedObjects(item)"
                          :key="row._id"
                          class="draggable-row"
                          @click="droppedObjectsLink(row)"
                        >
                          <td style="width: 40px;">
                            <v-icon class="drag-handle" style="cursor: grab;">mdi-drag</v-icon>
                          </td>

                          <td v-for="h in droppedObjectsHeaders.filter(h => h.value !== 'drag')" :key="h.value">
                            {{ row[h.value] }}
                          </td>
                        </tr>
                      </draggable>
                    </tbody>
                  </template> -->
                </v-data-table>
              </v-container>

              <!-- <v-card class="pa-3">
                <v-card-text>
                  <div
                    class="drop-zone"
                    @dragover.prevent="onDragOver"
                    @drop="onDrop(item)"
                  >
                    Drop Here {{ dropName }}
                  </div>
                </v-card-text>
              </v-card> -->
            </td>
          </template>

          <template slot="footer">
            <hr v-if="totalFields" />
            <table v-if="totalFields" class="v-data-table mt-2 table-summary" style="width: 100%">
              <tr>
                <td align="right" v-for="(header, j) in filteredHeaders" :key="j">
                  <span v-for="(f, i) in tableTotal" :key="i">
                    <strong>
                      <span class="mr-6" v-if="tableTotal[i]['field'] == header.value">
                        {{ capitalize(header.value) }}: {{ parseFloat(tableTotal[i]["total"]).toFixed(2) }}
                      </span>
                    </strong>
                  </span>
                </td>
              </tr>
            </table>

            <div class="fixed-footer">
              <tr>
                <td v-if="editedItem && !tableInsertable"></td>

                <td v-if="editedItem && !tableInsertable">
                  <v-table-edited-item
                    :editedItem="editedItem"
                    :isNew="isNew"
                    :onValueChange="onValueChange"
                    :save="save"
                    ref="edit_combo"
                  ></v-table-edited-item>
                </td>
              </tr>
              <!-- <table style="width:100%" v-if="tableInsertable">
          <tr> -->
              <hr />
              <!-- <v-toolbar
            v-if="!hideFooter"
            flat
            :color="$vuetify.breakpoint.smAndDown ? 'grey lighten-3' : ''"

          > -->
            </div>

            <!-- </v-toolbar> -->
          </template>
          <!-- <template
          v-if="breakpoint && $vuetify.breakpoint.smAndDown && itemTemplate"
          v-slot:item="{ item, headers }"
        >
          <v-row class="ma-2" v-for="h in headers" :key="h.value">
            <v-col
              v-if="
                (selectDelete && !noDelete && item._id != newRowId) ||
                  select ||
                  singleSelect ||
                  selectSwitch
              "
              style="max-width: 25px; overflow: hidden"
            >

              <v-checkbox
                class="mt-0 mb-n4"
                v-if="
                  (item._id && !disabledProperty) ||
                    (disabledValue &&
                      item[disabledProperty] !== disabledValue) ||
                    (!disabledValue && !item[disabledProperty])
                "
                v-model="item.isSelected"
                @change="
                  log(item);
                  item.select($event);
                "
              ></v-checkbox
            ></v-col>
            <v-col>{{ h.text }}</v-col>
            <v-col>{{ item[h.value] }}</v-col>
          </v-row>

        </template> -->

          <template v-if="$root.isMobile && mobileViewTemplate && breakpoint" v-slot:item="{ item, index }">
            <v-mobile-view-table-template
              :tableName="tableName"
              :item="item"
              :index="index"
              :getItemColor="getItemColor ? getItemColor : null"
              :editCurrentRecord="editCurrentRecord"
              :linkClick="linkClick"
              :getTemplate="getTemplate"
              :parentObject="parentObject"
            ></v-mobile-view-table-template>
          </template>

          <!-- <template v-slot:no-data>
            <v-card>
              No Data
              <v-icon large> mdi-table-off </v-icon>
            </v-card>
          </template> -->
        </v-data-table>
        <div v-if="loading">
          <i class="mdi mdi-loading mdi-spin ma-2"></i>
          Loading ...
        </div>
      </div>

      <!-- pageCount: {{ pageCount }} currentPage:{{ currentPage }} -->
      <!-- <v-pagination>
      v-model="currentPage" :length="pageCount"
    </v-pagination> -->
      <d-list
        width="100%"
        v-if="dList"
        :key="listKey"
        :data_object="data_object"
        :editData="editData"
        :editRec="editRec"
      ></d-list>

      <excel-table
        v-if="dExcel"
        :key="excelKey"
        :table="table"
        :headers="headers"
        :data_object="data_object"
        :columnWidth="excelColumnWidth"
        ref="excel_table"
        v-model="selected"
        class="mt-n4"
      ></excel-table>
      <!-- <v-btn @click="assignId()">assign id </v-btn> -->
      <v-snackbar v-if="successMessage" v-model="successMessage" :timeout="5000" color="success">
        {{ successMessage }}

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="successMessage = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <!-- <v-alert
      class="ma-4"
      dismissible
      timeout="3000"
      v-if="successMessage != '' && !noAlert"
      type="success"
    >
      {{ successMessage }}
    </v-alert> -->
      <v-alert class="ma-4" timeout="3000" dismissible v-if="errorMessage != '' && errorMessage" type="error">
        {{ errorMessage }}
      </v-alert>
      <v-app-bar v-if="$root.isMobile" class="bottom-bar" bottom :app="true">
        <v-toolbar flat>
          <v-pager
            v-if="tableReady && !hideFooter && table.length > 10 && !editDisablePagination && !disablePagination"
            :pageStart="pageStart"
            :pageStop="pageStop"
            :itemsLength="itemsCount"
            :navigate="navigate"
            :page="page"
          ></v-pager>
        </v-toolbar>
      </v-app-bar>
    </div>

    <v-dialog class="assistant" v-model="assistantModel" width="600">
      <v-ai-chat
        v-if="assistant"
        hideAssistantsList="true"
        hideThreads="true"
        hideNewChat="true"
        v-bind="assistant"
      ></v-ai-chat>
    </v-dialog>
    <div
      v-if="showRowTooltip"
      class="mouse-tooltip"
      :style="{
        top: mouseY + 'px',
        left: mouseX + 'px',
        background: tooltipColor
      }"
    >
      {{ tooltipText }}
    </div>
  </div>
</template>

<script>
// import vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import axios from "axios";
import Sortable from "sortablejs";
import draggable from "vuedraggable";
import arrive from "arrive";
import { mergeProps } from "vue";
import * as fun from "../plugins/common";

export default {
  name: "DTable",
  props: {
    data_object: Object,
    vModel: [Object, Array],
    editable: {
      type: Array,
      default: function() {
        return [];
      }
    },

    table_title: String,
    tableName: String,
    addButtonCaption: String,
    addButtonKey: String,
    newItemTitle: String,
    new_data: Object,
    rowClick: Function,
    linkClick: Function,
    selectSwitch: Boolean,
    editData: [Array, Object],
    getTotal: Function,
    rowIcons: Function,
    parentKey: String,
    allParentKeys: Array,
    toolBarControls: Array,
    editControls: Array,
    toolBarExpandedControls: Array,
    itemsPerPage: {
      type: [Number, String]
    },
    itemSelected: Function,
    toolbarRight: Boolean,
    hasSearch: Boolean,
    remoteSearch: Boolean,
    remoteSearchFields: Array,
    numericFields: Array,
    searchLen: Number,
    beforeSubmit: Function,
    afterSubmit: Function,
    beforeSave: Function,
    afterSave: Function,
    onValueChange: Function,
    doSubmit: Boolean,
    dList: Boolean,
    dListData: Array,
    dExcel: Boolean,
    fixedHeader: Boolean,
    hideTitle: Boolean,
    tableHeight: [String, Number],
    hideFooter: Boolean,
    hideHeader: Boolean,
    allExpanded: Boolean,
    disablePagination: Boolean,
    noServerPagination: Boolean,
    mobileBreakpoint: String,
    alwaysUpdate: Boolean,
    allEditable: Boolean,
    directEdit: Boolean,
    getTable: Function,
    ajustTableSchema: Function,
    editedItem: Object,
    onRowUpdate: Function,
    beforeAddData: Function,
    onLoad: Function,
    onMount: Function,
    onDataChange: Function,
    getFreshData: Boolean,
    excelColumnWidth: String,
    formModel: [Object, Array],
    parentModel: Object,
    fields_excluded: Array,
    fields_included: Array,
    expandedIndexes: Array,
    editRow: Boolean,
    editRecord: Function,
    initialData: Array,
    tblKey: String,
    groupName: Function,
    expandable: Boolean,
    additionalData: Array,
    k: String,
    expansionColumns: Number,
    insertable: Boolean,
    noDelete: Boolean,
    noSave: Boolean,
    disabledProperty: String,
    disabledValue: String,
    parObject: Object,
    parTable: Array,
    parentObject: [Object, Array],
    defaultModel: Object,
    isDraggable: Boolean,
    disableSort: Boolean,
    singleSelect: Boolean,
    noToolBar: Boolean,
    skipRecalculation: Boolean,
    saveButtonCaption: String,
    noAdditionalMenu: Boolean,
    editRowWithEditable: Boolean,
    // assistant_instructions: String,
    link: {
      type: Object,
      default: function() {
        return {};
      }
    },
    noInitEdit: Boolean,
    isGoToButton: Boolean,
    goToButtonText: String,
    goToButtonAction: Function,
    onDataReceived: Function,
    getRowClass: {
      Function,
      String
    },
    coloredFields: Array,
    dialogFields: Array,
    getItemColor: [Function, String],
    colorProperty: String,
    filterTabs: Array,
    filterTabsFn: [String, Function, Object],
    noTabs: Boolean,
    noExcel: Boolean,
    filterCondition: String,
    // filterFunction: Function,
    searchableColumns: Array,
    focusOnInsert: String,
    showGroupBy: Boolean,
    filterTable: Function,
    filter: String,
    cssClass: String,
    selectedId: String,
    mData: Array,
    serverPagination: Boolean,
    sortBy: [String, Array],
    customSort: Function,
    customSortItems: Array,
    sortDesc: Boolean,
    onRowDragDrop: Function,
    dropItem: Function,
    noAlert: Boolean,
    customFilter: Function,
    refreshAfterSubmit: Boolean,
    noCache: Boolean,
    noEditRow: Boolean,
    showFilterCombo: Boolean,
    filterComboLabel: String,
    hideAllTabFilter: Boolean,
    updateNestedArray: Boolean,
    hasAdvancedSearch: Boolean,
    noRefreshAfterUpload: Boolean,
    noRefreshButton: Boolean,
    noRefreshButtonTitle: Boolean,
    limitTabsToData: Boolean,
    limitObject: String,
    actionCommand: Array,
    editedItemTitle: Array,
    idField: String,
    columnTool: Boolean,
    refreshParent: Function,
    hideTopBar: Boolean,
    draggedIndex: null,
    dropItemHandling: Function,
    droppedObjectsSortProperty: String,
    defaultTabCaption: String,
    defaultTabColor: String,
    mobileItemTemplate: Function,
    hideEditedTabs: Boolean,
    hideFilterTabs: Boolean,
    copyRecords: Boolean,
    disableChildEdit: Boolean,
    defaultDataFn: String,
    groupByItems: Array,
    noGroups: Boolean,
    vBind: Object,
    readonly: Boolean,
    NoFirstRowEditable: Boolean,
    minSearchLength: {
      type: Number,
      default: 3
    },
    totalFields: Array,
    validate: String,
    noHorizontalScroll: Boolean,
    hideScroll: Boolean,
    noTableWrap: Boolean,
    noAddOnAllTab: Boolean,
    autoSave: Boolean,
    hideAllInCombo: Boolean,
    refreshHeadersOnFormChange: Boolean,
    parentProperty: String,
    noTabSort: Boolean,
    defaultDataObject: Object,
    mobileViewTemplate: Boolean,
    addMenuButton: Object,
    noFullScreen: Boolean,
    formMainTab: Number,
    deleteId: String,
    toolBarItemsExcluded: Array,
    hasParent: Boolean,
    scrollableEditor: Boolean,
    getItems: Boolean,
    scrollOnNew: String,
    searchAfterCompleted: Boolean,
    helpText: String,
    helpTitle: String,
    useTabs: Boolean,
    maxRecords: Number,
    droppedObjects: Array,
    droppedObjectsHeaders: Array,
    droppedObjectsCustomControls: Array,
    droppedObjectsTitle: String,
    droppedObjectsShowConrols: Function,
    droppedObjectsAsTable: Boolean,
    droppedObjectTemplate: Function,
    droppedObjectsLink: Function,
    droppedObjectSelect: Function,
    droppedObjectFilterProperty: String,
    sortedDraggedObjectsOnRowReorder: Function,
    expandedItemsTitle: String,
    initialIdField: String,
    dropName: String,
    addRecordWithLink: Object,
    qry: null,
    columns: Array,
    hasAssistant: Boolean,
    assistantTitle: String,
    noCustomQry: Boolean,
    customerColumns: Array,
    noEditCurrentRecord: Boolean,
    startExpanded: Boolean,
    hoverRowFn: Function,
    hoverTooltipFn: Function,
    droppedTableId: String,
    parentObjectName: String,
    mergeWithParent: Boolean,
    groupByDataObjects: Array
  },

  components: {
    VLoading: () => import("../components/Loading.vue"),
    VCombo: () => import("./ComboBox.vue"),
    VFormComponent: () => import("../components/FormComponent.vue"),
    DList: () => import("../components/List.vue"),
    DForm: () => import("../components/Form.vue"),
    VAccordion: () => import("../components/Accordion.vue"),
    VDateRangePicker: () => import("../components/DateRangePicker.vue"),
    VUpload: () => import("../components/UploadDragDrop.vue"),
    USMap: () => import("../components/USMap.vue"),
    SelectTable: () => import("../components/SelectTable.vue"),
    VRadioList: () => import("../components/RadioList.vue"),
    VAddLabor: () => import("../components/AddLabor.vue"),
    VCustomButton: () => import("../components/CustomButton.vue"),
    VDateTime: () => import("./DateTime.vue"),
    VFormCard: () => import("../components/FormCard.vue"),
    VUnitCharge: () => import("../components/UnitCharge.vue"),
    VAddToTableButton: () => import("../components/AddToTableButton.vue"),
    VTreeInput: () => import("../components/TreeInput.vue"),
    VEditor: () => import("../components/Editor.vue"),
    SendLetter: () => import("../components/SendLetter.vue"),
    VTableEditedItem: () => import("../components/TableEditedItem.vue"),
    DataTableRowHandler: () => import("../components/DataTableRowHandler.vue"),
    VMenuButton: () => import("../components/MenuButton.vue"),
    ChangeRates: () => import("../components/ChangeRates.vue"),
    VLabelButton: () => import("../components/LabelButton.vue"),
    VFormToolBar: () => import("../components/FormToolBar.vue"),
    VDialogTable: () => import("../components/DialogTable.vue"),
    VCrew: () => import("../components/Crew.vue"),
    VTextDialog: () => import("../components/TextDialog.vue"),
    VTableSearch: () => import("../components/TableSearch.vue"),
    VTakePhoto: () => import("../components/TakePhoto.vue"),
    VArray: () => import("../components/Array.vue"),
    VAiChat: () => import("../components/AIChat.vue"),
    VMobileViewTableTemplate: () => import("../components/UI/MobileViewTableTemplate.vue"),
    VPager: () => import("../components/UI/Pager.vue"),
    VRepeatAutocomplete: () => import("./RepeatAutocomplete.vue"),
    draggable
  },
  data() {
    return {
      lastSavedCustomQry: null,
      assistantVBind: {
        hideAssistantsList: true,
        hideNewChat: true,
        noStreaming: this.assistant?.noStreaming,
        defaultMessage: this.assistant?.defaultMessage,
        defaultToolTip: this.assistant?.defaultToolTip,
        listHeight: this.assistant?.listHeight
      },
      assistantModel: 0,
      myLinkClick: null,
      testItems: [
        {
          _id: 111,
          color: "#fff"
        }
      ],
      initialQry: null,
      searchMenuKey: 0,
      assistantQry: null,
      editValue: null,
      tabQry: null,
      searchLabel: "Search",
      tableReady: false,
      activeTab: null,
      breakpoint: null,
      tabFilter: null,
      selectDelete: false,
      mapDialog: false,
      mapDialogWidth: 0,
      mapDialogHeight: 0,
      searchDrawer: false,
      curTable: null,
      dialog: false,
      successMessage: false,
      errorMessage: false,
      headers: [],
      computedHeaders: [],
      selected: [],
      table: [],
      pagerKey: 0,
      tableKey: 0,
      originalRecords: [],
      schema: {},
      sending: false,
      showSelect: true,
      search: "",
      snack: false,
      snackColor: "",
      snackText: "",
      groupBy: [],
      totalKey: "",
      formKey: 0,
      expandedKey: 0,
      formObject: {},
      model: {},
      init: false,
      isNew: true,
      isEditedNew: false,
      listKey: 0,
      excelKey: 0,
      loading: false,
      tooltip: null,
      defaultItem: null,
      dObject: null,
      dragIndex: null,
      options: {
        debug: true,
        disableAll: false,
        autoFoldObjects: true
      },
      editedItemPlaceholder: "",
      totals: null,
      capitalizable: [],
      expanded: [],
      // expandable: false,
      expand: false,
      transitioned: [],
      closeTimeouts: {},
      editedClass: "mb-n6 mt-n2",
      newRow: {},
      insertedRow: null,
      insertNewRow: false,
      newRowInserted: false,
      observer: null,
      rowAdded: false,
      expandedObjects: [],
      compKey: 0,
      page: 1,
      pageCount: 1,
      currentPage: 1,
      itemsLength: 1,
      pageStart: 1,
      pageStop: 1,
      editDialog: false,
      qryExplanation: "",
      newRowId: "",
      sortDisabled: false,
      allTableExpanded: false,
      comboFilterItems: [],
      currentFilter: -1,
      pagination: {},
      blankRowModel: {},
      filterItems: [],
      initialId: "",
      filterCond: "",
      propertyList: [],
      addTableKey: 0,
      dModel: {},
      select: false,
      editedId: "",
      additionalModel: null,
      hideControls: false,
      customBtnLoading: false,
      form: null,
      update: {
        add: [],
        update: [],
        delete: []
      },
      comboCurrentFilter: {},
      sidePanelOpen: false,
      showAdvancedSearch: false,
      searchModel: {},
      xllink: "",
      editedTabs: [],
      edited: 0,
      currentForm: null,
      childEdited: false,
      editedTabsKey: 0,
      columnId: null,
      editTitle: "",
      mobileHeaders: [],
      copyMenu: false,
      duplicateValues: null,
      hasUpload: false,
      upload: false,
      uploadFields: [],
      uploadFieldsInitialTitle: "Use excel file with the following fields:",
      itemsPerPageEdited: 0,
      pager: false,
      serverItemsLength: -1,
      itemsPerPageChanged: false,
      editDisablePagination: false,
      delBtnKey: 0,
      toolMenu: false,
      filterChanged: false,
      toolbarKey: 0,
      groupByItemsReady: false,
      searchDone: false,
      toolBarKey: 0,
      footerKey: 0,
      serverPaginationDone: false,
      doServerPagination: false,
      filterComboKey: 0,
      rowClassFn: null,
      specialFields: [],
      disableSave: false,
      searchTabQuery: "",
      searchTabs: null,
      searchTab: null,
      tabSearchDialog: false,
      tabKey: 0,
      dialogModel: true,
      tableInsertable: false,
      keepHeaders: false,
      initialHideHeaders: null,
      mobileList: "",
      menuModel: false,
      helpModel: false,
      searchMenuModel: false,
      searchModelKey: 0,
      additionalTabs: null,
      additionalTab: 0,
      editMode: false,
      insertMode: false,
      menuOpen: false,
      hasDefaultTab: 0,
      dropKey: 0,
      filteredTabModel: 0,
      searchBarKey: 0,
      filterModel: null,
      searchFormKey: 0,
      isFullScreen: false,
      closeMenuOnClick: false,
      menuItems: [],
      menuButtonKey: false,
      sortCriteria: [],
      currentSortBy: [], // This will hold the current sort column(s)
      currentSortDesc: [],
      wrapHeight: "",
      searchReset: false,
      isSearch: false,
      pipeline: null,
      dateFields: [],
      tooltipColor: "black",
      showRowTooltip: false,
      tooltipText: "",
      mouseX: 0,
      mouseY: 0,
      groupByItemTabs: [],
      groupByFilter: -1,
      groupQry: null
    };
  },
  methods: {
    getItemFromRow(tr) {
      const tds = tr.querySelectorAll("td");
      if (!tds.length) return null;

      const item = {};

      // match each cell to header value
      this.computedHeaders.forEach((h, index) => {
        const cell = tds[index];
        if (!cell) return;

        // Extract plain text
        const value = cell.innerText.trim();

        // Save into item under header key
        item[h.value] = value;
      });

      return item;
    },

    onRowHover(e) {
      const tr = e.target.closest("tr");
      if (!tr) return;

      // Track mouse position
      this.mouseX = e.clientX;
      this.mouseY = e.clientY;
      const item = this.getItemFromRow(tr);
      const hover = this.hoverTooltipFn ? this.hoverTooltipFn(item) : null;

      if (hover && hover.text) {
        this.tooltipText = hover.text;
        this.tooltipColor = hover.color || "black"; // default
        this.mouseX = e.clientX;
        this.mouseY = e.clientY;
        this.showRowTooltip = true;
      } else {
        this.showRowTooltip = false;
      }
    },

    onRowLeave() {
      this.showRowTooltip = false;
    },
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen;
    },
    buildSearchQuery() {
      // Create an array of conditions for remoteSearchFields using regex
      var regexConditions = (this.remoteSearchFields || [])
        .filter(field => !(this.numericFields || []).includes(field)) // Exclude numericFields from regex
        .map(field => {
          return {
            [field]: {
              $regex: this.search,
              $options: "i" // Case-insensitive regex search
            }
          };
        });

      // Create an array of conditions for numericFields using exact match
      if (!this.search) {
        regexConditions = [];
      }
      const numericConditions = (this.numericFields || []).map(field => {
        return {
          [field]: parseInt(this.search) // Exact match for numeric fields
        };
      });

      // Combine all conditions
      const searchConditions = [...regexConditions, ...numericConditions];

      // Construct the MongoDB query
      if (this.initialQry) {
        const myQry = {}; // Clone the initial query

        if (!this.initialQry["$and"]) {
          myQry["$and"] = [fun.clone(this.initialQry)];
        }
        if (!myQry["$and"]) {
          myQry["$and"] = [fun.clone(this.initialQry)];
        }
        if (this.search) {
          myQry["$and"].push({ $or: searchConditions });
        }

        return myQry;
      }
      if (searchConditions.length) {
        return {
          $or: searchConditions
        };
      }
    },

    mergeProps,
    itemTemplate(item, headers) {
      if (this.mobileItemTemplate) {
        return this.mobileItemTemplate(item, headers);
      } else {
        var rows = "";
        headers.forEach(h => {
          if (item[h.value]) {
            rows += fun.format(
              "<tr><td style='white-space:noWrap;margin-right:20px'><b>{0}:&nbsp;</b></td><td>{1}</td></tr>",
              h.text,
              item[h.value] || ""
            );
          }
        });

        var t = fun.format("<table style='width:100%'>{0}</table><hr/><br/>", rows);

        // return t;
        return false;
      }
    },
    customAction(item, actionName) {
      this.$root.$emit(actionName, {
        item: item,
        obj: this
      });
      console.log(actionName, item);
    },

    resetColumns() {
      var data = {
        object_name: "columns",
        ids: [this.columnId]
      };

      axios
        .post(this.serverURL + "/delete_records", data, {
          withCredentials: true
        })
        .then(response => {
          this.tableMount();
        });
    },
    saveCustomQry(q) {
      var that = this;

      var data = {
        metadata: {
          object_name: "custom_qry"
        },

        model: {
          caption: q.caption,
          description: q.description,
          qry: this.assistantQry,
          table_name: this.tableName,
          user_id: this.$root.user_id,
          threadId: q.thread_id
        }
      };
      if (fun.compareObjects(this.lastSavedCustomQry, data.model)) {
        return;
      } else {
        this.lastSavedCustomQry = data.model;
      }

      this.qryExplanation = q.description;
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          this.successMessage = "Custom query created";
          // this.toolMenu = false;
        });
    },
    saveColumns() {
      var that = this;
      if (!this.columnId) {
        this.columnId = fun.guid();
      }
      var data = {
        metadata: {
          object_name: "columns"
        },

        model: {
          _id: this.columnId,
          headers: this.computedHeaders,
          table_name: this.tableName,
          user_id: this.$root.user_id
        }
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          this.successMessage = "Columns updated";
          this.toolMenu = false;
        });
    },
    resetSearchForm() {
      this.searchModel = {};
      // this.$refs.searchForm[0].reset();
      this.searchFormKey = !this.searchFormKey;
      this.searchDrawer = false;
    },
    getColumns() {
      var columns = this.columns || this.additionalModel?.columns;
      if (columns && columns.length && columns[0].headers.length) {
        this.computedHeaders = columns[0].headers;
        this.columnId = columns[0]._id;
      } else {
        this.computedHeaders.forEach(c => {
          if (!c.hidden) {
            c.show = true;
          } else {
            c.show = false;
          }
        });
        this.tableKey = !this.tableKey;
      }

      if (!this.tableName) {
        return;
      }
      var data_object = {
        object_name: "columns",
        qry: {
          table_name: this.tableName.toLowerCase(),
          user_id: this.$root.user_id
        }
      };
      axios
        .post(this.serverURL + "/get_data", data_object, {
          withCredentials: true
        })
        .then(response => {
          var data = response.data;
          if (data.model.length && data.model[0].headers.length) {
            this.computedHeaders = data.model[0].headers;
            this.columnId = data.model[0]._id;
          } else {
            this.computedHeaders.forEach(c => {
              c.show = true;
            });
            this.tableKey = !this.tableKey;
          }
        });
    },
    tableMount() {
      var that = this;
      this.tableReady = false;
      this.childEdited = this.disableChildEdit;

      if (!this.itemsPerPageEdited) {
        this.itemsPerPageEdited = this.itemsPerPage;
      }
      this.editDisablePagination = this.disablePagination;

      // if (this.$vuetify.breakpoint.smAndDown) {
      //   this.tableEditRow = this.editRow || this.insertable;
      // } else {
      this.tableEditRow = this.editRow;
      this.tableInsertable = this.insertable;
      // }
      // this.columnId = fun.guid();
      this.$root.$emit("tableInit", this);
      this.mapDialogWidth = window.innerWidth;
      this.mapDialogHeight = window.innerHeight;
      this.curTable = this;
      if (this.filterTabs) {
        this.getFilterParams(this);
      }

      if (this.onMount) {
        this.onMount(this);
        that.init = true;
      }
      this.$root.$on("responseFromAssistant", d => {
        console.log(d);
        that.assistantQry = d;
        console.log(that.assistantQry);
        that.assistantModel = 0;
        that.itemsCount = 0;
        // if (!that.additionalModel.custom_qry) {
        //   that.additionalModel.custom_qry = [];
        // }
        // that.additionalModel.custom_qry.push(d);

        // const assistantJson = JSON.parse(that.assistantQry);
        // const lastQry = assistantJson.at(-1);

        // that.saveCustomQry(that.assistantQry );
        that.loadFromDb();
      });
      this.$root.$on("activeTabChanged", () => {
        var curTab = this.$root.resentTabs[this.$root.activeTab];
        // console.log(curTab);
      });
      this.$root.$on("dialogClose", function() {
        that.dialog = false;
      });
      this.$root.$on("dataChanged", obj => {
        if (obj.tableTitle == that.table_title) {
          that.refresh();
        }
      });

      this.$root.$on("data_changed", m => {
        if (m.dataChange) {
          m.dataChange(that);
        }
      });
      this.$root.$on("recalculateFields", m => {
        if (that.tableName == m.tableName) {
          // that.getCalculatedFields();
        }
      });

      this.$root.$on("filterTable", m => {
        if (that.tableName == m.tableName) {
          that.table = that.originalRecords.filter(r => {
            return m.func(r);
          });
          if (m.sort) {
            that.sortTable(m.sort);
          }
        }
      });
      this.$root.$on("fileUploaded", d => {
        if (d.response.uploaded) {
          this.successMessage = "Data has been successfully imported";
        } else {
          this.errorMessage = d.response;
        }
        this.upload = false;
        if (this.noRefreshAfterUpload) {
          return;
        }
        // if (d.response.object_name != "templates") {
        //   this.refreshTable();
        // }
      });
      that.showSelect = that.selectSwitch;

      that.getData();

      if (that.getTable) {
        that.getTable(that);
      }

      this.getEditedItem();

      this.setTotals();
      this.resetForm();
      if (!this.remoteSearch || (this.remoteSearch && this.maxRecords)) {
        that.tableReady = true;
      }

      this.$root.$emit("tableMounted", this);
    },

    doSearch() {
      if (this.serverPagination) {
        this.data_object.pipeline = this.buildMongoAggregate(this.searchModel);
        this.tableReady = true;
        this.tableMount();
        this.loadFromDb();
      }
    },
    initEdit(item, edit) {
      this.dObject.schema = this.schema;
      // this.dObject["v-bind"] = this.schema["v-bind"];
      this.dObject.objectName = this.objectName || this.data_object.object_name;
      if (!item && this.data_object.object_name_to_update && !this.objectName) {
        this.dObject.objectName = this.data_object.object_name_to_update;
      }
      this.dObject.additionalModel = this.additionalModel;
      this.dObject.topObject = this.data_object?.object_name_to_update || this.data_object?.object_name;

      // this.dObject.model = item;
      this.dObject.parentModel = this.formModel;
      // if (this.dObject.model && !item) {
      //   this.dObject.model._id = fun.guid();
      // }

      // if (edit) {
      this.getModel(item, edit);

      this.formKey = !this.formKey;
      return this.dObject.model;
    },
    refreshTable() {
      this.searchModel = {};
      this.assistantQry = null;
      this.tableMount();
      this.edited = false;
      // this.currentFilter = 1;
      // this.currentFilter = 0;
      // this.updateFilter();
      // this.$forceUpdate();
      // this.doTabFilter();
      // this.tableKey = !this.tableKey;
    },
    doExpand(item, isExpanded) {
      if (this.singleSelect && !isExpanded) {
        this.selected = [];
        this.selected.push(item);
      }
    },
    onInsertControlCreated(itemName) {
      if (this.focusOnInsert && itemName == this.focusOnInsert) {
        // console.log("focus", itemName);
        //
      }
    },
    toggleFilter(e) {
      e.preventDefault();
      console.log(e);
    },
    validateEntry(id, remove, fn) {
      var that = this;
      setTimeout(function() {
        that.errorMessage = "";
        var validationRules = [];
        var valid = true;
        var messages = [];
        if (that.validate) {
          var r = that.table.find(t => {
            return t._id == id;
          });

          validationRules = eval(that.validate);
        }
        if (validationRules) {
          validationRules.forEach(v => {
            var rule = fun.getRule(v.rule.rules, v.rule.title);
            if (rule) {
              var invalidMessage = rule[0](r[v.name]);
              if (invalidMessage && typeof invalidMessage == "string") {
                messages.push(invalidMessage);
              }
            }
          });
          if (messages.length) {
            that.errorMessage = messages.join("<br/>");
            valid = false;
            if (remove) {
              that.table = that.table.filter(item => item._id !== id);
              that.originalRecords = that.originalRecords.filter(item => item._id !== id);
              that.newRowId = null;
            }
          }
        }
        fn(valid);
      }, 100);
    },
    applyRow(fromMenu) {
      if (fromMenu) {
        this.validateAndSave();
        return;
      }
      var table = this.table;
      var that = this;
      var valid = this.validateEntry(this.newRowId, true, valid => {
        if (valid) {
          const model = that.table.find(t => {
            return t._id == that.newRowId;
          });
          this.newRowId = "";
          this.getCalculatedFields();
          this.$root.$emit("rowAdded", {
            tbl: this
          });
          if (this.alwaysUpdate) {
            this.save(model, false, true);
            // this.submit();
          }
        }
      });
    },
    hideToolBar(hide) {
      this.hideControls = hide;
    },
    onDragOver(event) {
      event.preventDefault(); // Necessary to allow a drop
    },
    onDragStart(item, index) {
      event.dataTransfer.setData("text/plain", JSON.stringify(item));
      this.draggedIndex = index;
      event.dataTransfer.effectAllowed = "move";
      // return (event) => {
      //   event.dataTransfer.setData('text/plain', item.name);
      //   console.log(`Started dragging: ${item.name}`);
      // };
      // const draggableItems = Array.from(
      //   event.currentTarget.querySelectorAll(".draggable-item")
      // );

      // // Find the index of the dragged element
      // const draggedElement = event.target.closest(".draggable-item");
      // this.draggedIndex = draggableItems.indexOf(draggedElement);
    },
    getDropTargetIndex(event) {
      const targetElement = event.target.closest(".draggable");
      if (!targetElement) return this.droppedObjects.length;

      const targetId = Number(targetElement.getAttribute("data-id"));
      return this.droppedObjects.findIndex(item => item.id === targetId);
    },

    onDropItem(cont, index) {
      event.stopPropagation(); // Prevent event from bubbling up
      event.preventDefault(); // Ensure default behavior is blocked
      let droppedItem = JSON.parse(event.dataTransfer.getData("text/plain"));
      if (this.dropItemHandling) {
        this.dropItemHandling(cont, droppedItem, index, this);
      }
    },
    onDrop(item) {
      // Get all draggable items within the container
      const draggableItems = Array.from(event.currentTarget.querySelectorAll(".draggable-item"));

      let itemIndex = -1; // Index where the item should be dropped
      const draggableRecordsId = []; // Array to track item IDs

      // Find the currently hovered item and its ID
      const curItem = event.currentTarget.querySelector("[data-id]");
      const curId = curItem ? curItem.getAttribute("data-id") : null;

      // Iterate through all draggable items to build IDs and find the target index
      draggableItems.forEach((d, i) => {
        const job = d.querySelector("[data-id]");
        const id = job.getAttribute("data-id");
        draggableRecordsId.push(id);

        if (id === curId) {
          itemIndex = i; // Set the target index
        }
      });

      // If the dragged item exists in the records, update its position
      const draggedIndex = this.droppedObjects.findIndex(obj => obj.id === item.id);

      if (draggedIndex !== -1 && itemIndex !== -1 && draggedIndex !== itemIndex) {
        // Remove the dragged item from its current position
        const [draggedItem] = this.droppedObjects.splice(draggedIndex, 1);

        // Insert the dragged item into the new position
        this.droppedObjects.splice(itemIndex, 0, draggedItem);

        console.log("Updated Order:", this.droppedObjects);
      }

      // Call the dropItem method with updated information
      this.dropItem(event, "", item, draggableRecordsId, this.draggedIndex);
    },

    customFiltering(value, search, item) {
      if (this.customFilter) {
        return this.customFilter(value, search, item);
      }
      if (this.currentFilter) {
        return this.filterItems[this.currentFilter - 1];
      }
    },
    restoreSchema() {
      // if (!this.parentKey) {
      let objName = this.data_object.object_name;
      if (!objName) {
        return;
      }
      if (localStorage.getItem(objName)) {
        let origSchema = JSON.parse(localStorage.getItem(objName));

        Object.keys(this.schema.properties).forEach(k => {
          delete this.schema.properties[k];
        });
        Object.keys(origSchema).forEach(k => {
          this.schema.properties[k] = origSchema[k];
        });
      }

      // }
    },
    validateAndSave(addNew, dontUpdateParent, keepOpen) {
      this.restoreSchema();
      this.isNew = addNew;
      var model = this.dObject.model;
      if (!model._id) {
        model._id = fun.guid();
      }

      var exist = this.originalRecords.filter(r => {
        return r._id == model._id;
      });

      this.errorMessage = "";

      if (this.$refs["form"]) {
        this.form = this.$refs["form"].$refs["form"].$refs["form"];
      }
      var formReady = this.form && this.form.validate();

      if (formReady) {
        //
        this.save(model, false, true);

        if (this.edited && !keepOpen) {
          this.removeTab(this.edited - 1);
        }
        if (addNew) {
          this.dObject.model = this.defaultModel;

          this.editCurrentRecord();
        }
      } else {
        this.errorMessage = "Please check your entries.";
      }
      if (!dontUpdateParent) {
        this.updateParentArray(model);
      }
      this.searchMenuKey = !this.searchMenuKey;
    },
    updateParentArray(m) {
      if (this.parentModel) {
        if (Array.isArray(this.parentModel[this.k])) {
          this.parentModel[this.k].forEach(r => {
            if (r._id == m._id) {
              r = m;
            }
          });
        }
        this.disableParentEdit(false, true);
      }
    },
    getPos(e) {
      console.log(e);
    },
    invertColor(c) {
      return fun.invertColor(c);
    },
    showSearchDrawer() {
      this.searchModel = {};
      this.isSearch = true;

      if (!this.searchReset) {
        this.searchDrawer = true;
      } else {
        this.isSearch = false;
        this.searchReset = false;
      }
    },
    getModel(item, edit) {
      if (!item && this.table.filterItems && this.table.filterItems[this.table.currentFilter]) {
        item = this.table.filterItems[this.table.currentFilter].value;
      }

      var that = this;
      if (!edit) {
        try {
          this.form = this.$refs["form"].$refs["form"].$refs["form"];
          this.form.reset();
        } catch (error) {
          //
        }
      }

      if (!edit && this.defaultModel) {
        this.dObject.model = this.defaultModel;
      }
      if (!edit && this.groupBy && this.groupByValue) {
        this.dObject.model[this.groupBy] = this.groupByValue;
      }
      if (this.dObject.model && this.defaultModel) {
        // console.log(this.dObject.model);
        Object.keys(this.defaultModel).forEach(k => {
          if (!this.dObject.model[k]) {
            this.dObject.model[k] = this.defaultModel[k];
          }
        });
      }
      if (that.schema.properties) {
        Object.keys(that.schema.properties).forEach(k => {
          if (that.schema.properties[k].loadOnDemand) {
            var data_object = that.schema.properties[k]["v-bind"];
            if (!data_object || !data_object.object_name) {
              data_object = {
                object_name: that.data_object.schema_name,
                qryFn: "var q={}; q['_id']=par._id; q"
              };
            }
            if (data_object.qryFn && item) {
              var par = item;
              data_object.qry = eval(data_object.qryFn);
            }
            axios
              .post(this.serverURL + "/get_data", data_object, {
                withCredentials: true
              })
              .then(response => {
                var data = response.data;
                if (data_object.data_property && data.model[0]) {
                  data.model = data.model[0][data_object.data_property];
                }
                var parTable = that.table;

                if (that.schema.properties[k] && that.schema.properties[k]["x-display"] == "d-table") {
                  data_object.editData = data.model;

                  this.$root.$emit("onDemandLoaded", {
                    tbl: this,
                    data: data_object.editData
                  });
                  that.dObject.update = {};
                  that.dObject.update[k] = {
                    id_fields: that.schema.properties[k]["v-bind"].id_fields
                  };
                  data_object.parTable = parTable;
                  this.$root.$on("updateChanged", tbl => {
                    // console.log(tbl);
                    if (tbl.tableName == data_object.tableName) {
                      that.dObject.update[k].update_data = tbl.update;
                      that.table.update = that.dObject.update;
                    }
                  });
                } else {
                  try {
                    that.dObject.model[k] = data.model[0][k];
                  } catch (error) {
                    //
                  }
                }

                this.formKey = !this.formKey;
              });
          }
        });
      }

      this.formKey = !this.formKey;
    },
    customSorting(items, index, isDesc) {
      var that = this;
      if (!items || !items.length) {
        return items;
      }

      var defaultSort = function() {
        if (!items || !items.length) {
          return true;
        }
        var templatedItems = fun.clone(items);
        try {
          templatedItems.forEach(t => {
            Object.keys(t).forEach(k => {
              t[k] =
                that.getTemplate(t, {
                  name: k
                }) || t[k];
            });
          });
        } catch (error) {
          //
        }

        if (that.sortBy && !index.length) {
          index = [that.sortBy];
        }
        // || that.sortDesc
        var desc = false;
        if (isDesc.length) {
          desc = isDesc[0];
        } else {
          desc = that.sortDesc;
        }

        fun.sortObjects(templatedItems, index, desc);
        templatedItems.forEach(r => {
          var origItem = items.find(i => {
            return i._id == r._id;
          });
          Object.keys(origItem).forEach(k => {
            r[k] = origItem[k];
          });
        });
        let sortedOriginalItems = templatedItems.map(item => items.find(origItem => origItem._id === item._id));
        return sortedOriginalItems;
      };
      if (this.customSort && this.customSortItems.length) {
        if (!index.length || this.customSortItems.includes(index[0])) {
          if (!index.length) {
            index = [this.customSortItems[0]];
          }
        } else {
          return defaultSort();
        }

        return this.sortDisabled ? defaultSort() : this.customSort(items, index, isDesc);
      } else {
        return defaultSort();
      }
    },
    getColor(props, field) {
      var cls = "";
      var value = props.item[field.name];

      if (this.coloredFields && this.coloredFields.indexOf(field.name) != -1) {
        var colorCls;
        if (this.getItemColor && value) {
          colorCls = this.getItemColor(value, field.name, true, this.tableName);
        } else {
          if (props["color"]) {
            colorCls = props["color"];
            //
          }
        }

        cls = colorCls || "";
        if (this.editable.indexOf(field.name) != -1) {
          return cls;
        } else {
          return cls + " editable";
        }
      } else {
        return "underscore";
      }
    },
    getInvertColor(props, field) {
      return fun.invertColor(this.getColor(props, field));
    },

    itemClass(item) {
      let base = "";

      if (this.rowClassFn) {
        base = this.rowClassFn(item);
      } else if (this.getRowClass) {
        const color = this.getRowClass(item);
        base = this.addDynamicClass(color);
      }

      // 🔥 Parent decides hover class
      const hoverClass = this.hoverRowFn ? this.hoverRowFn(item) : "";

      return `${base} ${hoverClass}`.trim();
    },
    addDynamicClass(color) {
      if (!color) {
        return "";
      }
      let className = `row-color-${color.replace("#", "")}`;
      if (!document.getElementById(className)) {
        const style = document.createElement("style");
        const readableColor = fun.calculateLuminance(color);
        style.id = className;
        style.type = "text/css";
        style.innerHTML = `
      .${className} {
        background-color: ${color} !important;
        color: ${readableColor} !important; /* Apply readable text color */
      }
      .${className} .v-icon,
      .${className} i,
      .${className} .v-data-table__expanded {
       background-color: ${color} !important;
        color: ${readableColor} !important; /* Ensure icons and slot content match text color */
      }
    `;
        document.head.appendChild(style);
      }
      return className;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    onPagination(paginationProperties) {
      // paginationProperties.itemsPerPage = parseInt(this.itemsPerPageEdited);

      if (this.itemsPerPageChanged) {
        this.itemsPerPageChanged = false;
        return;
      }
      if (this.doServerPagination) {
        if (
          // !this.serverPaginationDone &&
          paginationProperties.page > 1 ||
          (this.currentPage > 1 && paginationProperties.navigate)
        ) {
          this.currentPage = paginationProperties.page;
          //
          this.loadFromDb();
          // this.serverPaginationDone = false;
        }
      } else {
        this.pageCount = paginationProperties.pageCount;
        this.currentPage = paginationProperties.page;
        this.itemsLength = paginationProperties.itemsLength;
        this.pageStart = paginationProperties.pageStart + 1;
        this.pageStop = paginationProperties.pageStop;
        this.perPage = paginationProperties.itemsPerPage;
      }
    },

    saveOrder(event) {
      const movedItem = this.table.splice(event.oldIndex, 1)[0];
      this.table.splice(event.newIndex, 0, movedItem);
      if (this.onRowDragDrop) {
        this.onRowDragDrop(this.table, event);
      }
    },
    getParentVBind() {
      return this.schema["v-bind"];
    },
    getParentSchema() {
      let properties = this.schema.properties ? this.schema.properties : this.data_object.schema.properties;
      return properties;
    },
    hasFilter(field) {
      var schema = this.getSchema(field);
      if (schema) {
        return schema[field.name]?.filter;
      }
    },
    getSchema(field) {
      var that = this;
      var properties = this.schema.properties ? this.schema.properties : this.data_object.schema.properties;

      if (properties) {
        var schema = fun.clone(properties); //JSON.parse(JSON.stringify(properties));
        Object.keys(schema).forEach(function(k) {
          if (k != field.name) {
            delete schema[k];
          }
        });
        schema[field.name] = this.prepareEditedField(schema[field.name]);
        // schema[field.name].hideTitle = true;
        if (field["v-bind"] && schema[field.name]) {
          schema[field.name]["v-bind"] = field["v-bind"];
        }
        if (
          schema[field.name] &&
          !schema[field.name]["x-display"] &&
          (!schema[field.name].type || schema[field.name].type == "string")
        ) {
          schema[field.name]["x-display"] = "v-text-field";
          schema[field.name]["v-bind"] = schema[field.name]["v-bind"] || {};
          schema[field.name]["v-bind"].clearable = true;
        }
        // console.log(field.name, schema[field.name]?.filter);
        // if (this.isSearch && schema[field.name]?.filter == "dayRangeFilter") {
        //   schema[field.name]["x-display"] = "v-date-range-picker";
        // }

        return schema;
      }
    },
    getCurrentEditedItem(t) {
      var item = this.originalRecords.filter(d => {
        return d._id == t.id;
      })[0];
      this.editCurrentRecord(item);
    },
    getDialogType(field) {
      // Determine whether to use 'v-edit-dialog' or 'v-dialog' based on item properties
      return field["v-bind"] && field["v-bind"].dialog ? "v-dialog" : "v-edit-dialog";
    },
    openDialog(field) {
      this.currentItem = field;
      if (this.getDialogType(field) === "v-dialog") {
        this.dialogModel = true;
      }
      // Else, the v-edit-dialog will handle its own opening
    },
    getVBind(field, model) {
      var vBind = this.getSchema(field, model);
      vBind.readonly = this.getReadOnly(field, model);
    },
    getReadOnly(field, model) {
      var that = this;
      if (that.schema[field]["v-bind"] && that.schema[field]["v-bind"].readOnlyFormula) {
        var readOnlyFormula = that.schema[field]["v-bind"].readOnlyFormula;
        var r = model;

        return eval(readOnlyFormula);
      }
    },
    inEditedItems() {
      var that = this;
      var included = false;
      if (this.editable) {
        this.editable.forEach(function(i) {
          if (that.editedItem) {
            if (i.name == that.editedItem.item) {
              included = true;
              return true;
            }
          }
        });
      }

      return included;
    },

    selectMe(item, e) {
      item.select(item, e);
    },
    clearSearch() {
      this.search = "";
      this.computedHeaders.forEach(h => {
        this.searchModel[h.value] = "";
      });
      this.searchMenuModel = 0;
      this.searchModelKey = !this.searchModelKey;
    },
    capitalize(text) {
      return fun.capitalize(text);
    },
    formatDate(d) {
      return fun.formatDate(d);
    },
    resetModel() {
      this.model = {};
    },
    getGroupName(p) {
      var name = p.group;
      var defaultName = name || "(none)";
      var grName = p.groupBy && p.groupBy.length ? p.groupBy[0] : "";
      if (this.groupName) {
        // this.prevGroup = this.groupName(name);
        return this.groupName(name);
      } else {
        if (grName && this.schema.properties[grName] && this.schema.properties[grName].template) {
          var m = p.items[0];
          var par = this.parentObject;
          var addModel = this.additionalModel;
          try {
            var t = eval(this.schema.properties[grName].template);
          } catch (error) {
            t = defaultName;
          }
          // this.prevGroup = t;
          return t;
        } else {
          // this.prevGroup = grName ? p.items[0][grName] : defaultName;

          return grName ? p.items[0][grName] : defaultName;
        }
      }
    },
    getAddButton() {
      if (this.addMenuButton) {
        if (this.addMenuButton.fromItem) {
          try {
            return this.data_object.schema.properties[this.addMenuButton.fromItem]["v-bind"];
          } catch (error) {
            //
          }
        }
      }
    },
    getEditableFields() {
      if (this.addMenuButton.editableFields) {
        var editableFields = [];
        this.addMenuButton.editableFields.forEach(f => {
          var fld = {};
          fld.name = f;
          fld.prop = this.data_object.schema.properties[f];
          editableFields.push(fld);
        });
        return editableFields;
      }
    },
    cancelEdit() {
      this.restoreSchema();
      this.errorMessage = "";
      if (this.edited) {
        this.removeTab(this.edited - 1);
        // this.edited = null;
      }
      this.$root.$emit("tableEditCanceled", this);
      this.searchMenuKey = !this.searchMenuKey;
    },
    getChipValue(item, slot) {
      if (!this.schema.properties[slot]) {
        return "";
      }
      var vBind = this.schema.properties[slot]["v-bind"];
      var value = item[slot];

      if (vBind && vBind.itemText && typeof item[slot] == "object") {
        value = item[slot][vBind.itemText];
      }
      if (vBind && vBind.capitalizeText) {
        value = this.capitalize(value);
      }
      if (this.schema.properties[slot].template) {
        value = this.getTemplate(item, {
          name: slot
        });
      }
      return value;
    },
    save(r, isEdtited, isEditedItem, keepOpen) {
      this.$root.$emit("tableEditCanceled", this);
      var that = this;
      var ind = -1;
      if (!r._id) {
        r._id = fun.guid();
      }
      this.originalRecords.forEach((f, i) => {
        if (f._id == r._id) {
          ind = i;
        }
      });
      if (ind == -1) {
        this.originalRecords.push(r);
        this.isNew = true;
      } else {
        this.originalRecords[ind] = r;
      }

      try {
        if (this.$refs.form && !this.$refs.form.validate()) {
          return;
        }
      } catch (error) {
        //
      }

      if (isEdtited && !this.isEditedNew) {
        this.isNew = false;
      }

      if (isEditedItem) {
        var defaultItem = null;

        if (!this.isNew) {
          defaultItem = this.table[this.table.indexOf(r)];
        }
        if (this.editedItem && this.editedItem.modelFn) {
          var par = fun.getParentByProperty(this, this.editedItem.modelFn);
          if (par) {
            r = par[this.editedItem.modelFn]({
              r: r,
              tbl: that,
              defaultItem: defaultItem,
              isNew: !this.isNew,
              schema: this.data_object.schema,
              formModel: this.formModel
            });
          }
        }
      }

      if (this.isNew && Object.keys(r).length) {
        if (
          (!r._id || this.data_object.alwaysAddId) &&
          (this.data_object.parent_object || this.formModel || this.data_object.alwaysAddId)
        ) {
          r._id = fun.guid();
        }
        var exist = this.table.filter(function(n) {
          return n._id == r._id;
        });
        if (!exist.length) {
          this.table.push(r);
          // if (this.parentObject && this.k) {
          //   this.parentObject[this.k] = this.table;
          // }
        }

        this.model = {};
      } else {
        this.dialog = keepOpen;
      }
      try {
        this.getCalculatedFields(r);
      } catch (error) {
        //
      }

      this.$emit("input", this.originalRecords);
      if (this.beforeSave) {
        this.beforeSave(r, this);
      }
      if (
        (this.getFreshData && !this.alwaysUpdate) ||
        (!this.data_object.parent_object && !this.noSave) ||
        this.dList ||
        (this.data_object.parent_object && !this.alwaysUpdate)
      ) {
        if (!isEditedItem || this.alwaysUpdate) {
          this.saveRecord(r, this.isNew);
        }
      }
      if (this.alwaysUpdate && this.data_object.parent_object) {
        this.submit();
      } else if (!this.alwaysUpdate) {
        if (Array.isArray(this.table)) {
          this.$emit(
            "input",
            this.table.filter(function(r) {
              return r._id;
            })
          );
          this.$root.$emit("tableUpdated", this, this.noSave);
        }
      }

      if (!this.editedItem) {
        this.isNew = true;
      }

      that.$root.$emit("record_updated", {
        data_object: that.data_object,
        model: fun.clone(r),
        tbl: that
      });
      this.model = {};
      this.listKey = !this.listKey;
      this.dialog = false;
      this.setTotals();
      // if (this.editedItem) {
      //   this.moveFocus(r);
      // }
      if (this.isNew && !keepOpen) {
        this.rowAdded = true;
        var editedIndex = this.hideAllTabFilter ? 0 : -1;
        this.editedTabs.forEach((e, i) => {
          if (e.icon == "mdi-new-box") {
            editedIndex = i;
          }
          if (editedIndex > -1) {
            this.editedTabs.splice(editedIndex, 1);
            // this.resetForm();
            // this.tableMount();
            // this.refresh();
          }
        });
      }
      // if (this.$route.params.id) {
      //   this.$router.push({
      //     name: this.$route.name,
      //     params: { ...this.$route.params, id: undefined },
      //   });
      // }
    },
    resetForm() {
      if (this.form) {
        this.form.reset();
        this.form.resetValidation();
        this.successMessage = false;
        this.errorMessage = false;
      }
    },
    saveFilter() {
      console.log(this.searchModel);
      this.errorMessage = "";
      if (!this.filterName) {
        this.errorMessage = "Please Enter Filter Name";
        return;
      }
      var filterName = this.filterName.replaceAll(" ", "_");
      var customFilterData = {};
      customFilterData[filterName] = this.searchModel;
      var data = {
        object_name: "employee",
        qry: {
          "contact.email": this.$root.user_email
        },
        new_data: {
          $set: {
            custom_filter: customFilterData
          }
        }
      };

      axios
        .post(this.serverURL + "/update_record", data, {
          withCredentials: true
        })
        .then(response => {
          this.successMessage = "successfully added custom filter";
          // if(!this.additionalTabs){
          //   this.additionalTabs
          // }
          this.updateAdditionalTabs(customFilterData);
          this.clearSearch();
        });
    },
    getValueChange() {
      this.getCalculatedFields();
      this.onValueChange;
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
      this.isNew = true;
      this.model = {};
    },
    customBtnClick(c, value) {
      this.$root.$emit("customBtnClick", {
        tbl: this,
        btn: c.id
      });
      event.stopPropagation();
    },
    customCtlOnInput(c, event) {
      console.log(c);
      if (c.addRow) {
        var rec = {};
        Object.keys(c.addRow).forEach(f => {
          var item = event.item || event;
          rec[f] = item[c.addRow[f]];
        });
        this.defaultModel = rec;
        this.addRow(
          {
            item: rec
          },
          true
        );
      }
    },
    clearGroupBy() {
      this.groupByItemTabs = [];
      this.groupQry = null;
      this.loadFromDb();
    },
    applyGroupBy(item) {
      if (this.serverPagination) {
        this.groupByItemTabs = [];
        this.groupQry = null;
        if (!item) {
          this.menuModel = 0;
          this.loadFromDb();
          return;
        }
        const groupBy = this.groupByDataObjects.find(g => {
          return g.groupByItem.includes(item);
        });
        var items = [];
        if (groupBy?.objectName) {
          items = this.additionalModel[groupBy.objectName];
        } else {
          items = groupBy.items;
        }
        if (items) {
          items.forEach(it => {
            this.groupByItemTabs.push({
              item: item,
              name: it[groupBy.name] || it,
              caption: fun.capitalize(it[groupBy.name] || it)
            });
          });
          fun.sortObjects(this.groupByItemTabs, "caption");
        }

        this.groupByFilter = -1;
        this.menuModel = 0;
      } else {
        this.groupBy = item ? [item] : [];
      }
    },
    captializedGroupByItems() {
      if (this.groupByItems) {
        var items = [];
        // this.groupByItems = this.groupByItems.sort();
        this.groupByItems.forEach(g => {
          items.push({
            text: fun.capitalize(g),
            value: g
          });
        });

        return items;
      }
    },
    duplicate() {
      // this.dObject.model
      var dValues = [];
      this.duplicateValues.split(",").forEach(v => {
        dValues.push(v.trim());
      });

      var data = {
        collection_name: this.data_object.object_name,
        field_name: this.copyRecords.field_name,
        duplicate_values: dValues,

        original_value: this.dObject.model[this.copyRecords.field_name]
      };

      axios
        .post(this.serverURL + "/duplicate_records", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          this.successMessage = response.data;
        });
    },
    getCalculatedFields(model) {
      if (!this.schema || !this.schema.properties) {
        return;
      }
      var schema = this.schema.properties ? this.schema : this.data_object ? this.data_object.schema : null;
      if (!schema || !schema.properties) {
        return;
      }
      // console.log(schema);
      var getNumber = function(n) {
        return fun.getNumber(n);
      };
      var sum = function(r, formula) {
        return fun.sum(r, formula);
      };

      var getSum = function(a) {
        return fun.getSum(a);
      };
      var formatDate = function(a) {
        return fun.formatDateTime(a);
      };
      var par = fun.getParentByProperty(this, this.parentProperty);
      var keys = Object.keys(schema.properties);
      if (!model) {
        if (this.table.length) {
          this.table.forEach(function(r) {
            keys.forEach(function(key) {
              if (schema.properties[key].calculate && r._id) {
                // console.log("rec", r);
                // console.log("calc str", schema.properties[key].calculate);
                // console.log("calc", eval(schema.properties[key].calculate));
                try {
                  r[key] = eval(schema.properties[key].calculate);
                } catch (error) {
                  r[key] = "";
                }
              }
            });
          });
        }
      } else {
        var r = model;
        keys.forEach(function(key) {
          if (schema.properties[key].calculate && model._id) {
            try {
              model[key] = eval(schema.properties[key].calculate);
            } catch (error) {
              // model[key] = "";
            }
          }
        });
      }

      this.$emit("input", this.originalRecords);
      this.$root.$emit("fieldsRecalculated", this, keys);
    },
    open(field, props) {
      this.dialog = true;
      var ref = field.name + props.item._id;
      this.editValue = fun.clone(props.item);

      this.$nextTick(() => {
        var firstElement = document.querySelector(".v-small-dialog__menu-content");

        // Check if the element exists and add the new class
        if (firstElement && field["v-bind"] && field["v-bind"].dialog) {
          firstElement.classList.add("edit-dialog-wrapper");
        }

        // class=
        const dialogEl = this.$refs[ref][0].$el;
        // left = dialogEl.getBoundingClientRect().left;
        if (field["v-bind"] && field["v-bind"].dialog) {
          var parentTable = fun.findParentByTagName(dialogEl, "table");

          left = parentTable.getBoundingClientRect().left;
          document.documentElement.style.setProperty("--edit-dialog-width", "100%");
        } else {
          return;
        }
        if ((field["v-bind"] && field["v-bind"].controlAtStart) || this.$vuetify.breakpoint.smAndDown) {
          const row = dialogEl.parentElement.parentElement;

          var left = this.$vuetify.breakpoint.smAndDown ? 0 : row.getBoundingClientRect().left;
        }

        document.documentElement.style.setProperty("--edit-dialog-left", left + "px");
      });

      // document.arrive("input[k='" + k + "']", (a) => {
      //   if (a) {
      //     a.click();
      //   }
      // });
      // this.snack = true;
      // this.snackColor = "info";
      // this.snackText = "Dialog opened";
      // this.sortDisabled = true;
    },
    close() {
      this.dialog = false;
      this.isNew = true;
      this.model = {};
      this.sortDisabled = false;
    },

    editRec(rec) {
      this.isNew = false;
      this.model = rec;
      this.dialog = true;
    },
    submit(options) {
      this.errorMessage = "";
      var that = this;

      var data_object = this.data_object;

      var model = this.table;

      if (data_object.parent_object) {
        var m = {};

        if (data_object.parent_object.path) {
          m[data_object.parent_object.path] = model;
        } else {
          m[data_object.object_name] = model;
        }
        model = m;
      }
      var tot = this.getTotal ? this.getTotal(this) : "";

      if (tot) {
        model[tot.key] = tot.value;
      }
      if (data_object.defaultValue) {
        model.forEach(function(r, i) {
          model[i] = {
            ...r,
            ...data_object.defaultValue
          };
        });
      }
      this.getCalculatedFields();
      if (this.beforeSubmit) {
        var doNotSubmit = this.beforeSubmit(model, data_object.deleted);
        if (doNotSubmit) {
          return false;
        }
      }
      if (this.beforeAddData) {
        this.beforeAddData(model, this);
      }
      var metadata = this.data_object;
      metadata.d_excel = this.dExcel;

      var data = {
        metadata: metadata,
        model: model
      };
      if (options && options.item) {
        data.model = options.item;
      }
      if (!model._id && metadata.model && metadata.model._id) {
        model._id = metadata.model._id;
      }

      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(function(response) {
          if (response.data.msg) {
            that.successMessage = "successfully saved"; // response.data.msg;
          }

          // console.log("error2:", response);
        })
        .catch(function(error) {
          that.errorMessage = error.data;
          // console.log("error:", error);
        })
        .finally(() => {
          this.loading = false;
        });
      if (that.afterSubmit) {
        var opt = {};
        opt.formOptions = options;
        that.afterSubmit(opt);
      }
    },
    getEditedItem() {
      var that = this;
      if (this.editedItem && this.editedItem.objName) {
        if (!this.editedItem.items) {
          this.loading = true;
          axios
            .post(
              this.serverURL + "/get_records",
              {
                object_name: this.editedItem.objName,
                qry: this.editedItem.qry
              },
              {
                withCredentials: true
              }
            )
            .then(response => {
              var data = response.data;
              if (that.editedItem.prepareData) {
                data = that.editedItem.prepareData(data);
              }
              that.editedItem.items = data;
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    defaultFilteredItem() {
      //not used
      var defaultItem = {};
      if (this.filterItems && this.filterItems.length) {
        var item = this.filterItems[this.currentFilter];
        if (item) {
          defaultItem[item.name] = item.id;
          var prop = this.schema.properties[item.name];
          if (prop["x-display"] && prop["x-display"] == "v-combo") {
            if (prop["v-bind"].returnObject) {
              defaultItem[item.name] = {
                text: item.caption,
                value: item.id
              };
            }
          }
        }
      }
      return defaultItem;
    },
    addRowFromButton(rec, edit, addQty) {
      var item = rec.item.rec || rec.item;
      var specialFunction = null;
      var addProp = this.data_object.schema.properties[this.addMenuButton.fromItem]["v-bind"];
      var val = rec.item.value || rec.item;
      // this.$refs.dTable["disable-pagination"] = true;
      // this.editDisablePagination = true;
      if (addProp.updateItem) {
        // if (addProp.updateItem.checkCustomFunction) {
        //   specialFunction = fun.getObjectsByKey(item, "special_function");
        //   //   if (specialFunction && specialFunction.length) {
        //   //     //comboUpdated

        //   // }
        if (item && addProp.updateItem.update) {
          var f = {};
          const guid = fun.guid;
          try {
            f = eval(addProp.updateItem.update);
          } catch (error) {
            //
          }

          if (!f[this.addMenuButton.fromItem]) {
            f[this.addMenuButton.fromItem] = val;
          }
          // if (this.defaultModel) {
          //   Object.keys(f).forEach((k) => {
          //     if (!f[k]) {
          //       f[k] = this.defaultModel[k];
          //     }
          //   });
          // }
          this.defaultModel = {
            ...this.defaultModel,
            ...f
          };
        } else {
          this.defaultModel[this.addMenuButton.fromItem] = val;
        }
        // }
        // this.data_object.schema.properties[this.addMenuButton.fromItem]["v-bind"];
        if (addQty) {
          var uniqProp = ["_id"];
          Object.keys(this.schema.properties).forEach(k => {
            if (this.schema.properties[k].uniqPar) {
              uniqProp.push(k);
            }
          });
          var matchingRec = this.findFirstSameRecord(this.defaultModel, uniqProp);

          if (matchingRec) {
            matchingRec.qty += 1;
            this.tableKey = !this.tableKey;
            // this.getCalculatedFields();
          }

          return;
        }
        var newRow = this.addRow(rec);
        if (edit) {
          this.editCurrentRecord(newRow);
        }
        this.getCalculatedFields();
        if (addProp.updateItem.checkCustomFunction) {
          this.$root.$emit("comboUpdated", {
            obj: this,
            objName: rec.objName,
            model: rec,
            formModel: newRow
          });
          return;
        }
      }
    },
    sameExcept(recA, recB, uniqProp = []) {
      const skip = new Set(uniqProp);

      // Only keys from recB matter
      const keysB = Object.keys(recB).filter(k => !skip.has(k));

      return keysB.every(k => recA[k] === recB[k]);
    },

    findFirstSameRecord(rec, uniqProp = []) {
      return this.table.find(row => row !== rec && this.sameExcept(row, rec, uniqProp)) || null;
    },

    scrollToEdited(newRow) {
      var that = this;
      if (that.scrollOnNew) {
        that.$nextTick(() => {
          var ref = that.scrollOnNew + newRow._id;
          if (ref) {
            try {
              const el = that.$refs[that.scrollOnNew][0].$el;
              if (el) {
                var elem = el.closest("tr").previousElementSibling || el.closest("tr");
                elem.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                  // inline: "start",
                });
              }
            } catch (error) {
              //
            }
            //
          }
        });
      }
    },
    addRow(rec, noScroll) {
      this.errorMessage = "";
      this.editMode = false;
      this.insertMode = true;
      // this.navigate("last");

      // var valid = true;
      var newRow = {};
      var that = this;
      that.newRowId = "";
      var addRow = function(valid) {
        if (!valid) {
          return;
        }
        // that.navigate("last");
        if (that.$refs.removeGroup) {
          that.$refs.removeGroup.$el.click();
        }

        // this.defaultFilteredItem() ||
        if (that.defaultModel) {
          newRow = fun.clone(that.defaultModel);
        } else {
          newRow = that.getDefaults(newRow);
        }
        if (that.filteredTabItems.length) {
          // var f = !that.hideAllTabFilter
          //   ? that.currentFilter - 1
          //   : that.currentFilter;
          var f = that.currentFilter;
          var curFilter = that.filteredTabItems[f];
          if (curFilter) {
            newRow[curFilter.name] = curFilter.value;
          }
        }
        newRow._id = fun.guid();
        that.newRowId = newRow._id;
        that.page = that.pageCount;
        if ((that.originalRecords.length + 1) / that.itemsPerPageEdited || 10 > that.page) {
          // that.page += 1;
          that.navigate("next");
        }
        if (!that.table.length) {
          that.table.push(newRow);
        } else {
          that.table.unshift(newRow);
          // that.tableKey = !that.tableKey;

          that.originalRecords.unshift(newRow);
        }

        if (that.updateNestedArray) {
          that.update.add.push(newRow);
        }

        that.$root.$emit("rowAdded", {
          tbl: that,
          row: newRow,
          rec: rec
        });
        if (!noScroll) {
          that.scrollToEdited(newRow);
        }

        return newRow;
      };
      if (that.newRowId) {
        var valid = that.validateEntry(that.newRowId, true, valid => {
          addRow(valid);
        });
      } else {
        addRow(true);
      }

      this.tableKey = !this.tableKey;
      return newRow;
      // this.insertMode = false;
    },
    blankRow(rowChanged) {
      var that = this;
      if (!this.table.length) {
        this.table = [];
      }
      this.newRow = {};
      var addRow = function() {
        var newRow = {};
        if (that.defaultModel) {
          newRow = fun.clone(that.defaultModel);
        }
        if (that.filteredTabItems.length) {
          var curFilter = that.filteredTabItems[that.currentFilter];
          newRow[curFilter.name] = curFilter.value;
        }
        if (that.editedItem && that.editedItem.defaultFn) {
          that.defaultItem = that.editedItem.defaultFn(that);
        }

        that.table.push(newRow);
        that.originalRecords.push(newRow);
        that.insertedRow = newRow;
        that.editDialog = true;
      };
      if (this.groupBy.length && this.table.length > 0) {
        this.newRow[this.groupBy] = this.table[this.table.length - 1][this.groupBy];
      }
      var blankRow = this.table.filter(r => {
        return !r._id;
      });

      if (!blankRow.length || rowChanged) {
        this.newRowInserted = true;

        this.insertedRow = this.table[this.table.length - 1];
        if (rowChanged) {
          this.insertedRow._id = fun.guid();
          addRow();
        } else {
          addRow();
        }
      }
    },
    resetFocus() {
      var that = this;
      var currentInput = document.activeElement;

      if (currentInput) {
        var td = currentInput.closest("td");
        if (td) {
          var tr = td.closest("tr");
          var tdArray = Array.from(tr.querySelectorAll("td"));
          var indexCol = tdArray.findIndex(column => column == td);
          var h = that.computedHeaders[indexCol - 2];

          var indexRow = this.$refs[h.value].length - 1;
          try {
            var input = this.$refs[h.value][indexRow].$el.querySelectorAll("input")[0];
            input.focus();
          } catch (error) {
            console.log(error);
          }
        }
      }
    },
    blankItem(isNew, clear) {
      if (this.editedItem) {
        var that = this;
        var edit = this.$refs.edit_combo;
        var newItem = {};

        if (this.editedItem.defaultFn) {
          this.defaultItem = this.editedItem.defaultFn(this);
        }
        if (this.editedItem.modelFn) {
          newItem = this.editedItem.modelFn({
            r: null,
            tbl: that,
            defaultItem: this.defaultItem || {},
            isNew: false,
            schema: this.data_object.schema,
            formModel: this.formModel
          });
        }
        if (!this.table.length) {
          this.table = [];
        }
        if (
          Array.isArray(this.table) &&
          !this.table.filter(function(r) {
            return r && !r._id;
          }).length
        ) {
          if (edit) {
            edit.resetModel();
          }

          // this.moveFocus();
        }
      }
    },
    navigate(dir) {
      if (dir == "next") {
        this.page += 1;
      }
      if (dir == "prev") {
        this.page -= 1;
      }
      if (dir == "last") {
        this.page = this.pageCount;
      }
      if (dir == "first") {
        this.page = 1;
      }
      if (this.doServerPagination) {
        var paginationProperties = {
          pageCount: this.pageCount,
          page: this.page,
          itemsLength: this.itemsCount,
          pageStart: this.pageStop + 1,
          pageStop: this.pageStop + this.perPage,
          itemsPerPage: this.perPage,
          navigate: true
        };
        this.onPagination(paginationProperties);
      }
    },
    changeFilterTab(ev) {
      // console.log(ev);
      if (!ev) {
        this.table = this.originalRecords;
        // this.$refs.dTable["disable-pagination"] = false;
        // this.$refs.dTable["items-per-page"] = 20;
      } else {
        // this.$refs.dTable["disable-pagination"] = this.editDisablePagination;
        // this.$refs.dTable["items-per-page"] = this.itemsPerPageEdited;
        this.filterItems.forEach((el, i) => {
          if (el.value == ev) {
            this.currentFilter = i;
          }
        });
      }
    },
    onScroll(e) {
      // debounce if scrolling fast
      this.timeout && clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        const { scrollTop } = e.target;
        const rows = Math.ceil(scrollTop / this.rowHeight);

        this.start = rows + this.perPage > this.desserts.length ? this.desserts.length - this.perPage : rows;

        this.$nextTick(() => {
          e.target.scrollTop = scrollTop;
        });
      }, 20);
    },
    toggleGroup(openGroup) {
      var that = this;
      Object.keys(this.$refs).forEach(k => {
        if (k.startsWith("openGroup")) {
          var groupName = k.split("_")[1];
          if (groupName != openGroup) {
            if (that.$refs[k]) {
              that.$refs[k].$el.click();
            }
          }
        }
        if (that.$refs["closeGroup_" + openGroup]) {
          that.$refs["closeGroup_" + openGroup].$el.click();
        }
      });
    },
    moveFocus(r) {
      var that = this;
      try {
        var observer = new MutationObserver(function(mutations) {
          var rowCount = that.countVisibleRows();
          var nextCtl = document.querySelectorAll('input[k="' + that.editedItem.nextCtl + '"]');

          if (nextCtl.length && nextCtl.length == rowCount) {
            var rowIndex = nextCtl.length - 1;

            if (that.isNew) {
              observer.disconnect();
              var clearBtn = that.$refs.edit_combo.$el.getElementsByTagName("button");
              that.toggleGroup(r[that.groupBy]);
              if (clearBtn.length) {
                clearBtn[0].click();
              }
            }
          }
        });

        observer.observe(document.body, {
          characterDataOldValue: true,
          subtree: true,
          childList: true,
          characterData: true
        });
      } catch (error) {
        //
      }
    },

    saveRecord(model, isNew) {
      this.errorMessage = "";
      Object.keys(this.schema.properties).forEach(k => {
        if (this.schema.properties[k].loadOnDemand && !this.schema.properties[k].keepOnSave) {
          delete model[k];
        }
      });
      var newModel = fun.clone(model);
      var that = this;

      var m = {};
      m._id = undefined;

      var _id = isNew ? undefined : model._id;
      var alwaysUpdate = false;

      var data_object = this.data_object;

      if (data_object.parent_object) {
        if (that.parentModel) {
          alwaysUpdate = data_object.parent_object.alwaysUpdate;
          _id = that.parentModel._id;
        } else {
          if (that.formModel) {
            _id = that.formModel._id;
            m._id = data_object.parent_object._id;
          }
        }
        if (isNew) {
          model._id = fun.guid();
        }

        var childrenPath = data_object.parent_object.children_path;

        var path_ids = [];
        var path = "";
        childrenPath.forEach((p, i) => {
          if (i > 0) {
            path_ids.push({
              name: childrenPath[i - 1],
              _id: that.formModel._id
            });

            path += ".$." + p;
          } else {
            path = p;
          }
        });
        data_object.parent_object.path_ids = path_ids;
        data_object.parent_object.path = path;
      }

      if (this.beforeAddData) {
        var doNotSubmit = this.beforeAddData(model, this);
        if (doNotSubmit) {
          return false;
        }
      }
      // if (that.schema["v-bind"].getObject) {
      //   var r = model;
      //   this.data_object.object_name = eval(that.schema["v-bind"].getObject);
      // }
      var data = {
        metadata: this.data_object,
        update: that.update,
        model: model,
        _id: _id
      };

      // this.dialog = false;
      if (isNew) {
        data.metadata.add_record_to_table = true;
      }

      if ((this.alwaysUpdate || alwaysUpdate) && (Object.keys(data.model).length || data.model.length)) {
        alwaysUpdate = this.alwaysUpdate;
        // this.loading = true;
        // if (!data._id) {

        //   return;
        // }
        Object.keys(data.model).forEach(k => {
          if (data.model[k] == undefined) {
            data.model[k] = null;
          }
        });
        axios
          .post(this.serverURL + "/add_data", data, {
            withCredentials: true
          })
          .then(function(response) {
            that.loading = false;
            that.successMessage = response.data.msg;
            if (data.metadata.add_record_to_table && !alwaysUpdate) {
              data.metadata.add_record_to_table = false;
              that.loadFromDb();
            }
            that.$root.$emit("record_updated", {
              data_object: that.data_object,
              model: newModel,
              tbl: that
            });
            if (that.afterSave) {
              that.afterSave(that, newModel);
              if (that.rowClick) {
                that.rowClick(newModel);
              }
            }

            if (that.refreshAfterSubmit) {
              that.tableMount();
              // setTimeout(that.refresh(), 200);
              // that.tableMount();
              // that.getData();
              that.refreshTable();
              //
            }
          });
      } else {
        this.table.push(model);
        this.originalRecords.push(model);
        this.page = this.pageCount;

        this.$root.$emit("tableUpdated", model, !alwaysUpdate);
      }
    },
    convertArray(jsArray) {
      let convertedArray = jsArray.map(([field, order]) => {
        return `("${field}", ${order})`;
      });
      return convertedArray;
    },

    loadFromDb(noInit) {
      // if (!this.data_object) {
      //   return;
      // }
      var that = this;
      if (!this.qry) {
        // edited records

        if (
          this.remoteSearch ||
          // (
          this.doServerPagination
        ) {
          this.data_object.object_name =
            this.data_object.remote_search_object || this.data_object.object_name || this.object_name;
          if (this.remoteSearch && !this.search) {
            this.tableReady = false;
            this.loading = false;

            this.data_object.qry = fun.clone(this.initialQry);

            if (!this.data_object.object_name) {
              this.data_object.object_name = this.object_name;
            }
            // return;
          } else if (!this.data_object?.pipeline) {
            this.data_object.qry = this.buildSearchQuery();

            if (this.data_object.qry) {
              this.data_object.aggregate = null;
            }
          }
        }
        if (this.data_object && this.data_object.schema && !this.data_object.object_name) {
          var d = this.data_object.schema["v-bind"];
          Object.keys(d).forEach(k => {
            this.data_object[k] = d[k];
          });
        }
        if (this.tabQry) {
          if (this.data_object.qry.$and) {
            this.data_object.qry.$and.push(this.tabQry);
          } else {
            this.data_object.qry = this.tabQry;
          }
        }

        if (this.assistantQry) {
          try {
            this.assistantQry = fun.preprocessJsonForMongoDB(this.assistantQry);
          } catch (error) {
            // console.log(error);
          }
          this.data_object.qry = fun.combineMongoQueries(this.data_object.qry, this.assistantQry);
        }

        if (this.data_object && this.data_object.qry && this.data_object.defaultValue) {
          this.data_object.qry = {
            ...this.data_object.qry,
            ...this.data_object.defaultValue
          };
        }
        if (this.data_object && this.data_object.qryFn) {
          var par = this.parentObject;
          this.data_object.qry = eval(this.data_object.qryFn);
        }

        if (this.doServerPagination && !this.editDisablePagination) {
          var itemsPerPage = this.itemsPerPage || 50;
          var pageStart = this.currentPage * this.itemsPerPageEdited - this.itemsPerPageEdited || 0;
          var pageStop = pageStart + itemsPerPage;

          this.data_object.pagination = {
            pageCount: this.pageCount,
            currentPage: this.currentPage,
            pageStart: pageStart,
            pageStop: pageStop,

            itemsPerPageEdited: this.itemsPerPageEdited || itemsPerPage,
            totalRecords: this.itemsCount
          };
          if (this.itemsCount && this.data_object.pagination.pageStart >= this.itemsCount) {
            return;
          }
          this.data_object.pagination.pageStop =
            parseInt(this.data_object.pagination.pageStart) + parseInt(this.itemsPerPageEdited || itemsPerPage);

          // this.data_object.sort = this.convertArray(this.sortCriteria);
          this.data_object.sort = this.sortCriteria;
        }
        if (!this.editDisablePagination) {
          if (this.data_object) {
            this.data_object.per_page = this.itemsPerPage;
          }
        } else {
          this.pagination = {};
          if (this.data_object) {
            this.data_object.per_page = null;
            this.data_object.pagination = {};
          }
        }

        if (this.data_object && this.defaultModel) {
          this.data_object.default_model = this.defaultModel;
        }
        if (this.maxRecords || this.serverPagination) {
          this.data_object.max_records = this.maxRecords;
          this.data_object.sort = this.currentSortBy[0] || this.sortBy;
          this.data_object.sort_desc = this.currentSortBy[0] ? this.currentSortDesc[0] : this.sortDesc;
        }
      } else {
        this.data_object.qry = this.qry;
      }
      if (this.groupQry) {
        let andArr = this.data_object.qry["$and"] || [];

        const newKey = Object.keys(this.groupQry)[0];

        // 1️⃣ remove empty placeholders: {}
        andArr = andArr.filter(cond => cond && typeof cond === "object" && Object.keys(cond).length > 0);

        // 2️⃣ remove existing conditions with same top-level key
        andArr = andArr.filter(cond => Object.keys(cond)[0] !== newKey);

        // 3️⃣ add new groupQry
        andArr.push(this.groupQry);

        // 4️⃣ reassign (Vue reactivity-safe)
        this.data_object.qry["$and"] = andArr;
        console.log(this.data_object.qry["$and"]);
      }

      this.loading = true;
      var t = new Date();
      if (!this.data_object.additional_data) {
        this.data_object.additional_data = [];
      }
      if (this.tableName) {
        this.data_object.additional_data.push({
          obj_name: "columns",
          qry: {
            table_name: this.tableName.toLowerCase(),
            user_id: this.$root.user_id
          }
        });
        this.data_object.additional_data.push({
          obj_name: "custom_qry",
          qry: {
            table_name: this.tableName.toLowerCase(),
            user_id: this.$root.user_id
          }
        });
      }
      if (this.data_object.pipeline) {
        this.data_object.date_fields = this.dateFields;
      }
      if (this.groupByDataObjects) {
        this.groupByDataObjects.forEach(g => {
          if (g.objectName) {
            var exist = this.data_object.additional_data.find(a => {
              return a.obj_name == g.objectName;
            });
            if (!exist) {
              this.data_object.additional_data.push({
                obj_name: g.objectName,
                db_name: g.db_name
              });
            }
          }
        });
      }
      axios
        .post(this.serverURL + "/get_data", this.data_object, {
          withCredentials: true
        })
        .then(response => {
          this.loading = false;
          var data = response.data;
          this.serverPaginationDone = true;

          this.additionalModel = data.additional_model;
          if (
            this.additionalModel &&
            this.additionalModel.employee &&
            this.additionalModel.employee.length &&
            this.additionalModel.employee[0].custom_filter
          ) {
            this.additionalTabs = this.additionalModel.employee[0].custom_filter;
          }
          if (data.schema["v-bind"]) {
            Object.keys(data.schema["v-bind"]).forEach(k => {
              that[k] = data.schema["v-bind"][k];
            });
          }
          if (data.total_records) {
            this.itemsCount = data.total_records || data.model.length;
            if (this.itemsCount > data.model.length) {
              this.doServerPagination = true;
            }
          }

          if ((!data.table || !data.table.length) && data.model && data.model.length) {
            data.table = data.model;
          }
          if (that.data_object.data_property) {
            data.table = response.data.model[0][that.data_object.data_property];
            if (!data.table.length) {
              data.table = data.model;
            }
            if (!data.table.length) {
              data.table = [];
            }
            that.originalRecords = fun.clone(data.table);
          }
          if (that.data_object.addField) {
            var template = data.schema.properties[that.data_object.addField].template;
            that.schema = data.schema;

            if (data.table.length) {
              data.table.forEach(r => {
                var d = that.getTemplate(r, {
                  name: that.data_object.addField
                });
                r[that.data_object.addField] = d;
              });
            }
            that.table = data.table;
            if (that.formModel) {
              that.formModel[that.data_object.addField] = that.table;
            }

            that.originalRecords = fun.clone(data.table);
          }
          if (that.onDataReceived) {
            data = that.onDataReceived(response.data, this);
            that.originalRecords = fun.clone(data.table);
          }

          that.addTableKey = !that.addTableKey;
          if (that.defaultModel && data.table) {
            data.table.forEach(r => {
              Object.keys(that.defaultModel).forEach(k => {
                if (!r[k]) {
                  r[k] = that.defaultModel[k];
                }
              });
            });
          }
          var currentPage = fun.clone(this.page);

          if (!noInit) {
            that.initTable(data);
          }

          that.getGroupBy();
          if (this.startExpanded) {
            that.expandAll();
          }

          if (this.editedId && !this.noEditCurrentRecord && data.table[0]._id == this.editedId) {
            this.editCurrentRecord(data.table[0]);
          }
          this.hideHeaders();

          this.pagerKey = !this.pagerKey;
          this.tabKey = !this.tabKey;
        })
        .catch(r => {
          // console.log(r);
        })
        .finally(() => {
          that.loading = false;
        });
    },

    getObjects(obj, key, val) {
      return fun.getObjects(obj, key, val);
    },
    assignId() {
      var that = this;
      if (this.table.length) {
        this.table.forEach((r, i) => {
          if (!r._id) {
            if ((that.tableInsertable && i != that.table.length - 1) || !that.tableInsertable)
              // r._id = fun.guid();
              that.table[i]._id = fun.guid();
          }
        });
      }
    },
    deleteCustomFilter(item) {
      this.$root.$confirm
        .open("Delete Custom Filter", "Confirm deleting " + item.value + "?", {
          color: "red"
        })
        .then(confirm => {
          if (confirm) {
            var filterName = "custom_filter." + item.value;
            var unset = {};
            unset[filterName] = "";

            var data = {
              object_name: "employee",
              qry: {
                "contact.email": this.$root.user_email
              },
              new_data: {
                $unset: unset
              }
            };

            axios
              .post(this.serverURL + "/update_record", data, {
                withCredentials: true
              })
              .then(response => {
                this.successMessage = "successfully removed " + item.value;
                delete this.additionalTabs[item.value];
                this.filterItems = this.filterItems.filter(obj => obj.value !== item.value);
                this.updateAdditionalTabs();

                console.log(this.filteredTabItems);
                // this.tabKey = !this.tabKey;
              });
          }
        });

      //
    },
    getGroupBy() {
      if (this.groupByItems && !this.noGroups) {
        this.groupByItems = this.groupByItems.sort();
        this.groupByItemsReady = true;
      }
    },
    buildSortCriteria() {
      this.sortCriteria = this.currentSortBy.map((sortField, index) => {
        return [sortField, this.currentSortBy[index] ? -1 : 1];
      });

      console.log("Sort Criteria:", this.sortCriteria);
      if (this.doServerPagination) {
        this.loadFromDb();
      }
    },
    getSortBy(newSortBy) {
      if (newSortBy.length) {
        this.currentSortBy = newSortBy;
        this.buildSortCriteria();
      }
    },
    getSortDesc(newSortDesc) {
      this.currentSortDesc = newSortDesc;
      this.buildSortCriteria();
    },
    closeDialog(d) {
      this.editValue = null;
      this.$refs[d][0].cancel();
    },
    getField(props, field) {
      if (!this.schema.properties) {
        return;
      }
      if (!field.name) {
        field = {
          name: field
        };
      }
      var val = this.getTemplate(props.item, field);
      if (fun.isJSON(val)) {
        return "";
      }
      if (val) {
        return val;
      }
      if (this.schema.properties[field.name] && this.schema.properties[field.name]["x-display"] == "v-switch") {
        return props.item[field.name]
          ? "<span style='color:green'><b>(Yes)</b></span>"
          : "<span style='color:red'><b>(No)</b></span>";
      }

      var title = field.title || this.capitalize(field.name);
      if (field["v-bind"]) {
        if (field["v-bind"].itemText && field["v-bind"].returnObject && props.item[field.name]) {
          val = props.item[field.name][field["v-bind"].itemText];
          if (field["v-bind"].capitalizeText) {
            return this.capitalize(val);
          } else {
            return val;
          }
        } else {
          val = props.item[field.name];
          if (field["v-bind"].capitalizeText) {
            return this.capitalize(props.item[field.name]);
          } else {
            return props.item[field.name];
          }
        }
      } else {
        if (field["v-bind"] && field["v-bind"].itemText && field["v-bind"].returnObject) {
          val = props.item[field.name][field["v-bind"].itemText];
          if (val) {
            return val;
          } else {
            val = this.getFieldDisplay(field, title);
            return val;
          }
        } else {
          if (
            this.schema.properties[field.name] &&
            this.schema.properties[field.name].displayProperty &&
            props.item[field.name]
          ) {
            val = props.item[field.name][this.schema.properties[field.name].displayProperty];

            if (!val) {
              val = this.getFieldDisplay(field, title);
            }
            return val;
          } else {
            val = props.item[field.name];

            if (!val || (typeof val == "object" && !val.length)) {
              val = this.getFieldDisplay(field, title);
            }

            return val;
          }
        }
      }
    },
    getFieldDisplay(field, title) {
      var val = "";
      if (!this.schema.properties[field.name]) {
        return;
      }
      if (this.schema.properties[field.name]["x-type"] == "number") {
        val = 0;
      } else if (this.schema.properties[field.name]["x-display"] == "v-cc") {
        val = "";
      } else {
        val = "(No " + title + ")";
      }
      return val;
    },
    sortedDraggedObjects(item) {
      if (this.droppedObjectsSortProperty) {
        this.droppedObjects.forEach((obj, i) => {
          const path = this.droppedObjectsSortProperty;

          const exists = path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj) != null;

          if (!exists) {
            fun.setNested(obj, path, i + 1);
          }
        });
      }

      let sortedObjects = (this.droppedObjects || [])
        .filter(f => {
          return f[this.droppedObjectFilterProperty] && f[this.droppedObjectFilterProperty]._id == item._id;
        })
        .sort((a, b) => {
          const aValue = eval(`a.${this.droppedObjectsSortProperty}`) || 0;
          const bValue = eval(`b.${this.droppedObjectsSortProperty}`) || 0;
          return aValue - bValue;
        });
      if (!sortedObjects.length) sortedObjects = [{}];
      return sortedObjects;
    },
    droppedObjectDragStart(index) {
      this.dragIndex = index;
    },
    droppedObjectDragOver(index) {
      // optional: highlight target row
    },
    droppedObjectDropRow(toIndex, item) {
      if (this.dragIndex === null || this.dragIndex === toIndex) return;
      const parItem = item[this.droppedObjectFilterProperty];

      const list = this.sortedDraggedObjects(parItem);

      const moved = list.splice(this.dragIndex, 1)[0];
      list.splice(toIndex, 0, moved);

      // update load_order
      list.forEach((row, i) => {
        fun.setNested(row, this.droppedObjectsSortProperty, i + 1);
      });

      // notify parent if needed
      this.sortedDraggedObjectsOnRowReorder?.(item, list);

      this.dragIndex = null;
    },
    getDefaultDataObject() {
      if (!this.originalRecords.length && this.defaultDataObject) {
        axios
          .post(this.serverURL + "/get_data", this.defaultDataObject, {
            withCredentials: true
          })
          .then(response => {
            var data = response.data;
            this.originalRecords = data.model;
            this.table = this.originalRecords;
          })
          .catch(r => {
            console.log(r);
          });
      }
    },
    getData() {
      var that = this;

      if (this.editData && this.editData.length) {
        this.table = this.editData;
        this.itemsCount = this.editData.length;

        if (!this.alwaysUpdate) {
          this.getFreshData = false;
        }
      } else if (
        this.vModel &&
        Array.isArray(this.vModel)
        //  &&
        // this.vModel.length
      ) {
        this.originalRecords = this.vModel;
        this.table = this.originalRecords;
        if (!this.table.length && !this.getFreshData && this.data_object.schema.default_values) {
          this.originalRecords = this.data_object.schema.default_values;
          this.table = this.originalRecords;
          this.getDefaultDataObject();
        }
      } else if (this.data_object && this.data_object.model) {
        this.table = this.data_object.model;
        if (!Array.isArray(this.data_object.model)) {
          this.table = [];
        }
      }
      if (this.table.length) {
        if (!this.itemsCount) {
          this.itemsCount = this.table.length;
        }
        this.table.forEach(r => {
          if (r && !r._id) {
            r._id = fun.guid();
          }
        });
      }
      if (this.beforeGetData) {
        this.beforeGetData(this.data_object);
      }

      if (this.getFreshData) {
        this.loadFromDb();
      } else {
        this.getTableProperties(this.data_object);
        if (this.singleSelect && !this.selected.length) {
          this.selected.push(this.table[0]);
        }
        this.doTabs(this.currentFilter);
        this.getGroupBy();
        this.getDefaultDataObject();
        this.getUploadFields();

        this.addTableKey = !this.addTableKey;
      }
      this.getCalculatedFields();
      if (this.initialData && this.groupBy) {
        var groupBy = that.groupBy;
        this.initialData.forEach((d, i) => {
          var groupExist = that.table.filter(c => {
            return d[groupBy] == c[groupBy] && !c._id;
          });
          if (!groupExist.length && !this.editedItem) {
            var r = {};
            r[groupBy] = d[groupBy];
            that.table.push(r);
          }
        });
      }

      this.formObject.schema = this.schema;
      this.formObject.model = this.model;
      if (this.formModel) {
        this.formModel[this.k] = this.table;
        // this.formModel[this.k] = this.table;
      }
      if (this.data_object && this.data_object.schema) {
        this.expandedObjects = fun.getObjects(this.data_object.schema.properties, "in_expand", true);
      }
      if (this.schema["v-bind"] && this.schema["v-bind"].sort) {
        var sort = this.schema["v-bind"].sort;
        this.sortTable(sort);
      }
      if (!this.originalRecords.length) {
        this.originalRecords = fun.clone(this.table);
      }
    },
    hideCtl(c) {
      // console.log(c);
      if (c.hideIf) {
        var p = this.formModel;
        return eval(c.hideIf);
      }
      return false;
    },
    resetNewRow() {
      this.errorMessage = "";
      this.table.splice(0, 1);
    },
    selectCtl(e) {
      console.log(e);
    },
    sortTable(sort) {
      this.table.sort((a, b) => {
        return a[sort] - b[sort];
      });
    },
    getFilterParams(obj) {
      if (obj.filterTabs) {
        this.filterItems = obj.filterTabs;
      }
    },
    autoAssign() {
      var wasAssigned = false;
      this.table.forEach((r, i) => {
        Object.keys(this.schema.properties).forEach(k => {
          if (this.schema.properties[k].autoAssign && !r[k]) {
            r[k] = i + 1;
            if (this.schema.properties[k].prefix) {
              var prefix = eval(this.schema.properties[k].prefix);
              r[k] = prefix + "-" + r[k];
            }

            wasAssigned = true;
          }
        });
      });
      if (wasAssigned) {
        this.submit();
      }
    },
    isNewGroup(prop) {
      // console.log(prop);
      var displayGroup = false;
      if (typeof prop["group"] == "string") {
        if (!this.prevGroup || this.prevGroup != prop["group"]) {
          displayGroup = true;
        }
      }
      if (typeof prop["group"] == "object") {
        if (!this.prevGroup || this.prevGroup._id != prop["group"]._id) {
          displayGroup = true;
        }
      }
      // this.prevGroup = prop["group"];
      return displayGroup;
    },
    getUploadFields() {
      this.uploadFields = [];
      try {
        Object.keys(this.schema.properties).forEach(p => {
          if (this.schema.properties[p].upload) {
            if (!this.schema.properties[p].upload_fields) {
              this.uploadFields.push(p);
            } else {
              this.schema.properties[p].upload_fields.forEach(u => {
                this.uploadFields.push(u);
              });
            }
          }
        });
      } catch (error) {
        console.log(error);
      }

      if (this.uploadFields.length) {
        this.hasUpload = true;
        this.toolbarKey = !this.toolbarKey;
        this.uploadFieldsTitle = this.uploadFieldsInitialTitle + " " + this.uploadFields.join(", ");
      }
    },
    initTable(data) {
      var that = this;
      if (!this.schema) {
        return;
      }

      if (!this.table || !this.table.length || (data && data.model && data.model.length)) {
        if (data.model && data.model.length) {
          this.table = data.model;
        } else if (data.table && data.table.length) {
          this.table = data.table;
        } else {
          this.table = [];
        }
      }
      if (data.total_records && this.itemsPerPageEdited) {
        this.pageCount = Math.ceil(data.total_records / this.itemsPerPageEdited);
        this.itemsLength = data.total_records;
        this.pageStart = 1 + this.itemsPerPageEdited * (this.currentPage - 1);
        this.pageStop = this.pageStart + this.itemsPerPageEdited - 1;
        if (this.pageStop > data.total_records) {
          this.pageStop = data.total_records;
        }
        // this.currentPage += 1;
      }
      var table = this.table;
      this.schema = data.schema;
      this.getUploadFields();
      this.initEdited();
      if (data.table && !this.editData) {
        this.table = data.table;
        if (this.dList) {
          this.editData = this.table;
        }
      } else {
        this.table = table;
      }

      this.groupBy = data.groupBy || [];
      this.headers = data.headers;

      this.getDefaults();

      if (this.ajustTableSchema) {
        this.ajustTableSchema(this);
      }

      this.getAllEditable();
      if (this.dExcel) {
        this.excelKey = !this.excelKey;
      }
      try {
        this.filterHeaders();
      } catch (error) {
        //
      }
      this.getSearchTabs();

      try {
        this.getColumns();
      } catch (error) {
        //
      }

      this.setTotals();
      // this.getCalculatedFields();
      if (this.singleSelect && !this.selected.length && !this.getFreshData) {
        this.selected.push(this.table[0]);
      }
      if (this.selectedId) {
        var selRec;
        this.table.forEach((r, i) => {
          if (r._id == this.selectedId) {
            selRec = i;
          }
        });
        this.selected.push(this.table[selRec]);
      }

      if (data.schema && data.schema["v-bind"]) {
        var vBind = data.schema["v-bind"];
        Object.keys(vBind).forEach(k => {
          that[k] = vBind[k];
        });
        this.tableEditRow = this.editRow && !this.noEditRow;
        var filterTabsFn = vBind.filterTabsFn || this.filterTabsFn;

        if (filterTabsFn) {
          this.filterTabsFn = filterTabsFn;
          // if (vBind.initialHideHeaders) {
          //   vBind.initialHideHeaders.forEach((h) => {
          //     this.computedHeaders[h].hidden = true;
          //   });
          // }
          this.doTabs(this.currentFilter);
        }
        if ((vBind.filterTabs && !this.filteredTabItems) || !this.filteredTabItems.length) {
          this.originalRecords = table;
          this.getFilterParams(vBind);
        } else {
          this.autoAssign();
        }
      }

      if (this.editRecord) {
        this.editRecord(this);
      }

      if (this.schema && this.schema.properties && this.schema.properties["color"]) {
        if (!this.model.length) {
          this.getDefaultColor();
        }
      }
      if (this.sortBy) {
        fun.sortArrayOfObjectsByProperties(this.table, this.sortBy);
      }
      this.originalRecords = fun.clone(this.table);
      this.tableReady = true;
      this.propertyList = [];
      Object.keys(this.schema.properties).forEach(k => {
        this.propertyList.push(k);
      });
      if (this.startExpanded) {
        this.expandAll();
      }
      // this.applyFilter();
      this.$nextTick(this.attachHoverListeners);
      this.$root.$emit("initTable", this);
    },
    getSearchTabs() {
      var advancedSearchFields = [];
      var searchTabs = [];
      Object.keys(this.schema.properties).forEach(k => {
        var f = this.schema.properties[k];

        if (f.filter) {
          advancedSearchFields.push(f);
          if (f.searchTab) {
            searchTabs.push(f.searchTab);
          }
        }
      });
      console.log(advancedSearchFields);
    },
    convertAssistantQry() {
      if (this.assistantQry) {
        return fun.mongoToSqlLike(this.assistantQry);
      }
    },
    resetAssistantQry() {
      this.assistantQry = null;
      this.itemsCount = 0;
      this.qryExplanation = "";

      this.loadFromDb();
    },
    buildCustomQueryPrompt() {
      const that = this;
      // var prompt =
      //   "Based on the description build a mongo query for collection called 'shipments' that have fields " +
      //   this.propertyList.toString() +
      //   ". Only use those properties. Find fields logically. Do not query fields that not requested in user prompt. Use lower case for strings.  Provide the response in JSON format.";
      this.qryExplanation = "";
      // this.assistantVBind.customInstructions = this.assistant?.assistant_instructions;
      //
      // this.$root.aiDrawer = true;
      if (this.assistant?.noStreaming) {
        //open assistant in dialog for queick tasks
        this.assistantModel = true;
      } else {
        let app = fun.getParentByProperty(this, "aiDrawer"); //opoen asistant at the right panel

        let aiChat = app.$refs.aiChat;
        app.aiDrawer = true;

        this.$nextTick(() => {
          aiChat.hideAssistantsList = true;
          aiChat.hideThreads = false;
          aiChat.hideNewChat = true;
          app.aiChatVBind = that.assistant;
          try {
            const par = fun.getParentByProperty(that, that.assistant.getData);
            if (par) {
              app.aiChatVBind.getData = par[that.assistant.getData];
            }
          } catch (error) {
            //
          }

          // aiChat["v-bind"] = that.assistant;

          app.aiChatKey = !app.aiChatKey;
        });
      }

      return prompt;
    },
    initEdited(id) {
      if (this.noInitEdit) {
        return;
      }
      if (!id && this.$route.params.id && fun.isNumericOrObjectId(this.$route.params.id)) {
        id = this.$route.params.id;
      }
      if (!id && this.$route.params.qry && fun.isNumericOrObjectId(this.$route.params.qry)) {
        id = this.$route.params.qry;
      }
      if (this.$route.params.id == "_new") {
        id = 0;
      }
      if (this.$route.params.id && this.$route.params.id.split("-")[0] == "0") {
        id = 0;
        this.initialId = this.$route.params.id.split("-")[1];
      }

      if (id === 0 && !this.noEditCurrentRecord) {
        this.editCurrentRecord();
        return;
      }
      if (!id) {
        return;
      }

      var idField = this.idField || "_id";
      if (this.$route.path.includes("storage")) {
        idField = "_id";
      }
      this.editedId = id;
      if (this.maxRecords) {
        this.data_object.qry = { _id: this.editedId };
      }
      this.tableEditRow = this.editRow;
      if (id && this.tableEditRow && !this.$route.path.includes("settings")) {
        if (!this.$route.path.includes("storage") && !this.$route.path.includes("customers")) {
          this.editedId = id.toString().split(":")[0];
          // } else {
        }
        if (this.getFreshData) {
          this.qry = {};
          this.qry[idField] = this.editedId;
          this.loadFromDb(true);
        }

        // if (!this.maxRecords) {
        //   var curRec = this.originalRecords.filter((r) => {
        //     return r[idField] == this.editedId;
        //   });
        //   if (this.getFreshData && curRec[0]) {
        //     this.editCurrentRecord(curRec[0]);
        //   }
        //   // } else {

        //   // axios
        //   //   .post(this.serverURL + "/get_data", this.data_object, {
        //   //     withCredentials: true,
        //   //   })
        //   //   .then((response) => {
        //   //     var data = response.data;
        //   //     this.editCurrentRecord(data.model[0]);
        //   //   });
        //   //
        // }
      }
    },
    getDefaultColor() {
      var edited = false;
      this.table.forEach(t => {
        if (!t["color"]) {
          t["color"] = "#" + fun.randomColor();
          edited = true;
        }
      });
      if (edited) {
        this.submit();
      }
    },
    doTabs(curFilter) {
      var that = this;
      if (this.filterTabs) {
        // this.currentFilter = 0;
        this.doTabFilter();
      }
      // if (this.filterTabs && this.filterTabs["v-bind"]) {
      //   this.initialHideHeaders = this.filterTabs["v-bind"].initialHideHeaders;
      // }
      if (this.filterTabsFn) {
        var par = this.parentObject;
        if (typeof this.filterTabsFn == "string") {
          var capitalize = fun.capitalize;
          var addModel = this.additionalModel;
          var parTable = this.parTable;
          var sortObjects = fun.sortObjects;
          var table = this.table;
          var schema = this.schema;
          var prop = schema.properties;
          try {
            this.currentFilter = -1;
            this.filterItems = eval(this.filterTabsFn);
            console.log(this.filterItems);

            // this.currentFilter = curFilter || 0;
            // this.doTabFilter();
          } catch (error) {
            console.log(error);
          }
        } else if (this.filterTabsFn["v-bind"]) {
          var filterTabVBind = this.filterTabsFn["v-bind"];

          this.initialHideHeaders = filterTabVBind.initialHideHeaders;

          if (filterTabVBind["v-if"] && !eval(filterTabVBind["v-if"])) {
            return;
          }
          var d = {
            object_name: filterTabVBind.objName,
            all_records: true,
            qry: filterTabVBind.qry
          };
          if (filterTabVBind.permittedQry) {
            try {
              this.$root.store.permittedActions.forEach(permittedActions => {
                if (eval(filterTabVBind.permittedQry)) {
                  var qry = eval(filterTabVBind.permittedQry).replaceAll("`", '"');
                  filterTabVBind.qry = JSON.parse(qry);
                }
              });
            } catch (error) {
              //
            }
          }

          axios
            .post(this.serverURL + "/get_data", d, {
              withCredentials: true
            })
            .then(response => {
              var data = response.data;
              this.filterItems = [];
              // try {
              //   data.model = fun.sortObjectByKey(data.model, "sort");
              // } catch (error) {
              //   //
              // }

              data.model.forEach(m => {
                var options = filterTabVBind.options;
                if (!options) {
                  try {
                    options = eval(filterTabVBind.optionFn);
                  } catch (error) {
                    //
                  }
                }

                this.filterItems.push({
                  caption: fun.capitalize(m[filterTabVBind.caption]),
                  value: m[filterTabVBind.value],
                  name: filterTabVBind.name,
                  color: m[filterTabVBind.color],
                  filterProperty: filterTabVBind.filterProperty,
                  includes: filterTabVBind.includes,
                  options: options
                });
              });
              if (filterTabVBind.addToListFrom) {
                that.table.forEach(dt => {
                  var exist = that.filterItems.filter(r => {
                    return r.value == dt[filterTabVBind.addToListFrom];
                  });
                  if (!exist.length && dt[filterTabVBind.addToListFrom]) {
                    that.filterItems.push({
                      caption: dt[filterTabVBind.addToListFrom],
                      value: dt[filterTabVBind.addToListFrom],
                      // name: filterTabVBind.name,
                      color: dt[filterTabVBind.color],
                      filterProperty: filterTabVBind.filterProperty
                    });
                  }
                });
              }
              if (filterTabVBind.sort) {
                fun.sortObjects(this.filterItems, filterTabVBind.sort || filterTabVBind.caption);
              }

              // console.log(fun.roughSizeOfObject(data));
              this.currentFilter = 0;
              this.getFilterCombo();
              this.checkTabOptions();
              this.searchBarKey = !this.searchBarKey;
            })
            .catch(r => {
              console.log(r);
            });
        } else {
          this.filterItems = this.filterTabsFn();
          this.currentFilter = 0;
          this.doTabFilter();
        }
      }
      if (this.limitTabsToData) {
        this.limitTabs();
      }
      this.getFilterCombo();
    },
    limitTabs() {
      var that = this;
      axios
        .post(
          this.serverURL + "/get_data",
          {
            object_name: this.limitObject.object_name,
            all_records: true
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          var arr = response.data.model;
          if (that.filterItems.length) {
            var groupped = fun.groupBy(arr, this.filterItems[0].name);
            var included = Object.keys(groupped);
            if (this.limitObject.additional_value) {
              included.push(this.limitObject.additional_value);
            }

            that.filterItems = that.filterItems.filter(item => included.includes(item.value));
          }

          // console.log(groupped);
        });
    },
    toggleBreakpoint() {
      this.menuModel = !this.menuModel;
      if (!this.breakpoint || this.breakpoint == "0") {
        this.breakpoint = 600;
        document.getElementsByClassName("v-data-table")[0].classList.add("mobile-list");
        // this.mobileList = "mobile-list";
      } else {
        this.breakpoint = 0;
        document.getElementsByClassName("v-data-table")[0].classList.remove("mobile-list");
        // this.mobileList = "";
      }
    },
    showComponent(c, r) {
      var comp = this.schema.properties[c];
      // console.log(comp);
      var d = this.displayIf(r, comp);

      return d;
    },
    getSaveTitle(c) {
      var comp = this.schema.properties[c];
      return comp.save_title || "Apply";
    },
    getSaveFunction(c) {
      var comp = this.schema.properties[c];
      return comp.save_function;
    },
    displayIf(r, value) {
      if (value["v-if-not-parameter"] && r[value["v-if-not-parameter"]]) {
        return false;
      }
      // if (value["v-if-top-parent"]) {
      //   var topParent = value["v-if-top-parent"];

      //   var parent = fun.getParentByProperty(this, topParent.property);
      //   var display =
      //     parent.model[topParent.parameter] &&
      //     parent.model[topParent.parameter].length > 0;
      //   return display;
      // }
      var par = value["v-if-parameter"] ? value["v-if-parameter"].name || value["v-if-parameter"] : "";
      if (value["v-if-value"] || value["v-if-parent"]) {
        return (
          fun.toArrayOfString(value["v-if-value"]).includes(r[par]) ||
          value["v-if-value"] == r[par] ||
          (value["v-if-value"].toString().indexOf("undefined") > -1 && !r[par] && !value["v-if-parent"])
        );
      }
      if (value["v-if-parameter"] && !value["v-if-value"] && !value["v-if-not-value"]) {
        var params = par.split(",");
        var incl = false;
        params.forEach(p => {
          if (r[p]) {
            incl = true;
          }
        });
        return incl;
      }
      if (value["v-if-not-value"]) {
        // par = value["v-if-parameter"].name || value["v-if-parameter"];
        return value["v-if-not-value"] == "true"
          ? false
          : !fun.toArrayOfString(value["v-if-not-value"]).includes(r[par]) && !r[value["v-if-not-value"]];
      }

      return true;
    },
    updateHeight(doFullHeight) {
      // const parentHeight =
      //   window.innerHeight - this.$refs.parentContainer.offsetTop;
      // if (this.isFullScreen || doFullHeight) {
      //   this.wrapHeight = parentHeight - 200 + "px";
      //   return;
      // }
      this.$nextTick(() => {
        if (
          // this.$refs.parentContainer &&
          this.$refs.outerScroll &&
          this.$refs.tableWrap
        ) {
          const topElementY = this.$refs.outerScroll.getBoundingClientRect().top;
          const topElementHeight = this.$refs.outerScroll.offsetHeight;
          if (!this.noTableWrap) {
            this.wrapHeight = window.innerHeight - 20 - topElementY - 4 * topElementHeight + "px !important";
            if (this.filterItems.length) {
              this.wrapHeight -= 20;
            }
          }

          this.$root.$emit("tableHeightUpdated", this);

          // this.$refs.tableWrap.style.height = `${newHeight}px !important`;
          // this.$refs.tableWrap.style.maxHeight = `${newHeight}px !important`;
        }
      });
    },
    getFilterCombo() {
      if (this.filterItems && this.filterItems.length && this.showFilterCombo) {
        // a.slice().unshift(0)
        // fun.prepend(this.comboFilterItems);

        // if (!this.hideAllTabFilter && !this.hideAllInCombo) {
        //   this.comboFilterItems.push({
        //     caption: "(All " + fun.capitalize(this.tableName) + ")",
        //     value: "",
        //   });
        // }
        fun.sortArrayOfObjectsByProperties(this.filterItems, ["value"]);
        this.filterItems.forEach(c => {
          this.comboFilterItems.push(c);
        });
        // this.comboFilterItems = fun.clone(this.filterItems);

        // this.comboCurrentFilter = this.filterItems[0];
      }
    },
    getTextDialogIcon(slot, item) {
      if (slot.icon) {
        return slot.icon;
      } else if (slot.iconFn) {
        var i = item;
        return eval(slot.iconFn);
      }
    },
    getDefaults(model) {
      // console.log(this.schema);
      var that = this;
      if (!model) {
        model = that.model;
      }
      if (this.schema && this.schema.properties) {
        var properties = this.schema.properties;
        var keys = Object.keys(properties);
        keys.forEach(function(key) {
          if (properties[key].default_value) {
            if (!model[key]) {
              model[key] = properties[key].default_value;
              if (properties[key].default_value.function && that[properties[key].default_value.function]) {
                model[key] = that[properties[key].default_value.function]();
              }
            }
          }
        });
      }

      return model;

      // console.log(this.model);
    },
    prepareEditedField(ed) {
      if (ed) {
        if (!ed["v-bind"]) {
          ed["v-bind"] = {};
        }
        ed["hideTitle"] = !ed.outlined;
        ed["v-bind"].class = "mb-2 mt-0 pa-0";

        if (ed["x-type"] == "number") {
          ed.style = "max-width: 75px;";
          if (fun.isMobile) {
            ed.style = "max-width: 50px;";
          }
        } else {
          ed["v-bind"].style = "white-space:nowrap;width:100%;";
        }
        if (fun.isMobile) {
          ed.dense = true;
        }
        return ed;
      }
    },
    deleteCustomQry(item, index) {
      var that = this;
      this.$root.$confirm
        .open("Delete", "Confirm deleting " + item.caption + "?", {
          color: "red"
        })
        .then(confirm => {
          if (confirm) {
            var data = {
              object_name: "custom_qry",
              ids: [item._id]
            };

            axios
              .post(this.serverURL + "/delete_records", data, {
                withCredentials: true
              })
              .then(response => {
                that.additionalModel.custom_qry.splice(index, 1);
                that.successMessage = response.data;
              });
          }
        });
    },
    getAllEditable() {
      var that = this;
      if (!this.schema) {
        return;
      }
      var schema = this.schema.properties ? this.schema : this.data_object.schema;
      if (schema.properties) {
        var keys = Object.keys(schema.properties);
        keys.forEach(function(r) {
          var ed = {
            name: r
          };

          if (
            // !this.$vuetify.breakpoint.smAndDown &&
            (that.allEditable || (that.editable && that.editable.includes(r))) &&
            (!schema.properties[r]["calculate"] || schema.properties[r]["editable"]) &&
            !schema.properties[r]["readonly"]
          ) {
            ed.directEdit =
              schema.properties[r]["x-display"] != "textarea"
                ? (that.directEdit && schema.properties[r].directEdit != false) ||
                  (!that.directEdit && schema.properties[r].directEdit == true)
                : false;
            if (!schema.properties[r]["x-display"]) {
              ed.ctl = "v-text-field";
            } else {
              ed.ctl = schema.properties[r]["x-display"];
              ed["v-bind"] = schema.properties[r]["v-bind"];
            }
            ed["x-type"] = schema.properties[r]["x-type"];

            if (ed.directEdit != false || that.directEdit) {
              ed = that.prepareEditedField(ed);
            }
            // if (ed["v-bind"]) {
            if ((that.editable && !ed["v-bind"]) || !ed["v-bind"].noEditInTable) {
              that.editable.push(ed);
            } else {
              if (!ed["v-bind"] || ed["v-bind"].capitalizeText) {
                that.capitalizable.push(r);
              }
            }

            // }

            // }
          } else if (
            (schema.properties[r]["v-bind"] &&
              (schema.properties[r]["v-bind"]["capitalizeText"] || schema.properties[r]["v-bind"]["returnObject"])) ||
            schema.properties[r].template
          ) {
            if (that.capitalizable || schema.properties[r].template) {
              that.capitalizable.push(r);
            }
          }
        });
      }
    },
    getEditedSchema() {
      var that = this;
      var field = this.editable.filter(e => {
        return e.name == that.editedItem.item;
      })[0];
      return this.getSchema(field);
    },
    removeTab(i) {
      this.edited = 0;
      this.editedTabs.splice(i, 1);
      this.childEdited = false;
      this.disableParentEdit(false);
    },
    getTableProperties(data_object) {
      if (!data_object) {
        return;
      }
      var that = this;
      var headers = this.headers.length ? this.headers : this.data_object.headers;

      var data = data_object.schema;
      if (!data) {
        return;
      }
      var get_table = data.get_table;
      if (!get_table) {
        get_table = "all";
      }
      var filter = get_table == "all" ? "" : get_table.split(",");
      var properties = data.properties;
      if (!properties) {
        return;
      }
      var keys = Object.keys(properties);

      try {
        that.table.forEach(r => {
          // console.log(r, i);
          Object.keys(r).forEach(k => {
            var schema = data.properties[k];

            if (schema && schema["x-display"] == "v-date-field") {
              r[k] = fun.formatDate(r[k]);
            }
          });
        });
      } catch (error) {
        console.log(error);
      }
      this.originalRecords = fun.clone(this.table);
      var groupBy = "";
      if (!headers) {
        headers = [];
      }
      //
      keys.forEach(function(key) {
        if (!filter || filter.indexOf(key) == -1) {
          var p = properties[key];
          var header = {};
          header.text = p.title;
          header.value = key;
          header.hidden = p.hidden;
          header.splitTitle = p.splitTitle;
          // header.groupable = p.groupable;

          if (!fun.InArray(headers, "value", key)) {
            headers.push(header);
          }

          if (p.groupBy) {
            groupBy = key;
          }
        }
      });

      this.groupBy = groupBy || [];
      if (!this.headers.length) {
        this.headers = headers;
      }
      // this.initTable();

      this.filterHeaders();
      this.getAllEditable();
      // this.getCalculatedFields();
      if (!Object.keys(that.schema).length) {
        that.schema = that.data_object.schema;
      }
      try {
        if (typeof Object.keys(that.schema.properties).forEach === "function") {
          Object.keys(that.schema.properties).forEach(p => {
            that.schema.properties[p]["full-width"] = true;
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    getCurrentDateTime() {
      return fun.getCurrentDateTime(true);
    },
    getCurrentDate() {
      return fun.getCurrentDateTime();
    },
    getCurrentUser() {
      return this.$root.store.userData.email;
    },
    updateModel(m, isNew) {
      // console.log(m);
      this.save(m, !isNew, true);
    },
    itemExpanded(value) {
      var that = this;
      if (this.expandable) {
        if (that.expanded.includes(value)) {
          that.transitioned.splice(that.transitioned.indexOf(value), 1);
          setTimeout(function() {
            that.expanded.splice(that.expanded.indexOf(value), 1);
          }, 100);
        } else {
          that.expanded.push(value);
          setTimeout(function() {
            that.transitioned.push(value);
          }, 100);
        }
      }
    },
    doDisablePagination() {
      this.editDisablePagination = !this.editDisablePagination;
      if (this.getFreshData) {
        this.loadFromDb();
      }
    },
    handleClick(value) {
      var that = this;
      if (this.rowClick && !this.selected.length) {
        this.rowClick(value);
      }

      if (this.tableInsertable) {
        if (!value._id) {
          this.insertNewRow = true;
        } else {
          this.insertNewRow = false;
        }
      }

      //
    },

    setTotals() {
      var tot = this.getTotal ? this.getTotal(this) : "";
      var data = {};
      if (tot) {
        var model = {};
        data.total = tot;
        model[tot.key] = tot.value;
        var data_object = this.data_object;
        if (data_object.parent_object && data_object.parent_object.object_id) {
          data.model = model;
        }
      }

      this.totals = data;
    },
    getTemplate(m, field) {
      var htmlDecode = function(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
      };
      // if (
      //   this.schema["v-bind"] &&
      //   (!this.schema["v-bind"].addField ||
      //     this.schema["v-bind"].addField != field.name)
      // ) {
      var that = this;
      var r = m;
      var par = this.parentObject;
      var addModel = this.additionalModel;
      var curRec = m[field.name];
      // var formatDate = fun.formatDate;
      var capitalize = fun.capitalize;
      var parTable = this.parTable;
      var table = this.table;
      var parentModel = this.parentModel;
      var sum = function(r, formula) {
        return fun.sum(r, formula);
      };
      var convertDateFormat = fun.convertDateFormat;
      var formatDate = fun.formatDate;
      var portal = this.$root.portal_id;
      var retValue = "";
      // var getInventoryImageUrl = function(r) {
      //   const url = `user_images/portal_${that.$root.portal_id}/shipment/${parentModel._id}/inventory/${r._id}/${r.main_image}`;
      //   return url;
      // };

      // if (
      //   that.schema.properties[field.name] &&
      //   that.schema.properties[field.name].template
      // ) {
      //   console.log(that.schema.properties[field.name].template);
      // }
      // if (m.crew_name == "BEDDELEEM") {
      //   console.log(m);
      // }
      // if (r.shipment_id == 564595) {
      //   console.log("shipment_id", r.shipment_id);
      // }
      // if (field.name == "order_date_time" && r.order_date_time) {
      //   console.log(r.order_date_time);
      // }
      if (that.schema.properties[field.name]) {
        try {
          if (that.schema.properties[field.name].template) {
            retValue = eval(that.schema.properties[field.name].template);
            if (that.schema.properties[field.name].icon) {
              retValue = `<i style='font-size: 24px;' class='${
                that.schema.properties[field.name].icon
              } ${retValue}'></i>`;
            }
          }
        } catch (error) {
          retValue = "";
          // console.log(error);
        }
        try {
          // if (isJSON(retValue)) {
          //   return "";
          // }
          retValue = retValue.toString();
        } catch (error) {
          //
        }
      }

      return retValue;
      // } else {
      //   return m[field.name];
      // }
    },
    filterHeaders() {
      var that = this;

      if (this.headers && this.headers.length) {
        if (
          // this.editRow &&
          !this.headers.filter(h => {
            return h.value == "actions";
          }).length

          //   ||
          // this.actionCommand
        ) {
          this.headers.push({
            text: "",
            value: "actions",
            sortable: false,
            groupable: false
          });
        }
        // if (this.actionCommand) {
        //   this.actionCommand.forEach((a) => {
        //     var addCommand = true;
        //     if (a.displayIf) {
        //       var isMobile = this.$root.isMobile;
        //       try {
        //         addCommand = eval(a.displayIf);
        //       } catch (error) {
        //         //
        //       }
        //     }
        //     if (addCommand && !this.headers.some((element) => element.text === a.text)) {
        //       this.headers.push({
        //         text: a.text,
        //         value: "actions",
        //         sortable: false,
        //         groupable: false,
        //       });
        //     }
        //   });
        // }
        if (
          this.expandable &&
          !this.headers.filter(h => {
            return h.value == "data-table-expand";
          }).length
        ) {
          this.headers.push({
            text: "",
            value: "data-table-expand",
            sortable: false,
            groupable: false
          });
        }

        if (this.isGoToButton) {
          this.headers.push({
            text: "GoTo",
            value: "goto",
            sortable: false,
            groupable: false
          });
        }
        var parentModel = this.parentModel;
        var formModel = this.formModel;
        var par = fun.getParentByProperty(this, this.parentProperty);
        var splitHeader = [];
        var splitedHeader = null;
        var splitIndex = -1;
        that.headers.forEach((h, i) => {
          if (h.value != "data-table-expand" && h.value && h.value != "actions") {
            h.text = h.text || fun.capitalize(h.value);
          }
          var schema = that.schema.properties ? that.schema : that.data_object.schema;
          try {
            h.hidden =
              (schema.properties[h.value] && schema.properties[h.value].hideInTable) ||
              (schema.properties[h.value].hideInTableFn && eval(schema.properties[h.value].hideInTableFn));
          } catch (error) {
            // console.log("hide in table error", h.value);
            // h.hidden = true;
            //
          }

          try {
            h.noCustomer = schema.properties[h.value].noCustomer;
          } catch (error) {
            //
          }
          try {
            if (h.text.split(";").length > 1) {
              splitHeader = h.text.split(";");
              splitedHeader = fun.clone(h);
              splitIndex = i;
            }
          } catch (error) {
            //
          }

          // if (h.filter) {
          //   h.filter = eval(h.filter);
          // }
        });

        that.computedHeaders = this.headers.filter(function(header) {
          if (!that.columnTool && !header.hidden) {
            header.show = true;
          }

          return (
            (!that.customerColumns ||
              !that.$root.customerId ||
              (that.customerColumns &&
                that.customerColumns.includes(header.value) &&
                (!that.$root.customerId || !header.noCustomer))) &&
            (header != "_id",
            (header.value != "_id" &&
              header.value != "_object_id" &&
              !header.hidden &&
              (!that.fields_excluded || !that.fields_excluded.includes(header.value)) &&
              (!that.fields_included || that.fields_included.includes(header.value))) ||
              header.value == "actions" ||
              header.value == "data-table-expand")
          );
        });
        that.originalHeaders = fun.clone(that.computedHeaders);
        that.mobileHeaders = fun.clone(that.computedHeaders);
        that.checkHiddenHeaders();
        try {
          this.getColumns();
        } catch (error) {
          //
        }
        // this.computedHeaders.forEach((c) => {
        //   c.show = true;
        // });
        console.log(that.computedHeaders);
      } else {
        return [];
      }
    },
    countVisibleRows() {
      if (this.$refs.dTable) {
        var rows = this.$refs.dTable.$el.getElementsByTagName("table")[0].getElementsByTagName("tr");
        var cnt = 0;
        rows.forEach(r => {
          if (!r.className.includes("v-row-group__header")) {
            cnt += 1;
          }
        });
        return cnt - 1;
      }
    },
    deleteSelected() {
      var that = this;
      var data = {};
      var ids = [];
      var id = this.deleteId || "_id";
      this.selected.forEach(function(d) {
        if (d[id]) {
          ids.push(d[id]);
          that.update.delete.push(d[id]);
        }
      });

      data.object_name = this.data_object.object_name_to_update || this.data_object.object_name;
      if (data.object_name && data.object_name.startsWith("v_")) {
        data.object_name = data.object_name.replace("v_", "");
      }
      data.delete_object_name = this.data_object.delete_object_name;

      data.db_name = this.data_object.db_name;
      data.parent_object = this.data_object.parent_object;
      data.ids = ids;
      data.id_name = id;
      data.additional_delete_objects = this.data_object.additional_delete_objects;

      this.$root.$confirm
        .open("Delete", "Confirm deleting " + ids.length + " record(s)?", {
          color: "red"
        })
        .then(confirm => {
          if (confirm) {
            that.data_object.deleted = that.selected;
            that.selected.forEach(function(s) {
              that.table.forEach(function(r, i) {
                if (r[id] == s[id] || !r[id]) {
                  that.table.splice(i, 1);
                }
              });
              that.originalRecords.forEach(function(r, i) {
                if (r[id] == s[id] || !r[id]) {
                  that.originalRecords.splice(i, 1);
                }
              });
            });
            that.setTotals();
            that.$root.$emit("tableChanged", that);
            if (
              (that.getFreshData && !that.data_object.parent_object) ||
              that.dList ||
              that.data_object.object_name_to_update
            ) {
              axios
                .post(this.serverURL + "/delete_records", data, {
                  withCredentials: true
                })
                .then(response => {
                  that.successMessage = response.data;
                  that.$root.$emit("itemsDeleted", that);

                  that.selected = [];
                  that.listKey = !that.listKey;
                });
            } else {
              if (that.alwaysUpdate) {
                that.submit({
                  delete: true
                });
              } else {
                that.$emit("input", that.originalRecords);
                that.$root.$emit("itemsDeleted", that);

                if (this.editedItem) {
                  this.blankItem(true);
                }
                // if (this.tableInsertable) {
                //   this.blankRow();
                // }
              }
            }
          }
          this.selectDelete = false;
        });
    },
    highlightClickedRow(value) {
      const tr = value.target.parentNode;
      tr.classList.add("highlight");
    },
    expandDataObject(item) {
      var data_object = {
        model: item,
        parentModel: this.parentModel,
        parModel: this.model,
        formModel: this.formModel,
        parObject: this.parObject,
        parentObject: this.parentObject,
        // data_object: this.data_object,
        onValueChange: this.onValueChange,
        schema: this.data_object ? this.data_object.schema : this.getDataObjectFromParent(item),
        isExpandRow: true
      };
      return data_object;
    },
    getDataObjectFromParent(item) {
      var dataObject = this.expandedObjects;
      console.log(this.data_object);
    },
    expandAll() {
      if (this.expandable) {
        if (!this.allTableExpanded) {
          this.expanded = this.table;
          this.allTableExpanded = true;
        } else {
          this.expanded = [];
          this.allTableExpanded = false;
        }

        // for (let i = 0; i < this.table.length; i += 1) {
        //   const item = this.table[i];
        //   this.$set(this.$refs.dTable.expanded, item._id, true);
        // }
      }
    },

    getObject() {
      return this;
    },
    expandRows() {
      console.log(this.$refs);
      // this.$refs.expandIcon[0].click();
    },
    refresh() {
      // this.$forceUpdate();
      this.tableMount();
    },
    uploadExcel() {
      this.upload = !this.upload;
    },

    downloadExcel(table) {
      if (!table || !table.length) return;

      const headers = Object.keys(table[0]);

      const csvRows = [];
      csvRows.push(headers.join(","));

      for (const row of this.table) {
        const values = headers.map(h => {
          const val = row[h] ?? "";
          return `"${String(val).replace(/"/g, '""')}"`;
        });
        csvRows.push(values.join(","));
      }

      const csvContent = csvRows.join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    downloadExcel_() {
      this.errorMessage = "";
      var that = this;
      var data = {
        portal_id: "portal_" + this.$root.portal_id,
        objectName: this.data_object.object_name,
        record_id: fun.guid(),
        filename: this.data_object.object_name,
        // html: html,
        host: `${location.protocol}//${location.hostname}:${location.port}`,
        // images: d.images,
        excel: true,
        data: this.table
        // headers: this.headers,
      };
      this.loading = true;
      try {
        axios
          .post(this.serverURL + "/create_pdf", data)
          .then(response => {
            // console.log(response.data);
            const url = response.data;
            // window.location.href = url;
            this.loading = false;
            this.xllink = url;
            window.open(url, "_blank");
            // window.open(url, "_blank");
          })
          .catch(function(error) {
            console.log(error);
            that.errorMessage = error.message;
            that.loading = false;
          });
      } catch (error) {
        console.log(error);
      }
    },
    getForm(v, itemName) {
      if (v.$refs && v.$refs["form"]) {
        this.currentForm = v.$refs["form"];
      } else {
        if (v.$refs && v.$refs[itemName]) {
          v.$refs[itemName].forEach(f => {
            if (f.$refs["form"]) {
              this.currentForm = f.$refs["form"];
            } else {
              if (f.$refs && f.$refs[itemName].length) {
                f.$refs[itemName].forEach(m => {
                  if (m.$refs) {
                    this.getForm(m, itemName);
                  }
                });
              }
            }
          });
        }
      }
    },
    emitDialogSave(item, itemName) {
      var formReady = true;
      var that = this;
      var d = itemName + item._id;
      item = this.editValue;
      var tblItem = this.table.find(r => {
        return r._id == item._id;
      });
      if (tblItem) {
        Object.assign(tblItem, item);
      }
      if (itemName) {
        this.getForm(this, itemName);
        if (this.currentForm) {
          formReady = this.currentForm.validate();
        }

        if (!formReady) {
          return false;
        }
      }

      this.update.update.push(item);

      // if (this.filterTabs) {
      //   this.model = fun.clone(this.originalRecords);
      //   this.model.forEach((m) => {
      //     if (m._id == item._id) {
      //       m = item;
      //     }
      //   });
      // }

      this.$root.$emit("tableItemChanged", {
        tbl: that,
        item: item,
        itemName: itemName
      });

      this.getCalculatedFields();
      var saveFunction = this.getSaveFunction(itemName);
      if (!saveFunction) {
        this.$refs[d][0].save();
        if (this.alwaysUpdate) {
          this.submit({ item: item });
        }
        return item[itemName];
      } else {
        this.$root.$emit("saveFunction", {
          tbl: this,
          item: item,
          editor: this.$refs[d][0]
        });
        // console.log(saveFunction);
      }
    },
    disableParentEdit(disable, update) {
      if (this.k) {
        var parent = fun.getParentsByProperty(this.$parent, "childEdited");
        if (parent.length) {
          parent[0].childEdited = disable;
          this.parentModel = this.formModel;
          if (update) {
            parent[0].save(this.parentModel);
          }
        }
      }
    },
    editCurrentRecord(item, addNew) {
      // if (this.formModel) {
      //   this.childEdited = true;
      // }
      this.dObject = {};
      if (this.addRecordWithLink) {
        this.myLinkClick(this.addRecordWithLink);
      }
      this.editedItem = item;
      this.errorMessage = "";
      this.dialog = true;
      this.$root.$emit("tableEditRecord", {
        tbl: this,
        rec: item
      });
      this.disableParentEdit(true);
      this.isEditedNew = !item;
      this.editMode = true;

      if (!item) {
        this.dObject.model = fun.clone(this.defaultModel);
        if (this.initialIdField && this.initialId) {
          this.dObject.model[this.initialIdField] = this.initialId;
        }
        // this.isEditedNew = true;
        // item = this.addRow();
      } else {
        this.dObject.model = item;
      }

      // if (item) {

      var editExist = this.editedTabs.filter(e => {
        return item && e.id == item._id;
      });
      // if (!addNew) {
      if (!editExist || !editExist.length) {
        this.initEdit(item, true);
        var text = "";
        if (this.editedItemTitle) {
          this.editedItemTitle.forEach(t => {
            text += fun.deepFind(item, t) + " ";
          });
          if (!text || text.toString().includes("undefined")) {
            text = "New " + this.tableName;
          }
          //
        } else if (item) {
          text = Object.keys(item)[0] != "_id" ? item[Object.keys(item)[0]] : item[Object.keys(item)[1]];
        }
        if (text && typeof text != "object") {
          text = text.toString().trim();
        } else {
          text = "";
        }
        this.editedTabs.push({
          text: text,
          icon: item ? "mdi-pencil" : "mdi-plus",
          id: item ? item._id : "",
          item: item || {}
        });
        this.edited = this.editedTabs.length;
        this.editTitle = text;
      } else {
        item = editExist[0].item;
        this.dObject.model = item;
        this.formKey = !this.formKey;
      }
      // }
      // } else {
      //   var id = fun.guid();
      //   item = fun.clone(this.defaultModel) || {};
      //   item._id = id;
      //   this.initEdit();
      //   this.dObject.model = item;
      //   this.editedTabs.push({
      //     text: this.addButtonCaption,
      //     icon: "mdi-new-box",
      //     // id: item._id,
      //     // item: item,
      //   });
      //   this.edited = this.editedTabs.length;
      // }
      return this.editedTabs;
    },
    bodySlots() {
      return this.coloredFields;
    },
    toggleAllGroups() {
      var that = this;
      Object.keys(this.$refs).forEach(k => {
        //console.log(this.$refs[k])
        if (k == "group") {
          that.$refs[k].$el.click();
        }
      });
    },
    filterData(f) {
      this.table = this.originalRecords;
      this.table = this.table.filter(r => {
        try {
          return f(r);
        } catch (error) {
          return true;
        }
      });
    },
    hideHeaders() {
      var that = this;

      var curFilter = this.filteredTabItems[this.currentFilter];
      if (curFilter && curFilter.options) {
        curFilter.options.forEach(h => {
          if (h.hideHeaders) {
            this.computedHeaders = this.computedHeaders.filter(c => {
              return !h.hideHeaders.includes(c.value);
            });
          }
          if (h.tableInsertable == false) {
            //

            that.hasSearch = false;

            that.hideTopBar = true;
          }
        });
      }

      if (curFilter && curFilter.renameHeaders) {
        curFilter.renameHeaders.forEach(h => {
          var header = Object.keys(h)[0];
          this.computedHeaders.forEach(c => {
            if (c.value == header) {
              c.text = h[header];
            }
          });
        });
      } else if (this.data_object?.initialHideHeaders && !curFilter) {
        this.data_object?.initialHideHeaders.forEach(h => {
          const header = this.computedHeaders.find(item => item.value === h);
          if (header) {
            header.hidden = true;
            header.show = false;
          }
        });

        //this.computedHeaders
      }
    },
    doTabFilter() {
      if (!this.noTabSort) {
        fun.sortArrayOfObjectsByProperties(this.filteredTabItems, ["value"]);
      }
      var that = this;
      var curFilter = this.filteredTabItems[this.currentFilter];
      this.editedTabs = [];
      this.edited = null;
      // if (!this.hideAllTabFilter) {
      //   curFilter = this.filteredTabItems[this.currentFilter - 1];
      // }
      this.tabFilter = curFilter;
      var getFilterValue = function(r) {
        var value = r[curFilter.name];
        if (curFilter.filterProperty) {
          return (
            r[curFilter.name][curFilter.filterProperty].toString().toLowerCase() ==
            curFilter.value.toString().toLowerCase()
          );
        } else if (typeof curFilter.value == "object") {
          return JSON.stringify(r[curFilter.name]) == JSON.stringify(curFilter.value);
        } else if (curFilter.notEmpty) {
          return r[curFilter.name];
        } else if (Array.isArray(r[curFilter.name])) {
          return r[curFilter.name].includes(curFilter.value);
        } else {
          var filterValue = curFilter.value;
          if (typeof filterValue == "string") {
            filterValue = filterValue.toString().toLowerCase();
          } else {
            return r[curFilter.name] == curFilter.value;
          }
          if (!filterValue.startsWith("!")) {
            return r[curFilter.name].toString().toLowerCase() == curFilter.value.toString().toLowerCase();
          } else {
            return (
              r[curFilter.name].toString().toLowerCase() !=
              curFilter.value
                .toString()
                .toLowerCase()
                .replace("!", "")
            );
          }
        }
      };

      this.table = this.originalRecords.filter(r => {
        // if (curFilter && r[curFilter.name]) {
        //   console.log(r[curFilter.name], curFilter.value);
        // }

        if (!r.active) {
          // console.log("inactive");
        }
        var evalValue = false;
        try {
          if (curFilter.valueFn) {
            evalValue = eval(curFilter.valueFn);
          }
        } catch (error) {
          //
        }
        return curFilter && curFilter.name
          ? (curFilter.empty && !r[curFilter.name]) ||
              ((r[curFilter.name] || r[curFilter.name] == false) &&
                (curFilter.value || curFilter.value == false) &&
                getFilterValue(r)) ||
              (!curFilter.value && !curFilter.valueFn) ||
              (curFilter.valueFn && evalValue) ||
              (curFilter.includes && r[curFilter.name] && r[curFilter.name].includes(curFilter.value))
          : true;
      });
      // this.computedHeaders = fun.clone(this.originalHeaders);
      this.hideHeaders();
      this.checkTabOptions();
      // this.computedHeaders.splice(1, 1);
      return curFilter;
    },
    log(e) {
      console.log(e);
    },
    dragstart(header) {
      this.draggedHeader = header;
    },
    drop(targetHeader) {
      if (!this.draggedHeader) return;
      const fromIndex = this.headers.indexOf(this.draggedHeader);
      const toIndex = this.headers.indexOf(targetHeader);
      this.headers.splice(fromIndex, 1);
      this.headers.splice(toIndex, 0, this.draggedHeader);
      this.draggedHeader = null;
      this.saveColumnOrder();
    },
    toggleColumn(header) {
      header.hidden = !header.hidden;
      this.saveColumnOrder();
    },
    saveColumnOrder() {
      // Save the updated column order and hidden state to your MongoDB database
      // You can use either the MongoDB native driver or an ORM like Mongoose to interact with your database
    },
    updateFilter() {
      var that = this;
      var curFilter = this.doTabFilter();
      this.initEdited();

      this.autoAssign();
      if (this.defaultModel) {
        this.dModel = this.defaultModel;
      }
      if (curFilter) {
        if (!this.serverPagination) {
          this.dModel[curFilter.name] = curFilter.value;
        } else {
          console.log("do server search");
          if (this.initialQry) {
            this.tabQry = {};
            this.itemsCount = 0;
            if (curFilter.valueFn) {
              this.tabQry = eval(curFilter.valueFn);
            } else {
              if (curFilter.name) {
                this.tabQry[curFilter.name] = curFilter.value;
              }
            }

            // this.initialQry.$and.push(tabQry);
            this.loadFromDb();
          }
        }
      }
    },
    applyCustomQry(id) {
      var customQry = this.additionalModel.custom_qry.find(c => {
        return c._id == id;
      });
      if (customQry) {
        this.qryExplanation = customQry.description;
        this.assistantQry = customQry.qry;
      } else {
        this.qryExplanation = null;
        this.assistantQry = null;
      }

      this.itemsCount = 0;
      this.loadFromDb();
    },
    applyFilter(e) {
      console.log(e);
      var filterIndex = this.filteredTabItems.findIndex(obj => obj && obj.value === e);
      // if (this.hasDefaultTab) {
      //   filterIndex += 1;
      // }
      this.currentFilter = filterIndex;
      if (this.currentFilter == -1) {
        this.tabQry = null;
        this.itemsCount = 0;
        if (this.doServerPagination) {
          this.loadFromDb();
        }
      }
    },
    applyFilterOnEnter(event) {
      if (event.key === "Enter") {
        this.applyFilter();
      }
    },
    checkTabOptions() {
      // if (!this.filterTabs) {
      //   return;
      // }
      var that = this;
      this.keepHeaders = false;
      // var curTab = this.filterTabs[this.currentFilter];
      if (this.tabFilter && this.tabFilter.options) {
        this.tabFilter.options.forEach(o => {
          var key = Object.keys(o)[0];
          if (key == "showHeaders") {
            if (!Array.isArray(o[key])) {
              o[key] = [o[key]];
            }
            o[key].forEach(opt => {
              var header = that.computedHeaders.find(item => item.value === opt);
              if (header) {
                header.hidden = false;
                header.show = true;
              }
            });
            this.keepHeaders = true;
          } else if (key == "hideHeaders") {
            if (!Array.isArray(o[key])) {
              o[key] = [o[key]];
            }
            o[key].forEach(opt => {
              if (that.computedHeaders[opt]) {
                that.computedHeaders[opt].hidden = true;
                that.computedHeaders[opt].show = false;
              }
            });
            this.keepHeaders = true;
          } else {
            that[key] = o[key];
          }
        });

        that.computedHeaders[that.computedHeaders.length - 1].show = that.tableEditRow;
      } else {
        that.checkHiddenHeaders();
      }
    },
    checkHiddenHeaders() {
      var that = this;
      if (that.initialHideHeaders && ((!that.hideAllTabFilter && that.currentFilter) || that.hideAllTabFilter)) {
        that.initialHideHeaders.forEach(opt => {
          that.computedHeaders[opt].show = false;
        });
      }
    },
    updateDisablePagination() {
      this.tableKey = !this.tableKey;
    },
    // sortTabItems() {
    //   this.filterItems = this.filterItems.sort((a, b) =>
    //     a.caption.localeCompare(b.caption)
    //   );
    // },
    updateAdditionalTabs(t) {
      var that = this;
      if (!this.additionalTabs) {
        this.additionalTabs = {};
      }
      if (t) {
        this.additionalTabs = {
          ...this.additionalTabs,
          ...t
        };
      }

      // if (this.additionalTabs) {
      Object.keys(this.additionalTabs).forEach(k => {
        if (
          !that.filterItems.some(f => {
            return f.value == k;
          })
        ) {
          that.filterItems.push({
            caption: this.capitalize(k),
            // name: this.filterItems[0].name,
            value: k,
            filter: this.additionalTabs[k]
          });
        }
      });
      // }
    },
    updateItemsPerPage() {
      // this.tableKey = !this.tableKey;
      this.itemsPerPageChanged = true;
      this.serverItemsLength = -1;
      // this.serverItemsLength = parseInt(this.itemsPerPageEdited);
      // this.itemsPerPageEdited = parseInt(this.itemsPerPageEdited, 10);
      //
      this.pageStart = 1;
      this.pageStop = this.itemsPerPageEdited;
      this.itemsLength = this.table.length;
      if (this.itemsPerPageEdited > this.table.length) {
        this.serverItemsLength = this.itemsPerPageEdited;
        this.pageStop = this.table.length;
        // } else {
        //   this.serverItemsLength = parseInt(this.itemsPerPageEdited);
      }
      // this.itemsPerPageChanged = false;

      // this.itemsPerPageEdited > this.table.length
      //   ? this.table.length
      //   : this.itemsPerPageEdited;
      // this.tableMount();
      // this.$refs.dTable.options.page = 1;
      // this.tableKey = !this.tableKey;
      // this.getData();
      // this.tableMount();
    },
    updateOriginalRecords() {
      var that = this;
      let tableIds = this.table.map(record => record._id);
      if (!tableIds) {
        return;
      }
      let remainingRecords = this.originalRecords.filter(record => !tableIds.includes(record._id));

      // Removed records
      this.originalRecords = remainingRecords.concat(this.table);

      // this.originalRecords = this.originalRecords.filter(record => !tableIds.includes(record.id));

      // this.table.forEach((record) => {
      //   var origRec = that.originalRecords.filter((r) => {
      //     return r._id == record._id;
      //   })[0];
      //   // let index = that.originalRecords.findIndex((r) => r.id === record.id);

      //   // if (index !== -1) {
      //   //   that.originalRecords[index] = record;
      //   // }
      //   if (origRec) {
      //     origRec = record;
      //   }
      // });
    },
    virtualScroll() {
      // const table = this.$refs.dTable.$el.querySelector(
      //   ".v-data-table__wrapper"
      // );
      // const outerScroll = this.$refs.outerScroll;
      // const innerScroll = outerScroll.querySelector(".inner-scroll");
      //data-table-wrap
      const table = document.getElementsByClassName("v-data-table__wrapper")[0];
      const tableWrap = document.getElementsByClassName("data-table-wrap")[0];
      // if (
      //   tableWrap &&
      //   !this.$root.isMobile &&
      //   !this.disablePagination &&
      //   !this.isFullScreen
      // ) {
      //   tableWrap.style.maxHeight = `${screen.height -
      //     table.offsetTop -
      //     450}px`;
      // }

      // Set the width of the inner scroll element to match the table's scroll width
      // innerScroll.style.width = `${table.scrollWidth}px`;

      // Event listener for table scrolling
      // table.addEventListener("scroll", () => {
      //   outerScroll.scrollLeft = table.scrollLeft;
      // });

      // // Event listener for outer scrolling
      // outerScroll.addEventListener("scroll", () => {
      //   table.scrollLeft = outerScroll.scrollLeft;
      // });
    },
    addDefaultFilter() {
      var defaultFilter = this.defaultTabCaption || "All " + fun.capitalize(this.tableName);
      if (
        !this.hasDefaultTab
        // &&
        // !this.filterItems[0].value.toLowerCase().startsWith("all ") &&
        // !this.filterItems[0].value.toLowerCase().startsWith("add ")
      ) {
        this.filterItems.unshift({
          caption: defaultFilter,
          value: defaultFilter
        });
      }
    },
    addDefaultTab() {
      if (!this.hideAllTabFilter && this.filterItems.length > 1) {
        // var defaultFilter =
        //   this.defaultTabCaption || "All " + fun.capitalize(this.tableName);
        // if (
        //   !this.hasDefaultTab
        //   // &&
        //   // !this.filterItems[0].value.toLowerCase().startsWith("all ") &&
        //   // !this.filterItems[0].value.toLowerCase().startsWith("add ")
        // ) {
        //   this.filterItems.unshift({
        //     caption: defaultFilter,
        //     value: defaultFilter,
        //   });
        // }
        // fun.sortObjects(this.filterItems, "value");
        this.addDefaultFilter();
        this.hasDefaultTab = 1;
      }
    },
    handleGroupDescChange(f) {
      console.log(f);
    },
    getTableTop() {
      if (this.$refs["dTable"]) {
        return this.$refs["dTable"].getBoundingClientRect().top;
      } else {
        return 0;
      }
    },
    attachHoverListeners() {
      const table = this.$refs.dTable?.$el;
      if (!table) return;

      const bodies = table.querySelectorAll("tbody");

      bodies.forEach(tbody => {
        tbody.removeEventListener("mouseover", this.onRowHover);
        tbody.removeEventListener("mousemove", this.onRowHover);
        tbody.removeEventListener("mouseleave", this.onRowLeave);

        tbody.addEventListener("mouseover", this.onRowHover);
        tbody.addEventListener("mousemove", this.onRowHover);
        tbody.addEventListener("mouseleave", this.onRowLeave);
      });
    },
    buildMongoAggregate(searchModel) {
      const match = {};
      const addFields = {};
      this.dateFields = [];
      const searchText = this.search;

      const hasSearchModel = searchModel && Object.keys(searchModel).length > 0;
      // const hasRemoteSearch =
      //   !hasSearchModel && searchText && Array.isArray(this.remoteSearchFields) && this.remoteSearchFields.length;

      // ---------------------------------------------------
      // NORMAL FILTER MODE
      // ---------------------------------------------------
      if (this.remoteSearch) {
        Object.keys(searchModel).forEach(key => {
          const value = searchModel[key];
          if (!value || (Array.isArray(value) && !value.length)) return;

          // --- Numeric range ---
          if (Array.isArray(value) && value.length === 2 && value.every(v => typeof v === "number")) {
            match[key] = { $gte: value[0], $lte: value[1] };
            return;
          }

          // --- Array of strings ---
          if (Array.isArray(value) && value.every(v => typeof v === "string")) {
            match[key] = { $in: value };
            return;
          }

          // --- Date range ---
          if (typeof value === "string" && value.includes(" - ")) {
            const [startStr, endStr] = value.split("-").map(v => v.trim());
            const start = fun.formatDate(startStr, true);
            const end = fun.formatDate(endStr, true);

            addFields[`${key}_date`] = {
              $switch: {
                branches: [
                  {
                    case: { $regexMatch: { input: `$${key}`, regex: "^\\d{2}\\/\\d{2}\\/\\d{4}$" } },
                    then: { $dateFromString: { dateString: `$${key}`, format: "%m/%d/%Y" } }
                  },
                  {
                    case: { $regexMatch: { input: `$${key}`, regex: "^\\d{2}\\/\\d{2}\\/\\d{4}\\s+\\d{2}:\\d{2}$" } },
                    then: { $dateFromString: { dateString: `$${key}`, format: "%m/%d/%Y %H:%M" } }
                  },
                  {
                    case: {
                      $regexMatch: { input: `$${key}`, regex: "^\\d{2}\\/\\d{2}\\/\\d{4}\\s+\\d{2}:\\d{2}:\\d{2}$" }
                    },
                    then: { $dateFromString: { dateString: `$${key}`, format: "%m/%d/%Y %H:%M:%S" } }
                  }
                ],
                default: null
              }
            };

            this.dateFields.push(`${key}_date`);
            match[`${key}_date`] = { $gte: start, $lte: end };
            return;
          }

          // --- Simple string ---
          if (typeof value === "string") {
            match[key] = { $regex: value, $options: "i" };
          }
        });
      }

      // ---------------------------------------------------
      // REMOTE SEARCH MODE (fallback)
      // ---------------------------------------------------
      if (this.remoteSearch) {
        match.$or = this.remoteSearchFields.map(field => ({
          [field]: { $regex: searchText, $options: "i" }
        }));
      }

      // ---------------------------------------------------
      // PIPELINE BUILD
      // ---------------------------------------------------
      const pipeline = [];
      if (Object.keys(addFields).length) pipeline.push({ $addFields: addFields });
      if (Object.keys(match).length) pipeline.push({ $match: match });

      return pipeline;
    }
  },
  directives: {
    draggable: {
      bind(el, binding, vnode) {
        var that = this;
        const options = {
          animation: 150,
          onUpdate: function(event) {
            vnode.child.$emit("sorted", event);
            vnode.child.$root.$emit("rowReordered", vnode.child);
          },
          handle: ".drag-handle"
        };
        if (vnode.context.isDraggable) {
          Sortable.create(el.getElementsByTagName("tbody")[0], options);
        }
      }
    }
  },

  mounted() {
    var that = this;
    this.updateHeight();
    window.addEventListener("resize", this.updateHeight);
    // this.initEdited();
    this.doServerPagination = this.serverPagination;
    if (this.data_object) {
      this.initialQry = fun.clone(this.data_object.qry);
    }

    //        this.remoteSearchFields.join(", ") +
    if (this.remoteSearchFields && this.minSearchLength) {
      var searchFields = [];
      this.remoteSearchFields.forEach(f => {
        searchFields.push(fun.capitalize(f));
      });
      this.searchLabel = "First " + this.minSearchLength + " char of " + searchFields.join(" or ");
    }
    this.breakpoint = this.mobileBreakpoint || 600;
    if (this.$vuetify.breakpoint.smAndDown && !this.mobileBreakpoint) {
      this.breakpoint = 600;
    }

    this.activeTab = this.$root.activeTab;
    document.arrive("input[k='" + this.focusOnInsert + "']", a => {
      if (a && that.insertMode) {
        a.click();
        that.insertMode = false;
      }
    });
    document.arrive(".v-data-table", t => {
      if (t) {
        that.virtualScroll();
      }
      if (this.breakpoint && this.$root.isMobile) {
        document.getElementsByClassName("v-data-table")[0].classList.add("mobile-list");
      }
    });
    this.tableMount();
    var specialFields = [...(this.dialogFields || []), ...(this.coloredFields || [])];
    specialFields.forEach(f => {
      if (typeof f == "string") {
        this.specialFields.push({
          model: f
        });
      } else {
        this.specialFields.push(f);
      }
    });
    if (this.startExpanded) {
      this.expandAll();
    }
    if (this.getItems) {
      this.$root.$on("get_menu_items", function(r) {
        // if (that._uid != that.$root.shipmentUid) {
        //   return;
        // }
        that.menuItems = r.items;
        that.menuButtonKey = !that.menuButtonKey;
      });
      return;
    }

    // this.virtualScroll()
  },
  activated() {
    // this.initEdited();
  },
  watch: {
    showAdvancedSearch() {
      if (!this.showAdvancedSearch) {
        this.searchModel = {};
      }
    },
    // vModel: {
    //   handler: function(newValue, oldValue) {
    //     console.log(newValue);
    //   },
    // },

    edited() {
      this.$root.$emit("edited", this);
      // if (this.edited != null) {
      //   this.delBtnKey = !this.delBtnKey;
      // }
      //
    },
    isFullScreen() {
      this.updateHeight();
    },
    searchTabQuery() {
      if (!this.searchTabQuery) {
        this.currentFilter = 0;
      }
    },

    searchModel: {
      handler: function(newValue, oldValue) {
        var that = this;
        if (this.serverPagination) {
          this.data_object.pipeline = null;
          return;
        }

        that.doTabFilter();
        if (this.searchModel) {
          Object.keys(this.searchModel).forEach(k => {
            if (this.searchModel[k] && this.searchModel[k].length) {
              this.searchReset = true;
              Object.keys(this.schema.properties).forEach(h => {
                if (h == k) {
                  if (this.schema.properties[h].filter) {
                    // console.log(that.table);
                    // console.log(this.schema.properties[h].filter);

                    that.table = that.table.filter(r => {
                      try {
                        var rec = r[h];
                        if (that.schema.properties[h].template) {
                          try {
                            rec = eval(that.schema.properties[h].template);
                          } catch (error) {
                            //
                          }
                        }
                        var v = newValue[h];
                        var includes = function() {
                          return rec.includes(v);
                        };
                        var inArray = function() {
                          if (v.length) {
                            return v
                              .toString()
                              .toLowerCase()
                              .split(",")
                              .includes(rec.toString().toLowerCase());
                          } else {
                            return true;
                          }
                        };
                        var range = function() {
                          return rec >= v[0] && rec <= v[1];
                        };
                        var dayRangeFilter = function() {
                          var range = v.split("-");
                          var minDate = new Date(range[0]);
                          var maxDate = null;
                          if (range[1].toString().trim()) {
                            maxDate = new Date(range[1]);
                          }
                          var dates = rec.split("-");

                          var dMin = new Date(dates[0]);

                          var dMax = null;
                          if (dates[1] && dates[1].toString().trim()) {
                            dMax = new Date(dates[1]);
                          }
                          if (minDate && maxDate) {
                            if (dMin && dMax) {
                              return dMin <= maxDate && dMax >= minDate;
                            } else {
                              return dMin >= minDate && dMin <= maxDate;
                            }
                          } else {
                            if (dMin && dMax) {
                              return dMin >= minDate && dMax <= minDate;
                            } else {
                              return dMin >= minDate;
                            }
                          }
                        };
                        var isString = !that.schema.properties[h]["x-display"];
                        if (rec && that.schema.properties[h].filter && v) {
                          if (isString) {
                            rec = rec.toString().toLowerCase();
                          }

                          var include = eval(that.schema.properties[h].filter + "()");
                          // console.log(include);
                          return include;
                        } else {
                          return false;
                        }
                      } catch (error) {
                        console.log("error search", error);
                        return false;
                      }
                    });
                    // console.log(that.table);
                  }
                }
              });
            }
          });
        }
      },
      deep: true
    },
    table: {
      handler: function(newValue, oldValue) {
        if (oldValue.length && !this.filterChanged) {
          this.updateOriginalRecords();
          this.$emit("input", this.originalRecords);
          this.$root.$emit("tableChanged", this);
          if (!this.skipRecalculation) {
            this.$root.$emit("recalculateFields", this);
          }
        }

        this.filterChanged = false;
        // console.log("totals", this.tableTotal);
      },
      deep: true
      // immediate: true,
    },
    update: {
      handler: function(newValue, oldValue) {
        // if (oldValue.length) {
        this.$root.$emit("updateChanged", this);
        // }
      },
      deep: true
      // immediate: true,
    },
    selected: function(r) {
      // console.log(this.selected);
      this.$root.$emit("tableSelectionChanged", this);
    },
    search: function(r) {
      if (this.remoteSearch) {
        return;
      }
      if (this.remoteSearch || this.doServerPagination) {
        this.itemsCount = 0;
        if ((!this.search || this.searchAfterCompleted) && !this.doServerPagination) {
          // if (this.itemsCount <= this.table.length) {
          this.tableReady = false;

          return;
          // }
        }
        if (!this.search || (!this.doServerPagination && this.search.length >= this.minSearchLength)) {
          this.tableReady = true;
          this.loadFromDb();
        } else {
          if (!this.doServerPagination || this.maxRecords) {
            return;
          } else {
            if (this.search && this.search.length >= this.minSearchLength) {
              this.buildSearchQuery();
              this.loadFromDb();
            } else if (!this.search) {
              this.tableMount();
            }
          }
        }
      }
    },
    currentFilter: {
      handler: function(newValue, oldValue) {
        // if (this.additionalTabs) {
        var ind = this.hideAllTabFilter ? 0 : 0;
        var tab = this.filteredTabItems[newValue - ind];
        if (this.additionalTabs && tab) {
          this.searchModel = tab.filter;
          //
        }
        // }
        var that = this;
        if (!this.currentFilter) {
          this.tabKey = !this.tabKey;
        }
        this.updateFilter();
        this.$root.$emit("tableFilterChanged", this);
        // this.$root.$emit("recalculateFields", this);
        this.filterChanged = true;
        this.filterComboKey = !this.filterComboKey;
        // this.getColumns();
        this.checkTabOptions();
        this.checkHiddenHeaders();
      },
      deep: true
    },
    groupByFilter: function(newValue, oldValue) {
      console.log(newValue);
      var groupFilter = this.groupByItemTabs[newValue];
      if (groupFilter) {
        this.groupQry = {};
        this.groupQry[groupFilter["item"]] = groupFilter["name"];
      }

      this.loadFromDb();
    },
    dialog: function() {
      // console.log(this.dialog);
      if (this.dialog && this.isNew) {
        this.resetModel();
      }
      // this.formKey = !this.formKey;
    },

    insertedRow: {
      handler: function(newValue, oldValue) {
        console.log(newValue, oldValue);

        if (oldValue && oldValue._id && !newValue._id) {
          return;
        }

        if (this.tableInsertable && oldValue) {
          var rowChanged = !fun.objectEqual(newValue, this.newRow, this._id);
          this.blankRow(rowChanged);
        }
      },
      deep: true
    },

    doSubmit: function() {
      this.submit();
    },
    searchInput: function(input) {
      console.log(input);
    },
    originalRecords: {
      handler: function(newValue, oldValue) {
        // console.log(this.originalRecords);
        // this.$root.$emit()
      }
      // deep: true,
    },
    formModel: {
      handler: function(newValue, oldValue) {
        // console.log(this.formModel);
        if (this.refreshHeadersOnFormChange && !this.keepHeaders) {
          this.filterHeaders();
        }
      },
      deep: true
    },
    page: function() {
      // console.log(this.page);
    }
  },
  computed: {
    safeToolBarControls() {
      // Check if toolBarControls is truthy and an array; return it or an empty array
      return this.toolBarControls
        ? this.toolBarControls.filter(c => !c.notParent || (this.parentObject && !this.parentObject[c.notParent])) || []
        : [];
      //toolBarItemsExcluded
    },

    filteredTabItems() {
      // this.filterItems.concat(Object.keys(this.additionalTabs));
      // this.sortTabItems();

      this.updateAdditionalTabs();
      this.addDefaultTab();

      return this.filterItems.filter(
        tab => !this.searchTabQuery || tab.value.toLowerCase().includes(this.searchTabQuery.toLowerCase())
      );
    },
    tableTotal() {
      var tot = [];
      if (this.totalFields) {
        this.totalFields.forEach(f => {
          tot.push({
            field: f,
            total: fun.sumOf(this.table, f)
          });

          //
        });
      }
      return tot;
    },
    tblStyle() {
      var width = screen.width;
      if (this.$vuetify.breakpoint.smAndDown) {
        return "width:" + width - 20 + "px; overflow:auto; ";
      } else {
        return "";
      }
    },
    filteredHeaders() {
      return this.$vuetify.breakpoint.smAndDown
        ? this.computedHeaders.filter(header => this.mobileHeaders.includes(header.value))
        : this.computedHeaders;
    },
    filteredItems() {
      // var tableItems = fun.clone(this.table);
      // tableItems.forEach((t) => {
      //   Object.keys(t).forEach((k) => {
      //     t[k] = this.getTemplate(t, { name: k }) || t[k];
      //   });
      // });

      if (this.$vuetify.breakpoint.smAndDown) {
        return this.table.filter(item => {
          return this.mobileHeaders.some(header => {
            const value = item[header.value];
            return value !== null && value !== undefined && value !== "";
          });
        });
      } else {
        return this.table;
      }
    },

    // computedTable() {
    //   if (this.tabFilter) {
    //     var curFilter = this.tabFilter;
    //     var table = this.originalRecords.filter((r) => {
    //       return curFilter && curFilter.name
    //         ? r[curFilter.name] &&
    //             curFilter.value &&
    //             r[curFilter.name].toString().toLowerCase() ==
    //               curFilter.value.toLowerCase()
    //         : true;
    //     });
    //     return table;
    //   } else {
    //     return this.table;
    //   }
    // },
    searchTrigger() {
      return this.searchLen && this.search && this.search.length >= this.searchLen ? this.search : "";
    }
  }
};
</script>

<style>
.side-panel-drawer {
  position: fixed !important;
  top: 0;
  bottom: 0;
  height: 100vh !important;
  width: 40vw !important;

  z-index: 1000;
}
.side-panel {
}
.mouse-tooltip {
  position: fixed;
  background: #333;
  color: white;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 13px;
  pointer-events: none;
  z-index: 99999;
  white-space: nowrap;
  transform: translate(12px, -12px);
  /* offset from cursor */
}

.pointer {
  cursor: pointer;
}

.toolbar-checkbox {
  padding-top: 8px !important;
}

.dropped-panel {
  min-width: 30%;
}

.bottomToolBar {
  position: fixed;
  top: 0;
  right: 40px;
  /* background-color: white;*/
  z-index: 10000;
}

.edit-bar {
  /* z-index: 10; */
}

.table-toolbar,
.table-toolbar div {
  background-color: transparent !important;
}
.top-bar {
  /* position: fixed; */
  background-color: white;
  top: 0;
  /* left: 0; */
}
.table-title {
  font-weight: normal;
}

.top-table-header {
  /* position: fixed; */
}

.filter-tabs {
  position: relative;
}

.filter-tabs .v-item-group {
  /* left: 100px; */
  /* position: absolute; */
}

.tab-search {
  position: absolute;
  left: -8px;
  top: -10px;
}

.per-page-width {
  width: 100px;
}

.bootom-bar {
  width: 100lvh;
}

.fixed-footer {
  position: fixed;
  bottom: 0;
  left: 400px;
}

.row-pointer {
  cursor: pointer;
  /* padding: 10px; */
}
.clickable-row {
  cursor: pointer;
}

/* Hover background */
.clickable-row:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.hidden-row {
  display: none;
}
.table-wrapper {
  position: relative;
}
.v-data-table__wrapper {
  width: initial !important;
  overflow: initial !important;
}

.v-data-table__wrapper tr {
  position: relative !important;
}

/* thead,
tbody tr {
  display: table;
  width: 100%;
} */
.data-table-wrap {
  /* max-height: 66vh; */
  /* max-height: 48vh !important; */
  overflow-x: auto;
  overflow-y: auto;
}
.table-summary {
  position: fixed;
  right: 0;
  bottom: 0;
}
.full-screen .data-table-wrap {
  max-height: 75vh !important;
  height: 78vh !important;
  overflow-y: initial !important;
  z-index: 3;
}

.full-screen .v-data-table__wrapper {
  height: initial !important;
}

.data-table-wrap-no-hor {
  overflow-y: auto;
  /* max-height: 65vh !important; */
}

.outer-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  /* width: 200%; */

  height: 20px;
  /* Height of the virtual scroll bar */
}

.inner-scroll {
  height: 100%;

  /* background-color: #3a3737; */
}

.theme--light .inner-scroll {
  background-color: white;
}

.theme--dark .inner-scroll {
  background-color: #121212;
}

.edit-dialog-wrapper {
  left: var(--edit-dialog-left) !important;
  /* width: var(--edit-dialog-width); */
}

.v-data-table tr {
  height: 60px !important;
}

.column-list {
  height: 400px;
  overflow: auto;
}

.custom-badge-position .v-badge__badge {
  transform: scale(0.9) translate(-10px, 10px);
  /* Adjust positioning */
}

.top {
  z-index: 100;
}

.hover-row,
.hover-important {
  cursor: pointer !important;
  transition: background 0.2s ease;
}

.hover-row:hover {
  background: #686869 !important;
  color: #ffffff;
}

.hover-important:hover {
  background: #b5f1f1 !important;
}

.dropped-objects-table {
  background: #e0e0e0;
  max-width: 100%;
  overflow: auto;
}

.dropped-objects-table tr:hover {
  background: #b5f1f1 !important;
  transition: background 0.2s ease;
  cursor: pointer !important;
}

.grid-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  border: 2px dashed #ccc;
  padding: 16px;
  border-radius: 8px;
}

.grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  width: 200px;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  cursor: grab;
  transition: background-color 0.2s, transform 0.2s;
}

.grid-item:active {
  cursor: grabbing;
}

.grid-item:hover {
  background-color: #e0e0e0;
  transform: scale(1.05);
}

.item-content {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.drop-zone {
  min-height: 50px;
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  border: 2px dashed #aaa;
  /* background-color: #e0e0e0; */
  margin-top: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.drop-zone:hover {
  background-color: #e0e0e0;
  /* Change color on hover to show it's a drop target */
}

.chip-text {
  /* background-color: white; */
  color: white;
  font-weight: 600;
  /* color: black; */
  padding: 2px;
  cursor: pointer;
  min-width: 50px;
  /* border-radius: 5px; */
}

.horizontal-list {
  display: flex;
  flex-direction: row;
  gap: 16px;
  /* Add space between items */
}

.horizontal-item {
  width: 100px;
  /* Set a fixed width for list items */
  text-align: center;
  border: 1px solid #ccc;
  /* Optional: Add a border for visibility */
  border-radius: 4px;
  cursor: grab;
}

.horizontal-item:active {
  cursor: grabbing;
}

.search-menu {
  height: 30px !important;
  display: flex;
  flex-direction: column;
  /* Stack items vertically */
  align-items: flex-start;
  /* Align items to the top */
  justify-content: flex-start;
  /* Ensure no unwanted spacing */
}

.bottom-bar .v-toolbar__content {
  width: 100% !important;
  padding: 0 !important;
  /* margin-left: -20px !important; */
}

.card-actions {
  position: fixed;
  bottom: 0;
  right: 30%;
  width: calc(100% -15px);
  z-index: 100;
}

.v-data-table__selected {
  background-color: rgba(255, 255, 0, 0.363) !important;
  /* color: white !important; */
  font-weight: bold !important;
}

.v-dialog {
  overflow-x: hidden !important;
}

.v-tab {
  /* background-color: white; */
  margin: 1px !important;
}

.colored .text-start {
  color: white;
  max-height: 30px !important;
}

.colored a {
  color: white;
}

.editable a {
  color: white;
}

.v-data-table-header {
  z-index: 3 !important;
}

.v-data-table-header th {
  /* text-transform: uppercase !important; */
  font-size: 16px !important;
  z-index: 3 !important;
}

.expanded-item {
  background-color: gray;
}
/* ================================
   GLOBAL V-DATA-TABLE — LIGHT MODE
================================ */

.v-data-table {
  font-size: 0.85rem;
  color: #2c3e50;
  background: transparent;
}

/* header */
v-data-table thead th

/* rows */
.v-data-table tbody tr {
  transition: background-color 0.12s ease;
}

/* row hover */
.v-data-table tbody tr:hover {
  background-color: #f3f6fb;
}

/* cells */
.v-data-table tbody td {
  padding: 6px 10px;
  border-bottom: 1px solid #eef2f6;
  vertical-align: middle;
}

/* striped rows (optional) */
.v-data-table tbody tr:nth-child(even) {
  background-color: #fafcff;
}

/* selected row */
.v-data-table tbody tr.v-data-table__selected {
  background-color: rgba(74, 144, 226, 0.12);
}

/* footer / pagination */
.v-data-table .v-data-footer {
  font-size: 0.75rem;
  border-top: 1px solid #eef2f6;
  padding: 6px 10px;
  color: #6b7c93;
}

/* icons (sort, pagination) */
.v-data-table .v-icon {
  font-size: 18px;
  color: #6b7c93;
}

/* compact variant */
.v-data-table.v-data-table--dense tbody td {
  padding: 4px 8px;
}

/* ================================
   GLOBAL V-DATA-TABLE — DARK MODE
================================ */

.theme--dark .v-data-table {
  font-size: 0.85rem;
  color: #e3e9f1;
  background: transparent;
}

/* header */
.theme--dark .v-data-table thead th {
  font-size: 0.68rem;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.01em;
  color: #9aa6b2;
  background: #1f252c;
  padding: 4px 8px;
  border-bottom: 1px solid #2a3442;
}

/* rows */
.theme--dark .v-data-table tbody tr {
  transition: background-color 0.12s ease;
}

/* row hover */
.theme--dark .v-data-table tbody tr:hover {
  background-color: #232a33;
}

/* cells */
.theme--dark .v-data-table tbody td {
  padding: 6px 10px;
  border-bottom: 1px solid #2a3442;
  vertical-align: middle;
}

/* striped rows */
.theme--dark .v-data-table tbody tr:nth-child(even) {
  background-color: #1c2229;
}

/* selected row */
.theme--dark .v-data-table tbody tr.v-data-table__selected {
  background-color: rgba(106, 169, 255, 0.18);
}

/* footer / pagination */
.theme--dark .v-data-table .v-data-footer {
  font-size: 0.75rem;
  border-top: 1px solid #2a3442;
  padding: 6px 10px;
  color: #a6b0c0;
}

/* icons */
.theme--dark .v-data-table .v-icon {
  font-size: 18px;
  color: #a6b0c0;
}

/* dense variant */
.theme--dark .v-data-table.v-data-table--dense tbody td {
  padding: 4px 8px;
}

@media only screen and (min-height: 600px) {
  /* .special-button {
    padding-top: 36px !important;
  } */
  .edited-form {
    height: 55vh;
    overflow: auto;
    /* position: relative; */
  }

  .edited-form-full {
    height: 100%;
    overflow: auto;
    /* position: relative; */
  }

  /* Your global styles (unchanged) */
  .theme--light .v-data-table-header th {
    z-index: 0 !important;
    background-color: #173d5d !important;
    color: white !important;
  }

  .theme--dark .v-data-table-header th {
    background-color: #f5f5f5 !important;
    color: black !important;
  }

  /* ❌ Override ONLY inside dropped-objects-table */
  .dropped-objects-table.theme--light .v-data-table-header th,
  .dropped-objects-table .theme--light .v-data-table-header th {
    background-color: unset !important;
    color: unset !important;
    z-index: unset !important;
  }

  .dropped-objects-table.theme--dark .v-data-table-header th,
  .dropped-objects-table .theme--dark .v-data-table-header th {
    background-color: unset !important;
    color: unset !important;
  }
}

@media only screen and (max-width: 450px) {
  .theme--light .v-data-table-header th {
    background-color: initial !important;
  }

  .toolbar-controls {
    flex: 0 0 auto;
    /* padding: 10px;
  display: flex;
  justify-content: left; */
    background: white;
  }
  .table-toolbar {
    padding-bottom: 20px;
    /* position: fixed;
    background-color: white;
    height: 20px;
    z-index: 100;
    top: 20; */
  }

  .button-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 8px;
  }

  .button-row .v-btn {
    flex: 1 1 auto;
    min-width: 120px;
  }

  .search-menu {
    max-width: 300px;
    margin-left: 10px;
  }

  .full-width {
    width: 100%;
  }

  .draggable-item {
    margin-top: 10px;
    padding: 10px;
    background-color: rgba(212, 219, 212, 0.843);
    border: 2px solid #7f7a7a;
    cursor: grab;
    transition: background-color 0.2s ease;
  }

  .draggable-item:active {
    cursor: grabbing;
  }

  .v-data-table__mobile-row__header {
    font-weight: normal;
    white-space: nowrap;
    /* margin-top: 16px;
    margin-bottom: 16px; */
  }

  .v-data-table__mobile-row {
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .v-small-dialog__activator__content {
    color: blue;
    text-decoration: underline;
    font-weight: bold;
  }

  .v-data-table.mobile-list {
    overflow-x: hidden !important;
  }

  .v-btn__content,
  .v-tab,
  .active-tab {
    font-size: small !important;
  }

  .pager {
    font-size: small;
    white-space: nowrap;
  }

  .v-data-table__mobile-row:not(:has(.v-data-table__mobile-row__cell:not(:empty))) {
    display: none;
  }

  table {
    border-collapse: collapse !important;
  }

  .v-data-table__mobile-row .v-chip.v-chip--outlined {
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .v-data-table__mobile-row {
    min-height: 0px !important;
  }

  .v-data-table__mobile-row:first-child {
    border-top: 1px solid #3a3737 !important;
    padding-top: 10px !important;
    /* background-color: #ccc !important; */
  }

  .header-toolbar {
    /* width: 100%;
    /* position: fixed; */
    /* z-index: 100; */
    top: 0;
    left: -25px;
  }

  .bottom-toolbar {
    width: 100%;
    position: absolute;
    /* z-index: 100; */
    bottom: 0;
    right: 0;
  }

  .special-button {
    /* padding-left: 40px !important */
  }

  .v-data-table .v-tab {
    /* color: white !important; */
    margin: 5px !important;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    font-size: 10px;
    padding: 2px;
    height: 30px;
  }

  .v-tabs--grow {
    width: 100% !important;
  }

  .v-tab.active-tab {
    /* color: yellow !important; */
    /* font-weight: bold !important;*/

    /*text-decoration-color: blue !important; */
    font-size: 14px !important;

    /* box-shadow: 3px !important; */
  }

  .v-slide-group__prev,
  .v-slide-group__next {
    padding: 2px;
    margin: -5px;
  }

  .tablist {
    margin: 1px;
  }
}
</style>
